(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["app-einladung"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Thema aus der App-Route, wenn der Auslöser keins nennt. */
    const THEMA_ZUM_PFAD = {
      loyalty: 'mitgliedskarte',
      consents: 'benachrichtigungen',
      'foot-scan': 'fussscan',
      wishlist: 'listen',
      'account/data': 'daten',
      live: 'beitrag',
      stores: 'filialen',
    };
    const handy = window.matchMedia('(max-width: 48rem)');
    const SPEICHER = 'hervis:app-hinweis:v1';
    const SITZUNG = 'hervis:app-hinweis:sitzung';
    const TAG = 864e5;
    let ausloeser = null;
    /* Automatisches Blatt offen? Dann zählt jedes Schließen ohne Handlung
       als „nein". */
    let automatisch = false;
    let gehandelt = false;

    const dialog = () => {
      const d = document.getElementById('app-einladung');
      return d instanceof HTMLDialogElement ? d : null;
    };
    const erlaubt = (pfad) => typeof pfad === 'string' && (window.hervisApp ? window.hervisApp.erlaubt(pfad) : false);

    /* Zustand des App-Hinweises (mit der App-Leiste geteilt). null = kein
       Speicher — dann nie automatisch. */
    const lesen = () => {
      try {
        const z = JSON.parse(localStorage.getItem(SPEICHER) || '{}');
        return z && typeof z === 'object' ? z : {};
      } catch {
        return null;
      }
    };
    const aendern = (fn) => {
      const z = lesen();
      if (!z) return;
      fn(z);
      try {
        localStorage.setItem(SPEICHER, JSON.stringify(z));
      } catch {
        /* nichts zu tun */
      }
    };

    function oeffnen({ thema, pfad, titel, hinweis, knopf, auto = false } = {}) {
      const d = dialog();
      if (!d || d.open) return;
      const texte = d.querySelector('template[data-app-texte]')?.content;
      const finde = (k) => (k && texte ? texte.querySelector('[data-thema="' + CSS.escape(k) + '"]') : null);
      const ziel = erlaubt(pfad) ? pfad : '/';
      const route = ziel.slice(1).split('?')[0];
      const ausPfad = THEMA_ZUM_PFAD[route] || THEMA_ZUM_PFAD[route.split('/')[0]] || '';
      const eintrag = finde(thema) || finde(ausPfad);
      const standard = finde('standard');
      const eigenerTitel = typeof titel === 'string' ? titel.trim() : '';
      const eigenerText = typeof hinweis === 'string' ? hinweis.trim() : '';

      if (standard) {
        d.querySelector('[data-app-titel]').textContent = eintrag
          ? eintrag.dataset.titel
          : eigenerTitel || standard.dataset.titel;
        d.querySelector('[data-app-text]').textContent = eigenerText || (eintrag || standard).textContent.trim();
      }
      const primaer = d.querySelector('[data-app-primaer]');
      if (primaer) primaer.dataset.appPfad = ziel;
      const blick = d.querySelector('[data-app-blick]');
      if (blick) blick.hidden = !auto;
      automatisch = auto;
      gehandelt = false;

      const aktiv = document.activeElement;
      ausloeser = auto ? null : knopf || (aktiv && aktiv !== document.body ? aktiv : null);
      d.showModal();
      /* Handy: „Im Browser weiter" hat den Fokus — ein Schritt zurück zum
         Einkauf. Desktop: „App laden". */
      const fokus = handy.matches
        ? d.querySelector('[data-app-weiter]')
        : d.querySelector('.app-einladung__desktop [data-app-laden]');
      fokus?.focus();
    }

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const knopf = event.target.closest('[data-app-invite]');
      if (knopf && dialog()) {
        event.preventDefault();
        oeffnen({
          thema: knopf.dataset.appInvite,
          pfad: knopf.dataset.appPfad,
          titel: knopf.dataset.appTopic,
          hinweis: knopf.dataset.appHinweis,
          knopf,
        });
        return;
      }
      /* Wer die App öffnet oder lädt (Leiste, Blatt, App-Seite), kennt sie:
         30 Tage kein automatisches Blatt. */
      if (event.target.closest('[data-app-oeffnen], [data-app-laden]')) {
        aendern((z) => {
          z.offenAm = Date.now();
        });
      }
      /* Nach „In der App öffnen" / „App laden" schließt das Blatt — die
         Seite dahinter bleibt, wie sie war. */
      const d = dialog();
      if (d?.open && event.target.closest('#app-einladung [data-app-oeffnen], #app-einladung [data-app-laden]')) {
        gehandelt = true;
        d.close();
      }
    });

    document.addEventListener('hervis:app-einladung', (event) => {
      const d = event.detail || {};
      oeffnen({ thema: d.thema, pfad: d.pfad, titel: d.titel || d.topic, hinweis: d.hinweis });
    });

    document.addEventListener(
      'close',
      (event) => {
        if (event.target !== dialog()) return;
        if (automatisch) {
          automatisch = false;
          /* ×, Esc, Hintergrund, „Im Browser weiter" = nein danke. */
          if (!gehandelt) {
            aendern((z) => {
              z.blattZu = Date.now();
              z.nein = (Number(z.nein) || 0) + 1;
            });
          }
          document.getElementById('hauptinhalt')?.focus({ preventScroll: true });
          return;
        }
        const zurueck = ausloeser;
        ausloeser = null;
        if (zurueck?.isConnected) zurueck.focus({ preventScroll: true });
      },
      true,
    );

    /* Automatisches Blatt (Runde 4, R-09) — der ehrliche „Drang": nur am
       Handy, frühestens ab der 3. Seite und erst, wenn auf dieser Seite eine
       Bildschirmhöhe gescrollt wurde; höchstens einmal je Sitzung; nach
       „nein" 14 Tage Ruhe, nach zwei „nein" 90 Tage; nach Öffnen/Laden
       30 Tage. Nie auf Produkt, Warenkorb, Konto, Passwort, 404; nie über
       einem anderen Dialog, dem Cookie-Banner oder einem Feld mit Fokus.
       Ohne Speicher nie. */
    if (!handy.matches) return;
    const zustand = lesen();
    if (!zustand) return;
    zustand.seiten = (Number(zustand.seiten) || 0) + 1;
    try {
      localStorage.setItem(SPEICHER, JSON.stringify(zustand));
    } catch {
      return;
    }

    const vorlage = document.body.dataset.template || '';
    const ansicht = document.body.dataset.ansicht || '';
    const seiteErlaubt =
      (vorlage === 'index' && ['', 'welten', 'services'].includes(ansicht)) ||
      ['collection', 'list-collections', 'search', 'article', 'blog', 'page'].includes(vorlage);
    if (!seiteErlaubt) return;

    const jetzt = Date.now();
    const vor = (zeit) => jetzt - (Number(zeit) || 0);
    let sitzungGezeigt = true;
    try {
      sitzungGezeigt = Boolean(sessionStorage.getItem(SITZUNG));
    } catch {
      sitzungGezeigt = true;
    }
    const nein = Number(zustand.nein) || 0;
    const darf =
      zustand.seiten >= 3 &&
      !sitzungGezeigt &&
      vor(zustand.blattZu) > 14 * TAG &&
      vor(zustand.offenAm) > 30 * TAG &&
      (nein < 2 || vor(zustand.blattZu) > 90 * TAG);
    if (!darf) return;

    const bannerSichtbar = () =>
      [...document.querySelectorAll('[id^="shopify-pc__banner"]')].some((el) => el.offsetParent !== null);
    const feldFokus = () => document.activeElement?.matches?.('input, textarea, select, [contenteditable="true"]');

    let wartet = false;
    const pruefen = () => {
      wartet = false;
      if (window.scrollY < window.innerHeight) return;
      if (!handy.matches || document.querySelector('dialog[open]') || bannerSichtbar() || feldFokus()) return;
      window.removeEventListener('scroll', beimScrollen);
      try {
        sessionStorage.setItem(SITZUNG, String(Date.now()));
      } catch {
        return;
      }
      oeffnen({ thema: 'standard', pfad: dialog()?.dataset.seitenPfad, auto: true });
    };
    const beimScrollen = () => {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(pruefen);
    };
    window.addEventListener('scroll', beimScrollen, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["app-leiste"] && !Shopify.designMode) return;
  try {
    (() => {
    /* aside: <html> trägt dasselbe Attribut (data-app-leiste="aus") und käme
       als Wurzel zuerst. */
    const leiste = document.querySelector('aside[data-app-leiste]');
    if (!leiste) return;
    const SPEICHER = 'hervis:app-hinweis:v1';

    /* iPhone ohne bekannte App: „Laden" statt „Öffnen" — der Klick geht dann
       zum Store bzw. zur Download-Seite (assets/hervis.js § 4, data-app-laden). */
    const knopf = leiste.querySelector('.app-leiste__knopf');
    let appDa = false;
    try {
      appDa = Boolean(localStorage.getItem('hervis:app-da'));
    } catch {
      appDa = false;
    }
    if (knopf && window.hervisApp?.plattform === 'ios' && !appDa) {
      knopf.textContent = knopf.dataset.textLaden || knopf.textContent;
      if (knopf.dataset.labelLaden) knopf.setAttribute('aria-label', knopf.dataset.labelLaden);
      knopf.removeAttribute('data-app-oeffnen');
      knopf.setAttribute('data-app-laden', '');
      knopf.href = window.hervisApp.ladenUrl();
    }

    leiste.querySelector('[data-app-leiste-zu]')?.addEventListener('click', () => {
      try {
        const zustand = JSON.parse(localStorage.getItem(SPEICHER) || '{}') || {};
        zustand.leisteZu = Date.now();
        localStorage.setItem(SPEICHER, JSON.stringify(zustand));
      } catch {
        /* Ohne Speicher gilt das Schließen nur für diese Seite. */
      }
      document.documentElement.dataset.appLeiste = 'aus';
      document.getElementById('hauptinhalt')?.focus({ preventScroll: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["entdecken-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('entdecken-feed')) return;

    const TON_SPEICHER = 'hervis:entdecken-ton:v1';
    /* WCAG 2.2.2: Was im Band von selbst startet, läuft höchstens fünf Sekunden. */
    const VORSCHAU_GRENZE = 5000;
    /* So lange stehen Hinweise („Link kopiert") und „Hinzugefügt". */
    const HINWEIS_DAUER = 5000;
    const HINZUGEFUEGT_DAUER = 2000;
    /* Mausrad/Trackpad: eine Geste = ein Beitrag. Ab dieser Summe blättert es;
       danach wird der Nachlauf geschluckt — bis eine neue Geste beginnt: Rad
       ruht kurz, Richtung kehrt um, neue Raststufe, oder die Werte steigen
       wieder an (Nachlauf klingt nur ab). Ohne den Anstieg blieb ein
       Trackpad nach dem ersten Wischen hängen: der Nachlauf des macOS-
       Trackpads läuft über eine Sekunde, jedes neue Wischen verlängerte ihn
       (Fund #25). */
    const RAD_SCHWELLE = 40; /* px Summe bis zum Blättern */
    const RAD_RUHE = 220; /* ms ohne Rad = neue Geste */
    const RAD_SPERRE = 450; /* ms nach einem Schritt kein zweiter */
    const RAD_STUFE = 50; /* px: so groß ist eine Raststufe mindestens */
    const RAD_TAKT = 40; /* ms: schneller kommt nur Trackpad-Nachlauf */
    const RAD_ANSTIEG = 10; /* px: ab hier zählt ein Anstieg als neue Geste */
    /* Klang der Nachlauf ab (so viele Werte ohne Anstieg) und kam dann eine
       Lücke im Takt (Finger neu aufgesetzt, der Nachlauf hört dann auf),
       genügt ein kleiner Anstieg: ein sanftes zweites Wischen kommt nie über
       10 px und blieb sonst hängen (Fund #25). Ein langsam ziehender Finger
       klingt nicht ab — für ihn bleibt es bei RAD_ANSTIEG. */
    const RAD_ABKLANG = 5;
    const RAD_ANSTIEG_NEU = 3;
    /* So lange darf das weiche Scrollen von gehe() höchstens dauern. */
    const UNTERWEGS_HOECHSTENS = 1000;

    const tonGespeichert = () => {
      try {
        return localStorage.getItem(TON_SPEICHER) === '1';
      } catch {
        return false;
      }
    };
    const tonSpeichern = (an) => {
      try {
        localStorage.setItem(TON_SPEICHER, an ? '1' : '0');
      } catch {
        /* privates Fenster: der Ton gilt dann nur für diesen Besuch */
      }
    };
    const bewegungAus = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
      const staerke = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion'));
      return Number.isFinite(staerke) && staerke <= 0;
    };
    const vorschauErlaubt = () =>
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !bewegungAus() &&
      !navigator.connection?.saveData;
    const kannFliegen = () => typeof document.startViewTransition === 'function' && !bewegungAus();

    /* Download eines Videos abbrechen, das gerade nicht gebraucht wird: die
       <source>-Elemente abnehmen und neu laden — ohne Quelle ist es leer.
       Ein bloßes load() reicht nicht, der HLS-Spieler holt sonst die Liste
       neu. Gibt true zurück, wenn es etwas abzubrechen gab. */
    const quellenAbnehmen = (video) => {
      if (!video) return false;
      if (!video.paused) video.pause();
      if (video.dvQuellen) return false;
      if (video.readyState === 0 && video.networkState !== HTMLMediaElement.NETWORK_LOADING) return false;
      video.dvQuellen = [...video.querySelectorAll('source')];
      video.dvQuellen.forEach((quelle) => quelle.remove());
      video.load();
      return true;
    };
    const quellenZurueck = (video) => {
      if (!video?.dvQuellen) return;
      video.append(...video.dvQuellen);
      video.dvQuellen = null;
      video.load();
    };

    class EntdeckenFeed extends HTMLElement {
      connectedCallback() {
        if (this.bereit) return;
        this.dialog = this.querySelector('[data-dv-viewer]');
        this.spur = this.querySelector('[data-dv-reihe-spur]');
        if (!this.dialog || !this.spur) return;
        this.bereit = true;

        this.pager = this.dialog.querySelector('[data-dv-spur]');
        this.chrome = this.dialog.querySelector('[data-dv-chrome]');
        this.beitraege = [...this.pager.querySelectorAll('[data-dv-beitrag]')];
        this.karten = [...this.spur.querySelectorAll('.dv-karte')];
        this.pfeile = [...this.querySelectorAll('[data-dv-reihe]')];
        this.schritte = [...this.dialog.querySelectorAll('[data-dv-schritt]')];
        this.zaehler = this.dialog.querySelector('[data-dv-zaehler]');
        this.hinweisFeld = this.dialog.querySelector('[data-dv-hinweis]');
        this.lichter = [...this.querySelectorAll('[data-dv-licht]')];
        if (this.lichter.length === 1) {
          /* Zweite Ebene zum Überblenden. */
          const zweites = this.lichter[0].cloneNode();
          zweites.classList.remove('is-sichtbar');
          zweites.removeAttribute('src');
          this.lichter[0].after(zweites);
          this.lichter.push(zweites);
        }
        this.t = this.dialog.dataset;
        this.aktiv = -1;
        this.ton = tonGespeichert();

        this.abbruch = new AbortController();
        const mit = { signal: this.abbruch.signal };

        this.addEventListener('click', (e) => this.klick(e), mit);
        this.dialog.addEventListener('keydown', (e) => this.taste(e), mit);
        this.dialog.addEventListener(
          'cancel',
          (e) => {
            e.preventDefault();
            this.schliessen();
          },
          mit,
        );
        this.dialog.addEventListener('close', () => this.geschlossen(), mit);
        /* Fällt der Fokus ins Leere (Beitrag wurde inert, oder der Browser
           setzt ihn beim Laden zurück), holt ihn der aktive Beitrag. Ein
           Dialog darüber (App-Einladung) behält ihn. */
        this.dialog.addEventListener(
          'focusout',
          () =>
            requestAnimationFrame(() => {
              const weg = !document.activeElement || document.activeElement === document.body;
              if (this.dialog.open && weg) this.beitraege[this.aktiv]?.focus({ preventScroll: true });
            }),
          mit,
        );
        this.dialog.addEventListener('submit', (e) => this.kaufen(e), mit);
        this.dialog.addEventListener('wheel', (e) => this.rad(e), { ...mit, passive: false });
        ['play', 'playing', 'pause'].forEach((typ) =>
          this.dialog.addEventListener(typ, (e) => this.videoStand(e), { ...mit, capture: true }),
        );
        this.spur.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.pfeilBild);
            this.pfeilBild = requestAnimationFrame(() => this.pfeileSetzen());
          },
          { ...mit, passive: true },
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.allesAnhalten();
          },
          mit,
        );

        this.groesse = new ResizeObserver(() => this.pfeileSetzen());
        this.groesse.observe(this.spur);

        this.beobachter = new IntersectionObserver((eintraege) => this.gesehen(eintraege), {
          root: this.pager,
          threshold: 0.6,
        });
        this.beitraege.forEach((b) => this.beobachter.observe(b));

        this.vorschauEinrichten(mit);
        this.tonAbgleichen();
        this.pfeileSetzen();
        this.direktlink();
      }

      disconnectedCallback() {
        this.abbruch?.abort();
        this.beobachter?.disconnect();
        this.bandBeobachter?.disconnect();
        this.groesse?.disconnect();
        cancelAnimationFrame(this.bild);
        cancelAnimationFrame(this.pfeilBild);
        clearTimeout(this.vorschauZeit);
        clearTimeout(this.hinweisZeit);
        clearTimeout(this.unterwegsZeit);
        this.bereit = false;
      }

      /* ---- Klicks: Karten, Band, Viewer ---------------------------------- */
      klick(e) {
        const ziel = e.target.closest(
          '[data-dv-oeffnen], [data-dv-reihe], [data-dv-schritt], [data-dv-ton], [data-dv-pause], [data-dv-flaeche], [data-dv-teilen], [data-dv-schliessen]',
        );
        if (!ziel || !this.contains(ziel)) return;
        if (ziel.getAttribute('aria-disabled') === 'true') return;
        const d = ziel.dataset;
        if (d.dvOeffnen !== undefined) this.oeffnen(d.dvOeffnen, ziel);
        else if (d.dvReihe !== undefined) this.blaettern(Number(d.dvReihe));
        else if (d.dvSchritt !== undefined) this.gehe(this.aktiv + Number(d.dvSchritt));
        else if (d.dvTon !== undefined) this.tonUmschalten();
        else if (d.dvPause !== undefined || d.dvFlaeche !== undefined) this.pauseUmschalten();
        else if (d.dvTeilen !== undefined) this.teilen();
        else if (d.dvSchliessen !== undefined) this.schliessen();
      }

      /* ---- Öffnen und Schließen (mit Flug der Karte in den Rahmen) -------- */
      oeffnen(handle, ausloeser, { animiert = true, stumm = false } = {}) {
        const i = this.beitraege.findIndex((b) => b.dataset.handle === handle);
        if (i < 0 || this.dialog.open) return;
        this.ausloeser = ausloeser || null;
        this.hashVorher = location.hash;
        if (stumm) this.ton = false;
        this.vorschauAlleStoppen();
        /* Im Viewer lädt nur das aktive Video — die Vorschauen hören auf. */
        this.karten.forEach((karte) => quellenAbnehmen(karte.querySelector('video')));

        const ziel = this.beitraege[i];
        const medium = this.karten[i]?.querySelector('.dv-karte__medium');
        const rahmen = ziel.querySelector('.dv-rahmen');
        const zeigen = () => {
          this.dialog.showModal();
          this.tonAbgleichen();
          this.pager.scrollTo({ top: ziel.offsetTop, behavior: 'instant' });
          this.aktivieren(i, { fokus: true });
        };
        if (animiert && medium && rahmen && kannFliegen() && this.imBild(medium)) {
          this.dialog.setAttribute('data-landung', '');
          this.flug(medium, rahmen, zeigen);
        } else {
          this.dialog.removeAttribute('data-landung');
          zeigen();
        }
      }

      schliessen() {
        if (!this.dialog.open) return;
        const karte = this.karten[this.aktiv];
        const medium = karte?.querySelector('.dv-karte__medium');
        const rahmen = this.beitraege[this.aktiv]?.querySelector('.dv-rahmen');
        this.zielKarte = karte?.querySelector('.dv-karte__knopf') || null;
        const zu = () => {
          this.dialog.close();
          if (karte) this.karteZeigen(karte);
        };
        if (medium && rahmen && kannFliegen()) this.flug(rahmen, medium, zu);
        else zu();
      }

      /* Gleiche Seite, ein Element fliegt: Karte ↔ Rahmen (View Transition). */
      flug(von, nach, aenderung) {
        const wurzel = document.documentElement;
        const aufraeumen = () => {
          von.style.viewTransitionName = '';
          nach.style.viewTransitionName = '';
          delete wurzel.dataset.dvFlug;
        };
        wurzel.dataset.dvFlug = '';
        von.style.viewTransitionName = 'dv-medium';
        let uebergang;
        try {
          uebergang = document.startViewTransition(() => {
            von.style.viewTransitionName = '';
            aenderung();
            nach.style.viewTransitionName = 'dv-medium';
          });
        } catch {
          aufraeumen();
          aenderung();
          return;
        }
        uebergang.ready.catch(() => {});
        uebergang.finished.catch(() => {}).finally(aufraeumen);
      }

      /* Ein Beitrag verlässt die Bühne: Video anhalten und den Download
         abbrechen. Ein bloßes load() reicht nicht — der HLS-Spieler holt
         dann die Liste neu. Also die <source>-Elemente kurz abnehmen: ohne
         Quelle ist das Video leer (NETWORK_EMPTY), darunter liegt das
         Standbild. Beim nächsten Abspielen kommen sie zurück (laden). */
      entladen(beitrag) {
        if (quellenAbnehmen(beitrag.querySelector('video'))) beitrag.removeAttribute('data-geladen');
      }

      geschlossen() {
        cancelAnimationFrame(this.bild);
        clearTimeout(this.unterwegsZeit);
        this.unterwegs = false;
        this.beitraege.forEach((b) => {
          this.entladen(b);
          b.inert = true;
          b.removeAttribute('data-aktiv');
          b.removeAttribute('data-pausiert');
        });
        this.adresse(null);
        const ziel = this.zielKarte || this.karten[this.aktiv]?.querySelector('.dv-karte__knopf') || this.ausloeser;
        this.zielKarte = null;
        this.aktiv = -1;
        this.ton = tonGespeichert();
        if (ziel?.isConnected) ziel.focus({ preventScroll: true });
      }

      /* ---- Der aktive Beitrag ------------------------------------------- */
      gesehen(eintraege) {
        if (!this.dialog.open) return;
        const treffer = eintraege
          .filter((e) => e.isIntersecting && e.intersectionRatio >= 0.6)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!treffer) return;
        const i = this.beitraege.indexOf(treffer.target);
        /* Unterwegs zum Ziel von gehe(): Beiträge, an denen das weiche
           Scrollen vorbeizieht, werden nicht aktiv. Sonst zählte der nächste
           Pfeil/Knopf von dort aus, und ein Schritt ging verloren (Fund #25). */
        if (this.unterwegs) {
          if (i === this.aktiv) this.unterwegs = false;
          return;
        }
        if (i >= 0 && i !== this.aktiv) this.aktivieren(i);
      }

      /* Nach dem Scrollen von gehe(): stand das Ziel nie im Bild (Scrollen
         abgebrochen), wird der Beitrag aktiv, der tatsächlich zu sehen ist. */
      angekommen() {
        clearTimeout(this.unterwegsZeit);
        if (!this.unterwegs) return;
        this.unterwegs = false;
        if (!this.dialog.open) return;
        const oben = this.pager.scrollTop;
        let naechster = this.aktiv;
        this.beitraege.forEach((b, j) => {
          if (Math.abs(b.offsetTop - oben) < Math.abs(this.beitraege[naechster].offsetTop - oben)) naechster = j;
        });
        if (naechster !== this.aktiv) this.aktivieren(naechster);
      }

      aktivieren(i, { fokus = false } = {}) {
        const neu = this.beitraege[i];
        if (!neu) return;
        /* Die verzögerte Landung gilt nur für den Beitrag, in den die Karte flog. */
        if (this.aktiv >= 0 && i !== this.aktiv) this.dialog.removeAttribute('data-landung');
        this.aktiv = i;
        this.beitraege.forEach((b, j) => {
          const an = j === i;
          b.toggleAttribute('data-aktiv', an);
          b.inert = !an;
          if (an) return;
          b.removeAttribute('data-pausiert');
          b.querySelector('.dv-segmente [data-stand="aktiv"]')?.style.removeProperty('--dv-fortschritt');
          this.entladen(b);
        });
        /* Nachbarn vorladen: nur die Standbilder, nie die Videos. */
        [i - 1, i + 1].forEach((j) =>
          this.beitraege[j]?.querySelectorAll('img[loading="lazy"]').forEach((bild) => {
            bild.loading = 'eager';
          }),
        );
        /* Wandert der Fokus in den Beitrag, sagt dessen Name die Position
           schon an („3 von 12: …") — der Zähler schweigt dann. Bleibt der
           Fokus auf Vor/Zurück, meldet der Zähler die neue Position. */
        const fokusWandert = fokus || !this.chrome.contains(document.activeElement);
        this.zaehlerSetzen(!fokusWandert);
        this.adresse(neu.dataset.handle);
        if (fokusWandert) neu.focus({ preventScroll: true });
        this.abspielen();
      }

      gehe(i) {
        if (!this.dialog.open) return;
        const j = Math.max(0, Math.min(i, this.beitraege.length - 1));
        if (j === this.aktiv) return;
        const ziel = this.beitraege[j];
        const sprung = Math.abs(j - this.aktiv) > 1 || bewegungAus();
        this.unterwegs = true;
        clearTimeout(this.unterwegsZeit);
        this.unterwegsZeit = setTimeout(() => this.angekommen(), UNTERWEGS_HOECHSTENS);
        this.pager.scrollTo({ top: ziel.offsetTop, behavior: sprung ? 'instant' : 'smooth' });
        this.aktivieren(j);
      }

      zaehlerSetzen(ansagen = false) {
        if (this.zaehler) {
          this.zaehler.setAttribute('aria-live', ansagen ? 'polite' : 'off');
          this.zaehler.textContent = this.zaehler.dataset.vorlage.replace('%i', String(this.aktiv + 1));
        }
        this.schritte.forEach((knopf) => {
          const zurueck = Number(knopf.dataset.dvSchritt) < 0;
          const amEnde = zurueck ? this.aktiv <= 0 : this.aktiv >= this.beitraege.length - 1;
          knopf.setAttribute('aria-disabled', String(amEnde));
        });
      }

      /* ?reel=<handle> in der Adresse: teilbar, ohne neuen Verlaufseintrag. */
      adresse(handle) {
        try {
          const url = new URL(location.href);
          if (handle) {
            url.searchParams.set('reel', handle);
            url.hash = 'entdecken';
          } else {
            url.searchParams.delete('reel');
            url.hash = this.hashVorher || '';
          }
          history.replaceState(history.state, '', url);
        } catch {
          /* replaceState kann in eingebetteten Vorschauen fehlen */
        }
      }

      direktlink() {
        let handle = null;
        try {
          handle = new URLSearchParams(location.search).get('reel');
        } catch {
          return;
        }
        if (!handle) return;
        if (this.beitraege.some((b) => b.dataset.handle === handle)) {
          this.oeffnen(handle, null, { animiert: false, stumm: true });
          return;
        }
        if (document.querySelector('entdecken-feed') !== this) return;
        if (document.querySelector(`[data-dv-beitrag][data-handle="${CSS.escape(handle)}"]`)) return;
        this.hashVorher = '#entdecken';
        this.adresse(null);
        const hinweis = this.querySelector('[data-dv-band-hinweis]');
        if (hinweis) hinweis.textContent = this.t.tNichtVerfuegbar;
        this.closest('section')?.scrollIntoView({ block: 'start' });
      }

      /* ---- Video: abspielen, Ton, Pause, Fortschritt --------------------- */
      video() {
        return this.beitraege[this.aktiv]?.querySelector('video') || null;
      }

      abspielen() {
        cancelAnimationFrame(this.bild);
        const beitrag = this.beitraege[this.aktiv];
        const video = this.video();
        if (!beitrag || !video) return;
        video.muted = !this.ton;
        /* Reduzierte Bewegung: nichts startet von selbst — Standbild mit Play-Kreis. */
        if (bewegungAus()) {
          beitrag.setAttribute('data-pausiert', '');
          this.pauseAbgleichen(beitrag);
          return;
        }
        this.starten(video);
      }

      starten(video) {
        quellenZurueck(video);
        const versuch = video.play();
        if (!versuch) return;
        versuch.catch((fehler) => {
          if (fehler?.name === 'NotAllowedError' && !video.muted) {
            /* Ton ohne Nutzergeste verweigert: stumm weiter. */
            this.ton = false;
            this.tonAbgleichen();
            video.muted = true;
            video.play().catch(() => {});
          }
        });
      }

      videoStand(e) {
        const video = e.target;
        if (!(video instanceof HTMLVideoElement)) return;
        const beitrag = video.closest('[data-dv-beitrag]');
        if (!beitrag) return;
        if (e.type === 'playing') beitrag.setAttribute('data-geladen', '');
        if (e.type === 'pause') {
          if (beitrag.hasAttribute('data-aktiv') && this.dialog.open) beitrag.setAttribute('data-pausiert', '');
        } else {
          beitrag.removeAttribute('data-pausiert');
          if (beitrag.hasAttribute('data-aktiv')) this.fortschritt(video, beitrag);
        }
        this.pauseAbgleichen(beitrag);
      }

      fortschritt(video, beitrag) {
        cancelAnimationFrame(this.bild);
        const segment = beitrag.querySelector('.dv-segmente [data-stand="aktiv"]');
        if (!segment) return;
        const schritt = () => {
          if (video.duration) segment.style.setProperty('--dv-fortschritt', String(video.currentTime / video.duration));
          if (!video.paused && this.dialog.open) this.bild = requestAnimationFrame(schritt);
        };
        schritt();
      }

      pauseUmschalten() {
        const video = this.video();
        if (!video) return;
        if (video.paused) {
          video.muted = !this.ton;
          this.starten(video);
        } else {
          video.pause();
        }
      }

      pauseAbgleichen(beitrag) {
        const pausiert = beitrag.hasAttribute('data-pausiert');
        const text = beitrag.querySelector('[data-dv-pause] [data-dv-text]');
        if (text) text.textContent = pausiert ? this.t.tAbspielen : this.t.tPause;
        const flaeche = beitrag.querySelector('[data-dv-flaeche]');
        flaeche?.setAttribute('aria-label', pausiert ? this.t.tPlay : this.t.tPausieren);
      }

      tonUmschalten() {
        this.ton = !this.ton;
        tonSpeichern(this.ton);
        this.tonAbgleichen();
        const video = this.video();
        if (video) video.muted = !this.ton;
      }

      tonAbgleichen() {
        this.dialog.toggleAttribute('data-ton', this.ton);
        this.dialog.querySelectorAll('[data-dv-ton]').forEach((knopf) => {
          knopf.setAttribute('aria-pressed', String(this.ton));
        });
      }

      allesAnhalten() {
        this.vorschauAlleStoppen();
        const video = this.video();
        if (video && !video.paused) video.pause();
      }

      /* ---- Tastatur im Viewer -------------------------------------------- */
      taste(e) {
        if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
        const ziel = e.target instanceof Element ? e.target : null;
        if (ziel?.closest('input, select, textarea, [contenteditable="true"]')) return;
        switch (e.key) {
          case 'ArrowDown':
          case 'ArrowRight':
          case 'PageDown':
          case 'j':
          case 'J':
            this.gehe(this.aktiv + 1);
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
          case 'PageUp':
          case 'k':
          case 'K':
            this.gehe(this.aktiv - 1);
            break;
          case 'Home':
            this.gehe(0);
            break;
          case 'End':
            this.gehe(this.beitraege.length - 1);
            break;
          case ' ':
            if (ziel?.closest('button, a, summary')) return;
            this.pauseUmschalten();
            break;
          case 'm':
          case 'M':
            this.tonUmschalten();
            break;
          default:
            return;
        }
        e.preventDefault();
      }

      /* Mausrad: das Einrasten allein springt bei kleinen Schritten zurück.
         Waagrecht (Produkt-Dock) und Zoomen (Strg) bleiben beim Browser, eine
         Produktliste, die selbst noch scrollen kann, auch. */
      rad(e) {
        if (e.ctrlKey || !this.dialog.open) return;
        const dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? innerHeight : 1);
        if (Math.abs(e.deltaX) > Math.abs(dy)) return;
        const liste = e.target instanceof Element ? e.target.closest('.dv-produkte') : null;
        if (liste && liste.scrollHeight > liste.clientHeight + 1) {
          const kann = dy > 0 ? liste.scrollTop + liste.clientHeight < liste.scrollHeight - 1 : liste.scrollTop > 0;
          if (kann) return;
        }
        e.preventDefault();
        const betrag = Math.abs(dy);
        if (!betrag) return;
        const jetzt = performance.now();
        const luecke = jetzt - (this.radZuletzt || 0);
        this.radZuletzt = jetzt;
        const r = (this.radStand ||= {});
        /* Anstieg = drei Werte hintereinander größer, am Ende mindestens
           doppelt so groß wie am Anfang, und angefangen in einem Tal (höchstens
           halb so groß wie die Spitze seit dem letzten Schritt). So zählt
           weder ein einzelner Ausreißer (zusammengefasste Ereignisse) noch
           ein Finger, der nach dem Schritt einfach weiter beschleunigt.
           Gleiche Werte (ganzzahlige Deltas eines langsamen Fingers)
           unterbrechen den Anstieg nicht. Beginnt er nach abgeklungenem
           Nachlauf kurz nach einer Lücke im Takt, genügt RAD_ANSTIEG_NEU. */
        if (luecke > RAD_TAKT) r.pause = jetzt;
        if (betrag > (r.vorher || 0)) {
          if (!r.anstiege) {
            r.von = r.vorher || 0;
            r.tal = r.von <= (r.spitze || 0) / 2;
            r.aufgesetzt = r.abklang >= RAD_ABKLANG && jetzt - r.pause < RAD_RUHE;
          }
          r.anstiege = (r.anstiege || 0) + 1;
          r.abklang = 0;
        } else {
          if (betrag < r.vorher) r.anstiege = 0;
          r.abklang = (r.abklang || 0) + 1;
        }
        r.vorher = betrag;
        r.spitze = Math.max(r.spitze || 0, betrag);
        if (luecke > RAD_RUHE) {
          r.nachlauf = false;
          r.summe = 0;
        }
        if (r.nachlauf) {
          const gesperrt = jetzt - r.schritt < RAD_SPERRE;
          /* Raststufe eines Mausrads: großer Schritt mit Pause davor — der
             Nachlauf eines Trackpads kommt dagegen im Bildtakt. Erst nach
             der Sperrzeit: gleich nach dem Schritt sieht ein Ruckler (ein
             zusammengefasster großer Wert) genauso aus. */
          if (!gesperrt && betrag >= RAD_STUFE && luecke > RAD_TAKT) r.neu = Math.sign(dy);
          /* Umkehr und Anstieg gelten auch, wenn sie in der Sperrzeit
             beginnen — dann gleich danach, in ihrer Richtung; der Rest des
             alten Nachlaufs bleibt geschluckt. */
          if (Math.sign(dy) !== r.richtung) r.neu = Math.sign(dy);
          const anstieg = r.aufgesetzt ? RAD_ANSTIEG_NEU : RAD_ANSTIEG;
          if (r.anstiege >= 2 && r.tal && betrag >= Math.max(anstieg, 2 * r.von)) r.neu = Math.sign(dy);
          if (gesperrt || Math.sign(dy) !== r.neu) return;
          r.nachlauf = false;
          r.summe = 0;
        }
        if (Math.sign(dy) !== Math.sign(r.summe || dy)) r.summe = 0;
        r.summe = (r.summe || 0) + dy;
        if (Math.abs(r.summe) < RAD_SCHWELLE) return;
        r.richtung = Math.sign(r.summe);
        this.gehe(this.aktiv + r.richtung);
        Object.assign(r, { summe: 0, schritt: jetzt, nachlauf: true, neu: 0, anstiege: 0, spitze: betrag });
      }

      /* ---- Teilen, Hinweise, Schnellkauf --------------------------------- */
      async teilen() {
        const beitrag = this.beitraege[this.aktiv];
        if (!beitrag) return;
        const url = new URL(location.pathname, location.origin);
        url.searchParams.set('reel', beitrag.dataset.handle);
        url.hash = 'entdecken';
        const daten = { title: beitrag.dataset.titel, url: url.href };
        if (navigator.share && (!navigator.canShare || navigator.canShare(daten))) {
          try {
            await navigator.share(daten);
            return;
          } catch (fehler) {
            if (fehler?.name === 'AbortError') return;
          }
        }
        try {
          await navigator.clipboard.writeText(url.href);
          this.hinweis(this.t.tKopiert);
        } catch {
          this.hinweis(url.href);
        }
      }

      hinweis(text, link) {
        const feld = this.hinweisFeld;
        if (!feld) return;
        clearTimeout(this.hinweisZeit);
        feld.replaceChildren(document.createTextNode(text));
        if (link) {
          const a = document.createElement('a');
          a.href = link.href;
          a.textContent = link.text;
          feld.append(' · ', a);
        }
        feld.setAttribute('data-sichtbar', '');
        const weg = () => {
          if (feld.matches(':hover, :focus-within')) {
            this.hinweisZeit = setTimeout(weg, HINWEIS_DAUER);
            return;
          }
          feld.removeAttribute('data-sichtbar');
          this.hinweisZeit = setTimeout(() => feld.replaceChildren(), HINWEIS_DAUER);
        };
        this.hinweisZeit = setTimeout(weg, HINWEIS_DAUER);
      }

      async kaufen(e) {
        const formular = e.target.closest('[data-dv-kaufen]');
        if (!formular) return;
        e.preventDefault();
        const knopf = formular.querySelector('[type="submit"]');
        if (knopf?.getAttribute('aria-busy') === 'true') return;
        const text = knopf?.querySelector('[data-dv-kaufen-text]');
        knopf?.setAttribute('aria-busy', 'true');
        try {
          const antwort = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(formular),
          });
          if (!antwort.ok) throw new Error(String(antwort.status));
          /* Ohne item_count: /cart/add.js nennt nur den neuen Artikel, nicht
             die Summe — hervis.js fragt dann selbst /cart.js (ein Abruf). */
          document.dispatchEvent(new CustomEvent('hervis:warenkorb'));
          if (knopf && text) {
            knopf.setAttribute('data-hinzugefuegt', '');
            text.textContent = this.t.tHinzugefuegt;
            clearTimeout(knopf.dvZeit);
            knopf.dvZeit = setTimeout(() => {
              knopf.removeAttribute('data-hinzugefuegt');
              text.textContent = this.t.tWarenkorb;
            }, HINZUGEFUEGT_DAUER);
          }
          this.hinweis(this.t.tImWarenkorb, { href: this.t.warenkorbUrl, text: this.t.tAnsehen });
        } catch {
          this.hinweis(this.t.tFehler);
        } finally {
          knopf?.removeAttribute('aria-busy');
        }
      }

      /* ---- Band: Pfeile, Vorschau, Raumlicht ----------------------------- */
      blaettern(richtung) {
        const karte = this.karten[0];
        if (!karte) return;
        const luecke = parseFloat(getComputedStyle(this.spur).columnGap) || 0;
        this.spur.scrollBy({
          left: richtung * 2 * (karte.offsetWidth + luecke),
          behavior: bewegungAus() ? 'instant' : 'smooth',
        });
      }

      /* Nach dem Schließen die Karte des zuletzt gesehenen Beitrags zeigen.
         Bewusst ohne scrollIntoView: das verschiebt jeden Vorfahren, der sich
         scrollen lässt. Hier bewegt sich nur die Reihe (halb verdeckte Karte
         an ihren Anfang, sie rastet nur an Kartenanfängen ein) und — falls die
         Karte über oder unter dem Bild liegt — die Seite. */
      karteZeigen(karte) {
        const spur = this.spur;
        const s = spur.getBoundingClientRect();
        const r = karte.getBoundingClientRect();
        if (r.left < s.left || r.right > s.right) {
          const rand = parseFloat(getComputedStyle(spur).scrollPaddingInlineStart) || 0;
          const ende = spur.scrollWidth - spur.clientWidth;
          const links = spur.scrollLeft + r.left - s.left - rand;
          spur.scrollTo({ left: Math.max(0, Math.min(links, ende)), behavior: 'instant' });
        }
        const k = karte.getBoundingClientRect();
        const oben = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        let weg = 0;
        if (k.top < oben) weg = k.top - oben;
        else if (k.bottom > innerHeight) weg = Math.min(k.bottom - innerHeight, k.top - oben);
        if (weg) window.scrollBy({ top: weg, behavior: 'instant' });
      }

      pfeileSetzen() {
        const { scrollLeft, scrollWidth, clientWidth } = this.spur;
        const ende = scrollWidth - clientWidth;
        this.toggleAttribute('data-ueberlauf', ende > 1);
        this.pfeile.forEach((knopf) => {
          const zurueck = Number(knopf.dataset.dvReihe) < 0;
          knopf.setAttribute('aria-disabled', String(zurueck ? scrollLeft <= 1 : scrollLeft >= ende - 1));
        });
      }

      imBild(element) {
        const r = element.getBoundingClientRect();
        return r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
      }

      vorschauEinrichten(mit) {
        this.karten.forEach((karte) => {
          const knopf = karte.querySelector('.dv-karte__knopf');
          /* Eine andere Karte ist jetzt dran: deren Vorschau hört auf — auch
             wenn diese Karte selbst kein Video hat (Look mit Bild). */
          const dran = () => {
            this.licht(karte);
            if (this.vorschauKarte && this.vorschauKarte !== karte) this.vorschauStoppen(this.vorschauKarte);
          };
          karte.addEventListener('pointerenter', dran, mit);
          knopf?.addEventListener('focus', dran, mit);
          const video = karte.querySelector('video');
          if (!video) return;
          video.addEventListener('playing', () => karte.setAttribute('data-spielt', ''), mit);
          video.addEventListener('pause', () => karte.removeAttribute('data-spielt'), mit);
          karte.addEventListener(
            'pointerenter',
            (e) => {
              if (e.pointerType === 'mouse' && vorschauErlaubt()) this.vorschau(karte);
            },
            mit,
          );
          karte.addEventListener('pointerleave', () => this.vorschauStoppen(karte), mit);
          knopf?.addEventListener(
            'focus',
            () => {
              if (knopf.matches(':focus-visible') && vorschauErlaubt()) this.vorschau(karte);
            },
            mit,
          );
          knopf?.addEventListener('blur', () => this.vorschauStoppen(karte), mit);
        });

        /* Im Bild (≥ 60 %): die erste ganz sichtbare Karte spielt einmal kurz an. */
        this.bandBeobachter = new IntersectionObserver(
          ([eintrag]) => {
            const sichtbar = eintrag.isIntersecting && eintrag.intersectionRatio >= 0.6;
            if (!sichtbar) {
              this.automatikGelaufen = false;
              this.vorschauAlleStoppen();
            } else if (!this.vorschauKarte) {
              this.vorschauImBild();
            }
          },
          { threshold: [0, 0.6] },
        );
        this.bandBeobachter.observe(this.spur);
      }

      vorschauImBild() {
        if (this.automatikGelaufen || this.dialog.open || !vorschauErlaubt()) return;
        const rand = this.spur.getBoundingClientRect();
        const karte = this.karten.find((k) => {
          const r = k.getBoundingClientRect();
          return r.left >= rand.left - 1 && r.right <= rand.right + 1 && k.querySelector('video');
        });
        if (!karte) return;
        this.automatikGelaufen = true;
        this.licht(karte);
        this.vorschau(karte, { begrenzt: true });
      }

      vorschau(karte, { begrenzt = false } = {}) {
        if (this.dialog.open) return;
        const video = karte.querySelector('video');
        if (!video) return;
        if (this.vorschauKarte && this.vorschauKarte !== karte) this.vorschauStoppen(this.vorschauKarte);
        this.vorschauKarte = karte;
        clearTimeout(this.vorschauZeit);
        if (begrenzt) this.vorschauZeit = setTimeout(() => this.vorschauStoppen(karte), VORSCHAU_GRENZE);
        quellenZurueck(video);
        video.play().catch(() => {});
      }

      vorschauStoppen(karte) {
        const video = karte.querySelector('video');
        if (video && !video.paused) video.pause();
        if (this.vorschauKarte === karte) {
          this.vorschauKarte = null;
          clearTimeout(this.vorschauZeit);
        }
      }

      vorschauAlleStoppen() {
        this.karten.forEach((karte) => this.vorschauStoppen(karte));
      }

      licht(karte) {
        if (this.lichter.length < 2 || bewegungAus()) return;
        const quelle = karte.querySelector('.dv-karte__poster');
        const url = quelle?.currentSrc || quelle?.src;
        if (!url || url === this.lichtUrl) return;
        this.lichtUrl = url;
        const [a, b] = this.lichter;
        const neu = a.classList.contains('is-sichtbar') ? b : a;
        const alt = neu === a ? b : a;
        neu.onload = () => {
          neu.classList.add('is-sichtbar');
          alt.classList.remove('is-sichtbar');
        };
        neu.src = url;
      }
    }

    customElements.define('entdecken-feed', EntdeckenFeed);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["erscheinungswahl"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('[data-erscheinungswahl]')) return;

    const SCHLUESSEL = 'hervis-farbschema';
    const MODI = ['auto', 'hell', 'dunkel'];
    const wurzel = document.documentElement;
    const system = window.matchMedia('(prefers-color-scheme: light)');

    const gespeichert = () => {
      try {
        const wahl = localStorage.getItem(SCHLUESSEL);
        return MODI.includes(wahl) ? wahl : null;
      } catch {
        return null;
      }
    };

    function anwenden() {
      const wahl = gespeichert();
      if (wahl === 'auto') wurzel.dataset.schema = system.matches ? 'hell' : 'dunkel';
      else if (wahl) wurzel.dataset.schema = wahl;

      // Ohne gespeicherte Wahl gilt, was der Server gesetzt hat (Theme-Einstellung).
      const aktiv = wahl || wurzel.dataset.schema;
      document.querySelectorAll('[data-darstellung]').forEach((knopf) => {
        const an = knopf.dataset.darstellung === aktiv;
        // Segment: Knöpfe mit aria-pressed; Liste: Radios (variante 'liste').
        if (knopf instanceof HTMLInputElement) knopf.checked = an;
        else knopf.setAttribute('aria-pressed', String(an));
      });

      const grund = getComputedStyle(wurzel).getPropertyValue('--paper').trim();
      if (grund) document.querySelector('meta[name="theme-color"]')?.setAttribute('content', grund);
    }

    function waehlen(modus) {
      if (!MODI.includes(modus)) return;
      try {
        localStorage.setItem(SCHLUESSEL, modus);
      } catch {}
      if (modus !== 'auto') wurzel.dataset.schema = modus;
      anwenden();
    }

    document.addEventListener('click', (event) => {
      const knopf = event.target.closest('button[data-darstellung]');
      if (knopf) waehlen(knopf.dataset.darstellung);
    });
    // Radios der Liste (Klick, Leertaste, Pfeiltasten) melden sich per change.
    document.addEventListener('change', (event) => {
      const radio = event.target;
      if (radio instanceof HTMLInputElement && radio.matches('[data-darstellung]') && radio.checked) {
        waehlen(radio.dataset.darstellung);
      }
    });

    // Anderer Tab hat gewählt, oder das System wechselt (nur bei „Automatisch").
    window.addEventListener('storage', (event) => {
      if (event.key === SCHLUESSEL) anwenden();
    });
    system.addEventListener('change', () => {
      if (gespeichert() === 'auto') anwenden();
    });
    document.addEventListener('shopify:section:load', anwenden);
    anwenden();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filialbestand"] && !Shopify.designMode) return;
  try {
    (() => {
    const wurzeln = document.querySelectorAll('[data-filialbestand]');
    if (!wurzeln.length) return;

    const SPEICHER = 'hervis:my-store:v1';
    const RANG = { high: 3, medium: 2, low: 1 };
    const fuelle = (text, werte) => String(text).replace(/%(\w+)%/g, (_, k) => werte[k] ?? '');
    const falte = (s) =>
      String(s ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/strasse/g, 'str')
        .replace(/[^a-z0-9]/g, '');
    const leseMein = () => {
      try {
        return localStorage.getItem(SPEICHER);
      } catch {
        return null;
      }
    };
    const el = (tag, klasse, text) => {
      const e = document.createElement(tag);
      if (klasse) e.className = klasse;
      if (text != null) e.textContent = text;
      return e;
    };

    // Eine Antwort je Produkt, geteilt; ein Fehler wird nicht behalten.
    const antworten = new Map();
    const bestand = (handle) => {
      if (!antworten.has(handle)) {
        antworten.set(
          handle,
          fetch(`/apps/erplink/stock?product=${encodeURIComponent(handle)}`, {
            headers: { Accept: 'application/json' },
          })
            .then((antwort) => (antwort.ok ? antwort.json() : Promise.reject(new Error(antwort.status))))
            .catch((fehler) => {
              antworten.delete(handle);
              throw fehler;
            }),
        );
      }
      return antworten.get(handle);
    };
    let filialenLaden;
    const ladeFilialen = (url) =>
      (filialenLaden ??= fetch(url)
        .then((antwort) => (antwort.ok ? antwort.json() : []))
        .catch(() => []));

    /* --- Öffnung in Wiener Zeit, Entfernung (wie sections/filialfinder) --- */
    function wienJetzt() {
      const teile = {};
      const format = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Vienna',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      });
      for (const teil of format.formatToParts(new Date())) teile[teil.type] = teil.value;
      const tag = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(teile.weekday);
      return { tag, min: (Number(teile.hour) % 24) * 60 + Number(teile.minute) };
    }
    const zuMin = (zeit) => Number(zeit.slice(0, 2)) * 60 + Number(zeit.slice(3, 5));
    const fuerTag = (f, tag) =>
      f.openingHours.filter((iv) => iv.days.includes(tag)).sort((a, b) => zuMin(a.open) - zuMin(b.open));
    function oeffnung(f, T) {
      if (!f?.openingHours?.length) return null;
      const { tag, min } = wienJetzt();
      const heute = fuerTag(f, tag);
      const offen = heute.find((iv) => min >= zuMin(iv.open) && min < zuMin(iv.close));
      if (offen) return { offen: true, text: fuelle(T.bis, { zeit: offen.close }) };
      const spaeter = heute.find((iv) => min < zuMin(iv.open));
      if (spaeter) return { offen: false, text: fuelle(T.oeffnet_um, { zeit: spaeter.open }) };
      for (let vor = 1; vor <= 7; vor++) {
        const d = (tag + vor) % 7;
        const erstes = fuerTag(f, d)[0];
        if (erstes) {
          return {
            offen: false,
            text:
              vor === 1
                ? fuelle(T.oeffnet_morgen, { zeit: erstes.open })
                : fuelle(T.oeffnet_tag, { tag: T.tage[d], zeit: erstes.open }),
          };
        }
      }
      return null;
    }
    function entfernungKm(a, b) {
      const rad = Math.PI / 180;
      const dLat = (b.lat - a.lat) * rad;
      const dLng = (b.lng - a.lng) * rad;
      const s = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2;
      return 2 * 6371 * Math.asin(Math.sqrt(s));
    }
    function entfernung(km, T) {
      if (km < 1) return fuelle(T.meter, { wert: Math.max(50, Math.round((km * 1000) / 50) * 50) });
      return fuelle(T.kilometer, { wert: km < 10 ? km.toFixed(1).replace('.', ',') : Math.round(km) });
    }

    wurzeln.forEach((wurzel) => {
      let T;
      try {
        T = JSON.parse(wurzel.querySelector('[data-fb-texte]').textContent);
      } catch {
        return;
      }
      const blatt = document.getElementById(wurzel.dataset.blatt);
      const zeile = wurzel.querySelector('[data-fb-zeile]');
      const titel = wurzel.querySelector('[data-fb-titel]');
      const unter = wurzel.querySelector('[data-fb-unter]');
      const suche = blatt?.querySelector('[data-fb-suche]');
      const naehe = blatt?.querySelector('[data-fb-naehe]');
      const status = blatt?.querySelector('[data-fb-status]');
      const liste = blatt?.querySelector('[data-fb-liste]');
      const fuer = blatt?.querySelector('[data-fb-fuer]');
      const handle = wurzel.dataset.handle;

      let antwort = null;
      let filialen = null;
      let geraet = null;
      let variante = wurzel.dataset.variante;
      let varianteName = wurzel.dataset.varianteName;

      // ERPLink-Name → Eintrag aus filialen.json: gleicher Name, sonst der
      // einzige Store im Ort, sonst ein Name, der so anfängt.
      const zuordnen = (eintrag) => {
        if (!filialen?.length) return null;
        const name = falte(eintrag.store);
        const ort = falte(eintrag.city);
        const imOrt = filialen.filter((f) => falte(f.city) === ort);
        return (
          filialen.find((f) => falte(f.name) === name) ??
          (imOrt.length === 1 ? imOrt[0] : null) ??
          filialen.find((f) => falte(f.name).startsWith(name)) ??
          null
        );
      };

      // Die Filialen der gewählten Variante, beste Stufe zuerst; null = unbekannt.
      const eintraege = () => {
        const roh = antwort?.variants?.[variante];
        if (!Array.isArray(roh)) return null;
        return roh
          .map((e) => {
            const level = RANG[e.level] ? e.level : 'low';
            const filiale = zuordnen(e);
            const name = filiale?.name ?? e.store;
            return {
              level,
              filiale,
              name,
              suchtext: falte([name, e.store, e.city, filiale?.city, filiale?.zip].join(' ')),
            };
          })
          .sort((a, b) => RANG[b.level] - RANG[a.level] || a.name.localeCompare(b.name, 'de'));
      };
      const meinStore = () => {
        const id = leseMein();
        return id && filialen ? (filialen.find((f) => f.id === id) ?? null) : null;
      };
      const mehrzahl = (anzahl, eins, viele) => (anzahl === 1 ? T[eins] : fuelle(T[viele], { anzahl }));

      /* --- Zeile in der Kaufbox ----------------------------------------- */
      function zeichneZeile() {
        const alle = eintraege();
        if (!alle) {
          wurzel.hidden = true;
          return;
        }
        const mein = meinStore();
        const meinEintrag = mein ? alle.find((e) => e.filiale?.id === mein.id) : null;
        zeile.disabled = alle.length === 0;
        zeile.removeAttribute('data-stufe');

        if (!alle.length) {
          titel.textContent = T.keine;
          unter.textContent = varianteName ? fuelle(T.fuer, { variante: varianteName }) : '';
        } else if (meinEintrag) {
          zeile.dataset.stufe = meinEintrag.level;
          titel.textContent = fuelle(T.in_store, { stufe: T.stufe[meinEintrag.level], store: mein.name });
          const rest = alle.length - 1;
          unter.textContent = rest ? `${T.mein_store} · ${mehrzahl(rest, 'weitere_eins', 'weitere')}` : T.mein_store;
        } else if (mein) {
          titel.textContent = fuelle(T.nicht_in_store, { store: mein.name });
          unter.textContent = mehrzahl(alle.length, 'andere_eins', 'andere');
        } else {
          zeile.dataset.stufe = alle[0].level;
          titel.textContent = mehrzahl(alle.length, 'in_filialen_eins', 'in_filialen');
          unter.textContent = fuelle(T.zum_beispiel, {
            stores: alle
              .slice(0, 2)
              .map((e) => e.name)
              .join(', '),
          });
        }
        wurzel.hidden = false;
      }

      /* --- Blatt ---------------------------------------------------------- */
      function filialZeile(e, mein) {
        const li = el('li', 'fb-filiale');
        const kopf = el('div', 'fb-filiale__kopf');
        const f = e.filiale;
        const name = f ? el('a', 'fb-filiale__name', e.name) : el('span', 'fb-filiale__name', e.name);
        if (f) name.href = wurzel.dataset.filialeUrl + encodeURIComponent(f.id);
        kopf.append(name);
        if (mein && f?.id === mein.id) kopf.append(el('span', 'badge badge--neutral', T.mein_store));

        const stufe = el('span', 'fb-filiale__stufe');
        stufe.dataset.stufe = e.level;
        const mass = el('span', 'filialbestand__mass');
        mass.setAttribute('aria-hidden', 'true');
        mass.append(el('i'), el('i'), el('i'));
        stufe.append(mass, T.stufe[e.level]);

        const info = el('p', 'fb-filiale__info');
        const teile = [];
        if (f) teile.push(`${f.street}, ${f.zip} ${f.city}`);
        const o = oeffnung(f, T);
        if (geraet && f?.lat) teile.push(entfernung(entfernungKm(geraet, f), T));
        info.append(teile.join(' · '));
        if (o) {
          if (teile.length) info.append(' · ');
          info.append(
            el('span', o.offen ? 'fb-filiale__offen' : '', o.offen ? T.geoeffnet : T.geschlossen),
            ` ${o.text}`,
          );
        }

        const aktionen = el('div', 'fb-filiale__aktionen');
        if (f?.lat) {
          const route = el('a', 'fb-filiale__aktion', T.route);
          route.href = `https://www.google.com/maps/dir/?api=1&destination=${f.lat},${f.lng}`;
          route.target = '_blank';
          route.rel = 'noopener';
          route.append(el('span', 'visually-hidden', ` ${T.neues_fenster}`));
          aktionen.append(route);
        }
        if (f && f.id !== mein?.id) {
          const knopf = el('button', 'fb-filiale__aktion', T.als_mein_store);
          knopf.type = 'button';
          knopf.addEventListener('click', () => {
            try {
              localStorage.setItem(SPEICHER, f.id);
            } catch {
              /* Privater Modus: gilt bis zum Neuladen nicht. */
            }
            document.dispatchEvent(new CustomEvent('hervis:mein-store', { detail: { id: f.id } }));
            status.textContent = fuelle(T.mein_store_gesetzt, { name: f.name });
            status.removeAttribute('data-fehler');
          });
          aktionen.append(knopf);
        }
        li.append(kopf, stufe, info, aktionen);
        return li;
      }

      function zeichneBlatt(meldung) {
        if (!blatt?.open || !liste) return;
        const alle = eintraege() ?? [];
        const mein = meinStore();
        fuer.textContent = varianteName ? fuelle(T.fuer, { variante: varianteName }) : '';
        const roh = suche.value.trim();
        const q = falte(roh);
        const treffer = alle.filter((e) => !q || e.suchtext.includes(q));
        const entf = (e) => (geraet && e.filiale?.lat ? entfernungKm(geraet, e.filiale) : Infinity);
        treffer.sort((a, b) => {
          const ma = a.filiale && a.filiale.id === mein?.id ? 0 : 1;
          const mb = b.filiale && b.filiale.id === mein?.id ? 0 : 1;
          if (ma !== mb) return ma - mb;
          if (geraet) return entf(a) - entf(b);
          return RANG[b.level] - RANG[a.level] || a.name.localeCompare(b.name, 'de');
        });
        liste.replaceChildren(...treffer.map((e) => filialZeile(e, mein)));
        liste.hidden = treffer.length === 0;
        if (meldung) return;
        status.removeAttribute('data-fehler');
        if (q && !treffer.length) status.textContent = fuelle(T.leer_suche, { begriff: roh });
        else if (!alle.length) status.textContent = T.keine;
        else if (geraet) status.textContent = fuelle(T.nach_naehe, { anzahl: treffer.length });
        else status.textContent = mehrzahl(treffer.length, 'anzahl_eins', 'anzahl');
      }

      const zeichne = () => {
        zeichneZeile();
        zeichneBlatt();
      };

      // Beim Öffnen die Adressen laden (falls noch nicht da) und zeichnen —
      // egal welcher Knopf das Blatt öffnet (data-oeffnet="<Blatt-ID>", etwa
      // der Kaufknopf bei Sperrgut „Nur in der Filiale erhältlich").
      document.addEventListener('click', (event) => {
        const oeffner = event.target instanceof Element && event.target.closest('[data-oeffnet]');
        if (!oeffner || oeffner.dataset.oeffnet !== wurzel.dataset.blatt) return;
        requestAnimationFrame(() => zeichneBlatt());
        ladeFilialen(wurzel.dataset.filialen).then((daten) => {
          filialen = daten;
          zeichne();
        });
      });
      suche?.addEventListener('input', () => zeichneBlatt());
      // Ein Klick ins Feld (neben dem Text) setzt den Cursor in die Suche.
      blatt?.querySelector('[data-fb-suchfeld]')?.addEventListener('click', (event) => {
        if (!event.target.closest('button, input')) suche.focus();
      });
      // „In meiner Nähe" schaltet: noch einmal gedrückt, wieder nach Bestand.
      naehe?.addEventListener('click', () => {
        if (geraet) {
          geraet = null;
          naehe.setAttribute('aria-pressed', 'false');
          zeichneBlatt();
          return;
        }
        if (!navigator.geolocation) {
          status.textContent = T.standort_fehler;
          status.dataset.fehler = '';
          return;
        }
        status.textContent = T.standort_laeuft;
        status.removeAttribute('data-fehler');
        naehe.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            geraet = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            naehe.removeAttribute('aria-busy');
            naehe.setAttribute('aria-pressed', 'true');
            zeichneBlatt();
          },
          (fehler) => {
            naehe.removeAttribute('aria-busy');
            status.textContent = fehler.code === 1 ? T.standort_verweigert : T.standort_fehler;
            status.dataset.fehler = '';
          },
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 },
        );
      });
      document.addEventListener('hervis:mein-store', () => {
        // Die Meldung „… ist jetzt dein Store" bleibt stehen, die Liste wird neu sortiert.
        zeichneZeile();
        zeichneBlatt(true);
      });
      let optionen = [];
      try {
        optionen = JSON.parse(wurzel.dataset.optionen || '[]');
      } catch {
        optionen = [];
      }
      const nenne = (v) =>
        (v?.options ?? [])
          .map((wert, i) => {
            const name = String(optionen[i] ?? '');
            return /^(farbe|colou?r)$/i.test(name) || !name ? wert : `${name} ${wert}`;
          })
          .join(' · ');
      wurzel.closest('[data-produktseite]')?.addEventListener('produkt:variante', (event) => {
        const v = event.detail?.variante;
        variante = v ? String(v.id) : '';
        varianteName = v && v.title !== 'Default Title' ? nenne(v) : '';
        zeichne();
      });

      // Laden: der Bestand immer, die Adressen gleich mit, wenn ein „Mein
      // Store" gesetzt ist — sonst erst beim Öffnen des Blatts.
      const adressen = leseMein() ? ladeFilialen(wurzel.dataset.filialen) : Promise.resolve(null);
      Promise.all([bestand(handle), adressen])
        .then(([daten, liste]) => {
          antwort = daten;
          if (liste) filialen = liste;
          zeichneZeile();
        })
        .catch(() => {
          wurzel.hidden = true;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-leiste"] && !Shopify.designMode) return;
  try {
    /* Produktlisten (sections/collection.liquid, sections/search.liquid):
     1. Sortierung schickt sofort ab.
     2. Ansicht Groß/Kompakt — gemerkt, die Stelle in der Liste bleibt.
     3. „Mehr laden" hängt die nächste Seite an — beim Scrollen von selbst.
     4. Filtern, Sortieren, Blättern ohne Neuladen (Fundliste #28).
     Alles delegiert: die Liste wird beim Filtern ersetzt. */
  (() => {
    const wurzel = document.documentElement;

    /* 0. Überlauf der Spur: Ausblenden an der Kante, an der es weitergeht. */
    const spurMessen = () =>
      document.querySelectorAll('.filter-leiste__spur').forEach((spur) => {
        const ende = spur.scrollWidth - spur.clientWidth;
        spur.toggleAttribute('data-links', spur.scrollLeft > 1);
        spur.toggleAttribute('data-rechts', spur.scrollLeft < ende - 1);
      });
    document.addEventListener(
      'scroll',
      (e) => {
        if (e.target instanceof Element && e.target.matches('.filter-leiste__spur')) spurMessen();
      },
      true,
    );
    window.addEventListener('resize', spurMessen);
    document.addEventListener('hervis:inhalt', spurMessen);
    spurMessen();

    /* 1. Sortierung: Auswahl schickt das Formular sofort ab (ohne JS: Knopf in noscript). */
    document.addEventListener('change', (e) => {
      const auswahl = e.target;
      if (!(auswahl instanceof HTMLSelectElement)) return;
      auswahl.closest('[data-sortierung]')?.requestSubmit();
    });

    /* 2. Ansicht. Gesetzt wird sie schon vor dem ersten Bild (Inline-Skript
       in der Leiste); hier nur Umschalten, Merken und Abgleichen. */
    const dichteAbgleichen = () => {
      const wert = wurzel.dataset.listeDichte === 'kompakt' ? 'kompakt' : 'gross';
      document.querySelectorAll('[data-dichte]').forEach((wahl) => {
        wahl.checked = wahl.value === wert;
      });
    };
    document.addEventListener('change', (e) => {
      const wahl = e.target;
      if (!(wahl instanceof HTMLInputElement) || !wahl.matches('[data-dichte]') || !wahl.checked) return;
      /* Die oberste sichtbare Karte bleibt an ihrem Platz — sonst wäre die Stelle weg. */
      const karte = [...document.querySelectorAll('[data-raster] > li')].find(
        (li) => li.getBoundingClientRect().bottom > 0,
      );
      const vorher = karte?.getBoundingClientRect().top;
      if (wahl.value === 'kompakt') wurzel.dataset.listeDichte = 'kompakt';
      else delete wurzel.dataset.listeDichte;
      dichteAbgleichen();
      if (karte) window.scrollBy({ top: karte.getBoundingClientRect().top - vorher, behavior: 'instant' });
      try {
        localStorage.setItem('hervis:liste-dichte', wahl.value);
      } catch {}
    });
    dichteAbgleichen();

    /* 3. „Mehr laden": nächste Seite per Section Rendering holen, Karten
       anhängen, neue Zahl ansagen. Kommt der Knopf beim Scrollen in die
       Nähe (zwei Bildschirmhöhen vorher), lädt die Liste von selbst nach —
       höchstens AUTOMATISCH_HOECHSTENS Mal am Stück, danach steht der Knopf
       wieder da, damit der Fuß (Impressum, Newsletter) erreichbar bleibt; ein
       Klick darauf gibt die nächste Runde frei. Ohne JavaScript ist der Knopf
       ein Link auf die nächste Seite, und die Seitennavigation bleibt
       sichtbar. */
    const AUTOMATISCH_HOECHSTENS = 4;
    let laedtMehr = false;
    const nahe =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (eintraege) => {
              for (const { isIntersecting, target } of eintraege) {
                const liste = target.closest('[data-produktliste]');
                if (!isIntersecting || !liste) continue;
                if ((Number(liste.dataset.automatisch) || 0) >= AUTOMATISCH_HOECHSTENS) continue;
                mehrLaden(target, { automatisch: true });
              }
            },
            { rootMargin: '0px 0px 200% 0px' },
          )
        : null;
    const beobachten = () => document.querySelectorAll('[data-naechste]').forEach((knopf) => nahe?.observe(knopf));
    /* Steht der Knopf nach dem Anhängen noch in der Nähe (wenige Karten,
       hoher Bildschirm), meldet der Beobachter das so gleich wieder. */
    const neuAnsehen = (knopf) => {
      if (!nahe || !knopf.isConnected) return;
      nahe.unobserve(knopf);
      nahe.observe(knopf);
    };

    const seiteHolen = async (liste, adresse) => {
      const url = new URL(adresse, location.href);
      url.searchParams.set('section_id', liste.dataset.sectionId);
      const antwort = await fetch(url);
      if (!antwort.ok) throw new Error(String(antwort.status));
      return new DOMParser().parseFromString(await antwort.text(), 'text/html');
    };
    const anhaengen = (liste, doc, knopf) => {
      const neue = [...doc.querySelectorAll('[data-raster] > li')];
      liste.querySelector('[data-raster]').append(...neue);
      const status = liste.querySelector('[data-status]');
      const gezeigt = (Number(status?.dataset.gezeigt) || 0) + neue.length;
      if (status) {
        status.dataset.gezeigt = String(gezeigt);
        status.textContent = status.dataset.text.replace('[g]', gezeigt.toLocaleString('de-DE'));
      }
      liste.dataset.seiten = String((Number(liste.dataset.seiten) || 0) + 1);
      const naechste = doc.querySelector('[data-naechste]');
      if (naechste) knopf.href = naechste.getAttribute('href');
      else {
        nahe?.unobserve(knopf);
        knopf.remove();
      }
      return neue;
    };

    const mehrLaden = async (knopf, { automatisch = false } = {}) => {
      const liste = knopf.closest('[data-produktliste]');
      const raster = liste?.querySelector('[data-raster]');
      if (!raster || laedtMehr) return;
      laedtMehr = true;
      const beschriftung = knopf.textContent;
      knopf.setAttribute('aria-busy', 'true');
      if (knopf.dataset.laedt) knopf.textContent = knopf.dataset.laedt;
      try {
        const doc = await seiteHolen(liste, knopf.href);
        /* Inzwischen gefiltert: die alte Liste ist weg, nichts anhängen. */
        if (!raster.isConnected) return;
        const neue = anhaengen(liste, doc, knopf);
        neue.forEach((li) => li.classList.add('ist-neu'));
        liste.dataset.automatisch = automatisch ? String((Number(liste.dataset.automatisch) || 0) + 1) : '0';
        document.dispatchEvent(new CustomEvent('hervis:inhalt'));
        /* Nur wer geklickt hat, bekommt den Fokus in die neuen Karten — beim
           Scrollen bliebe er sonst irgendwo hängen. */
        if (!automatisch) neue[0]?.querySelector('a')?.focus();
      } catch {
        const status = liste.querySelector('[data-status]');
        if (status) status.textContent = status.dataset.fehler;
      } finally {
        laedtMehr = false;
        knopf.removeAttribute('aria-busy');
        if (knopf.isConnected) knopf.textContent = beschriftung;
        neuAnsehen(knopf);
      }
    };

    document.addEventListener('click', (e) => {
      const knopf = e.target.closest?.('[data-naechste]');
      if (!knopf || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!knopf.closest('[data-produktliste]')?.querySelector('[data-raster]')) return;
      e.preventDefault();
      mehrLaden(knopf);
    });

    /* Zurück vom Produkt: die nachgeladenen Seiten und die Stelle kommen
       wieder — sonst stünde man wieder bei Artikel 1. Gemerkt je Adresse,
       nur in diesem Tab (sessionStorage). Hat man schon selbst gescrollt,
       bleibt die Seite, wo sie ist. */
    const MERKEN = 'hervis:liste:';
    const merkSchluessel = () => MERKEN + location.pathname + location.search;
    window.addEventListener('pagehide', () => {
      const liste = document.querySelector('[data-produktliste]');
      const seiten = Number(liste?.dataset.seiten) || 0;
      try {
        if (!seiten) sessionStorage.removeItem(merkSchluessel());
        else {
          const automatisch = Number(liste.dataset.automatisch) || 0;
          sessionStorage.setItem(merkSchluessel(), JSON.stringify({ seiten, automatisch, y: Math.round(scrollY) }));
        }
      } catch {}
    });
    const wiederherstellen = async () => {
      const liste = document.querySelector('[data-produktliste]');
      const knopf = liste?.querySelector('[data-naechste]');
      let merk = null;
      try {
        merk = JSON.parse(sessionStorage.getItem(merkSchluessel()) || 'null');
      } catch {}
      if (!knopf || !liste.querySelector('[data-raster]') || !(merk?.seiten > 0)) return;
      let angefasst = false;
      const anfassen = () => (angefasst = true);
      const arten = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
      arten.forEach((art) => window.addEventListener(art, anfassen, { passive: true }));
      laedtMehr = true;
      const erste = Number(new URL(location.href).searchParams.get('page')) || 1;
      try {
        const seiten = await Promise.all(
          Array.from({ length: Math.min(merk.seiten, 10) }, (_, i) => {
            const url = new URL(location.href);
            url.searchParams.set('page', String(erste + 1 + i));
            return seiteHolen(liste, url);
          }),
        );
        if (!knopf.isConnected) return;
        for (const doc of seiten) {
          anhaengen(liste, doc, knopf);
          if (!knopf.isConnected) break;
        }
        liste.dataset.automatisch = String(merk.automatisch || 0);
        document.dispatchEvent(new CustomEvent('hervis:inhalt'));
        if (!angefasst) window.scrollTo({ top: merk.y, behavior: 'instant' });
      } catch {
        /* Dann bleibt es bei Seite 1 — wie ohne Merken. */
      } finally {
        laedtMehr = false;
        arten.forEach((art) => window.removeEventListener(art, anfassen));
        neuAnsehen(knopf);
      }
    };

    /* Nach dem Filtern ist der Knopf ein neues Element. */
    document.addEventListener('hervis:inhalt', beobachten);
    if (performance.getEntriesByType?.('navigation')[0]?.type === 'back_forward') wiederherstellen();
    beobachten();

    /* 4. Filtern ohne Neuladen. Filter-Chips, Panel, Sortierung, Seiten und
       die Filter-Links der Köpfe (Zielgruppe, Kategorie — gleiche Seite,
       andere Parameter) holen per Section Rendering (?sections=) alle
       Bereiche der Vorlage neu, statt die Seite neu aufzubauen. Die Adresse
       folgt per pushState, Zurück/Vor holt den Stand wieder. Die Liste
       bleibt an der Filterleiste stehen; der Fokus geht an das passende
       Bedienelement, eine Live-Region sagt „N Artikel" an. Ohne JavaScript
       (und bei jedem Fehler) bleibt es beim normalen Laden. */
    if (!document.querySelector('[data-produktliste]') || window.Shopify?.designMode) return;

    const PRAEFIX = 'shopify-section-';
    const VORLAGE = `[id^="${PRAEFIX}template--"]`;
    /* Was nur dieser Browser kennt, füllt ein Skript beim Laden (Merkliste,
       Zuletzt angesehen — snippets/merkliste-reihe, zuletzt-angesehen): das
       bleibt stehen, der Server kennt es nicht. */
    const BLEIBT = '[data-zuletzt], [data-merkliste-reihe]';
    const FOKUSSIERBAR = 'a[href], button, input, select';
    let stand = location.pathname + location.search;
    let abbruch = null;
    let panelOeffner = 'filter';

    const ansage = document.createElement('p');
    ansage.className = 'visually-hidden';
    ansage.setAttribute('role', 'status');
    document.body.append(ansage);

    document.addEventListener(
      'click',
      (e) => {
        const knopf = e.target.closest?.('[data-oeffnet="filter-panel"]');
        if (knopf) panelOeffner = knopf.dataset.filterGruppe || 'filter';
      },
      true,
    );

    /* Höchstens fünf Bereiche je Anfrage (Shopify) — sonst mehrere parallel. */
    const holen = async (url, signal) => {
      const ids = [...document.querySelectorAll(VORLAGE)].map((b) => b.id.slice(PRAEFIX.length));
      const gruppen = [];
      for (let i = 0; i < ids.length; i += 5) gruppen.push(ids.slice(i, i + 5));
      const teile = await Promise.all(
        gruppen.map(async (gruppe) => {
          const anfrage = new URL(url);
          anfrage.searchParams.set('sections', gruppe.join(','));
          const antwort = await fetch(anfrage, { signal });
          if (!antwort.ok) throw new Error(String(antwort.status));
          return antwort.json();
        }),
      );
      return Object.assign({}, ...teile);
    };

    /* Nur ändern, was sich geändert hat: Bilder im Kopf bleiben stehen und
       laden nicht neu. Eigene Elemente (produkt-reihe) und Formularfelder
       werden ganz ersetzt, damit ihr Zustand neu anfängt. */
    const angleichen = (alt, neu) => {
      if (alt.isEqualNode(neu)) return;
      if (
        alt.nodeType !== Node.ELEMENT_NODE ||
        alt.nodeName !== neu.nodeName ||
        alt.localName.includes('-') ||
        alt.matches('input, select, textarea')
      ) {
        alt.replaceWith(neu);
        return;
      }
      for (const { name } of [...alt.attributes]) if (!neu.hasAttribute(name)) alt.removeAttribute(name);
      for (const { name, value } of [...neu.attributes]) {
        if (alt.getAttribute(name) !== value) alt.setAttribute(name, value);
      }
      const neuKinder = [...neu.childNodes];
      if (alt.childNodes.length !== neuKinder.length) {
        alt.replaceChildren(...neuKinder);
        return;
      }
      [...alt.childNodes].forEach((kind, i) => angleichen(kind, neuKinder[i]));
    };

    const einsetzen = (daten, listeId) => {
      for (const bereich of document.querySelectorAll(VORLAGE)) {
        const html = daten[bereich.id.slice(PRAEFIX.length)];
        if (typeof html !== 'string') continue;
        const neu = new DOMParser().parseFromString(html, 'text/html').getElementById(bereich.id);
        if (!neu) continue;
        if (bereich.id === listeId) {
          bereich.replaceChildren(...neu.childNodes);
          continue;
        }
        const behalten = [...bereich.querySelectorAll(BLEIBT)];
        neu.querySelectorAll(BLEIBT).forEach((platz, i) => {
          if (behalten[i]) platz.replaceWith(behalten[i]);
        });
        angleichen(bereich, neu);
      }
    };

    /* Wohin der Fokus nach dem Ersetzen geht — an das Gegenstück dessen,
       was ihn hatte. */
    const filterKnopf = () => document.querySelector('[data-produktliste] .filter-leiste__filter');
    const fokusPlan = (ausloeser, bereich) => {
      /* Zurück/Vor: stand der Fokus in der Liste, geht er an „Filter". */
      if (!(ausloeser instanceof Element)) {
        return document.querySelector('[data-produktliste]')?.contains(document.activeElement)
          ? filterKnopf
          : () => null;
      }
      if (bereich) {
        const href = ausloeser.getAttribute('href');
        const stelle = [...bereich.querySelectorAll(FOKUSSIERBAR)].indexOf(ausloeser);
        return () => {
          const neu = document.getElementById(bereich.id);
          if (!neu) return null;
          const gleich = href && [...neu.querySelectorAll('a[href]')].find((a) => a.getAttribute('href') === href);
          return gleich || neu.querySelectorAll(FOKUSSIERBAR)[stelle] || null;
        };
      }
      if (ausloeser.id) return () => document.getElementById(ausloeser.id);
      if (ausloeser.closest('dialog')) {
        const gruppe = panelOeffner;
        return () =>
          (gruppe !== 'filter' &&
            document.querySelector(`[data-produktliste] [data-filter-gruppe="${CSS.escape(gruppe)}"]`)) ||
          filterKnopf();
      }
      /* Die Chips stehen zweimal im Dokument (Pille am Handy, Zeile ab 48rem) —
         gezählt werden nur die sichtbaren. */
      const sichtbareChips = () =>
        [...document.querySelectorAll('[data-produktliste] .chip--entfernen')].filter(
          (chip) => chip.getClientRects().length > 0,
        );
      if (ausloeser.matches('.chip--entfernen')) {
        const stelle = sichtbareChips().indexOf(ausloeser);
        return () => {
          const chips = sichtbareChips();
          return chips[stelle] || chips[stelle - 1] || filterKnopf();
        };
      }
      if (ausloeser.closest('[data-seiten]')) {
        return () => document.querySelector('[data-produktliste] [data-raster] a') || filterKnopf();
      }
      return filterKnopf;
    };

    const laden = async (adresse, { push = true, ausloeser = null } = {}) => {
      const url = new URL(adresse, location.href);
      const sprung = url.hash;
      url.hash = '';
      abbruch?.abort();
      abbruch = new AbortController();
      const { signal } = abbruch;

      const liste = document.querySelector('[data-produktliste]');
      const listeId = liste?.closest(`[id^="${PRAEFIX}"]`)?.id;
      liste?.setAttribute('aria-busy', 'true');
      document.querySelectorAll('[data-produktliste] dialog[open]').forEach((dialog) => dialog.close());

      let daten;
      try {
        daten = await holen(url, signal);
        if (!listeId || typeof daten[listeId.slice(PRAEFIX.length)] !== 'string') throw new Error('Liste fehlt');
      } catch (fehler) {
        if (fehler.name === 'AbortError') return;
        /* Notfall: wie ohne JavaScript. */
        if (push) location.assign(url.href + sprung);
        else location.reload();
        return;
      }

      /* Ankerpunkt: geklickt im Kopf → dieser Bereich bleibt, wo er ist.
         In der Liste: klebte die Leiste schon (man war in der Liste), rollt
         die Seite zurück an den Anfang der Liste; sonst bleibt alles stehen. */
      const kopf = ausloeser?.closest?.(VORLAGE);
      const bereich = kopf && kopf.id !== listeId ? kopf : null;
      const anker = bereich || document.querySelector('[data-liste-anker]') || liste;
      const vorher = anker.getBoundingClientRect().top;
      const leiste = document.querySelector('[data-filter-leiste]');
      const klebt = !bereich && !!leiste && leiste.getBoundingClientRect().top - vorher > 1;
      const fokus = fokusPlan(ausloeser, bereich);
      const fokusWeg = () =>
        !document.activeElement || document.activeElement === document.body || !document.activeElement.isConnected;

      einsetzen(daten, listeId);
      const neu = url.pathname + url.search;
      if (push && neu !== stand) history.pushState({ hervisListe: true }, '', neu + sprung);
      stand = neu;
      dichteAbgleichen();

      const ziel = sprung && document.getElementById(decodeURIComponent(sprung.slice(1)));
      const neuerAnker = bereich
        ? document.getElementById(bereich.id)
        : document.querySelector('[data-liste-anker]') || document.querySelector('[data-produktliste]');
      if (ziel) ziel.scrollIntoView({ block: 'start', behavior: 'instant' });
      else if (klebt) neuerAnker?.scrollIntoView({ block: 'start', behavior: 'instant' });
      else if (neuerAnker) {
        window.scrollBy({ top: neuerAnker.getBoundingClientRect().top - vorher, behavior: 'instant' });
      }

      if (fokusWeg()) fokus()?.focus({ preventScroll: true });

      const neueListe = document.querySelector('[data-produktliste]');
      const seite = ausloeser?.closest?.('[data-seiten]') && neueListe?.querySelector('.produktliste__seite');
      const text = (seite || neueListe?.querySelector('[data-liste-ansage]'))?.textContent.trim().replace(/\s+/g, ' ');
      ansage.textContent = '';
      if (text) setTimeout(() => (ansage.textContent = text), 100);
      document.dispatchEvent(new CustomEvent('hervis:inhalt'));
    };

    /* Links: gleiche Seite, andere Parameter (Filter-Chips ×, Seiten,
       Zurücksetzen, Zielgruppe/Kategorie im Kopf). Eine neue Suche (anderes
       q) und reine Anker (#produkte) bleiben normale Links. */
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target.closest?.('a[href]');
      if (!link || link.target || link.hasAttribute('download')) return;
      if (link.matches('[data-naechste], [data-oeffnet], [data-app-oeffnen], [data-app-laden]')) return;
      if (!link.closest(VORLAGE)) return;
      const ziel = new URL(link.href, location.href);
      const hier = new URL(location.href);
      if (ziel.origin !== hier.origin || ziel.pathname !== hier.pathname) return;
      if (ziel.searchParams.get('q') !== hier.searchParams.get('q')) return;
      /* Gleicher Stand: ein Anker (#produkte) springt wie gewohnt. Der Chip,
         der schon gilt („Kinder" auf Kinder, „Alle" ohne Filter), lädt nicht
         die ganze Seite neu und springt nicht nach oben — er tut nichts.
         „Zurücksetzen" im Panel zeichnet trotzdem neu (Panel zurück). */
      if (ziel.search === hier.search && !link.closest('dialog')) {
        if (!ziel.hash) e.preventDefault();
        return;
      }
      e.preventDefault();
      laden(ziel, { ausloeser: link });
    });

    /* Formulare: Sortierung und Filter-Panel. */
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-sortierung], [data-filter-form]')) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      if (form.querySelector('[data-filter-anzeigen][aria-disabled="true"]')) return;
      const params = new URLSearchParams();
      for (const [name, wert] of new FormData(form)) if (wert !== '') params.append(name, wert);
      const ziel = new URL(form.getAttribute('action') || location.pathname, location.href);
      ziel.search = params.toString();
      laden(ziel, { ausloeser: form.matches('[data-sortierung]') ? form.querySelector('select') : form });
    });

    window.addEventListener('popstate', () => {
      if (location.pathname + location.search === stand) return;
      laden(location.href, { push: false });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-panel"] && !Shopify.designMode) return;
  try {
    /* Filter-Panel: Unisex-Begleiter, „Alle Schuhe" und Größen-Begleiter,
     leere Felder weglassen, Sprung zur Gruppe aus der Schnellwahl, Live-Zahl
     im Knopf und die übrigen Gruppen live (Section Rendering).
     Alles delegiert: beim Filtern ohne Neuladen wird das Panel mit der
     Liste ersetzt (snippets/filter-leiste.liquid). */
  (() => {
    const FORM = '[data-filter-form]';

    const unisexAbgleichen = (form) => {
      const unisex = form.querySelector('[data-unisex]');
      if (unisex) unisex.disabled = !form.querySelector('[data-geschlecht]:checked');
    };

    /* Kategorie: „Alle Schuhe" ist an, wenn alle Typen der Gruppe an sind,
       halb, wenn ein Teil an ist. */
    const katAbgleichen = (gruppe) => {
      const alle = gruppe?.querySelector('[data-kat-alle]');
      if (!alle) return;
      const typen = [...gruppe.querySelectorAll('[data-kat-typ]')];
      const an = typen.filter((typ) => typ.checked).length;
      alle.checked = an > 0 && an === typen.length;
      alle.indeterminate = an > 0 && an < typen.length;
    };
    const alleKatAbgleichen = () => document.querySelectorAll('[data-kat-gruppe]').forEach(katAbgleichen);
    alleKatAbgleichen();
    document.addEventListener('hervis:inhalt', alleKatAbgleichen);

    document.addEventListener('change', (e) => {
      const feld = e.target;
      if (!(feld instanceof HTMLInputElement) || !feld.closest(FORM)) return;
      if (feld.matches('[data-kat-alle]')) {
        feld
          .closest('[data-kat-gruppe]')
          .querySelectorAll('[data-kat-typ]')
          .forEach((typ) => (typ.checked = feld.checked));
        feld.indeterminate = false;
      } else if (feld.matches('[data-kat-typ]')) {
        /* War die ganze Gruppe gewählt, heißt ein Klick auf einen Typ „nur
           dieser" — nicht „alle außer diesem". */
        const gruppe = feld.closest('[data-kat-gruppe]');
        if (!feld.checked && gruppe?.querySelector('[data-kat-alle]')?.checked) {
          gruppe.querySelectorAll('[data-kat-typ]').forEach((typ) => (typ.checked = typ === feld));
        }
        katAbgleichen(gruppe);
      } else if (feld.matches('[data-groesse-mit]')) {
        /* „S" nimmt „S/36" mit. */
        feld
          .closest('label')
          ?.querySelectorAll('[data-groesse-begleiter]')
          .forEach((begleiter) => (begleiter.checked = feld.checked));
      }
    });

    /* „+ N weitere" klappt die übrigen Typen einer Gruppe auf. */
    document.addEventListener('click', (e) => {
      const knopf = e.target.closest?.('[data-kat-mehr]');
      if (!knopf) return;
      const gruppe = knopf.closest('[data-kat-gruppe]');
      const offen = !gruppe.hasAttribute('data-offen');
      gruppe.toggleAttribute('data-offen', offen);
      knopf.setAttribute('aria-expanded', String(offen));
      knopf.textContent = offen ? knopf.dataset.textOffen : knopf.dataset.textZu;
    });
    const mehrAbgleichen = (offene) =>
      offene.forEach((id) => {
        const gruppe = document.querySelector(`[data-kat-gruppe="${CSS.escape(id)}"]`);
        const knopf = gruppe?.querySelector('[data-kat-mehr]');
        if (!gruppe || !knopf) return;
        gruppe.setAttribute('data-offen', '');
        knopf.setAttribute('aria-expanded', 'true');
        knopf.textContent = knopf.dataset.textOffen;
      });

    /* Die übrigen Gruppen aus der Antwort übernehmen — Größen, die es unter
       der neuen Wahl nicht gibt, fallen weg, Zahlen stimmen. Die Gruppe, in
       der gerade gewählt wurde, bleibt stehen (Fokus, Stelle); die Liste
       rollt so, dass sie an ihrem Platz bleibt. */
    const gruppenAngleichen = (form, doc, behalten) => {
      const inhalt = form.querySelector('.filter-panel__inhalt');
      const neu = doc.querySelector('[data-filter-form] .filter-panel__inhalt');
      if (!inhalt || !neu) return;
      const anker = behalten && document.getElementById(behalten);
      const vorher = anker?.getBoundingClientRect().top;
      const offene = [...inhalt.querySelectorAll('[data-kat-gruppe][data-offen]')].map((g) => g.dataset.katGruppe);
      const kinder = [...neu.children].map((kind) =>
        kind.id && kind.id === behalten && anker ? anker : document.importNode(kind, true),
      );
      if (anker && !kinder.includes(anker)) return;
      inhalt.replaceChildren(...kinder);
      mehrAbgleichen(offene);
      fokusErneuern(form);
      if (anker && vorher !== undefined) inhalt.scrollTop += anker.getBoundingClientRect().top - vorher;
      alleKatAbgleichen();
      unisexAbgleichen(form);
    };

    /* Leere Felder (Preis ohne Wert, Produkttyp „Alle") gehören nicht in die
       URL. Nur die leeren Einträge fallen weg — delete(name) nähme auch die
       festen Werte gleichen Namens mit (filter.p.tag=world:…). formdata steigt
       nicht auf, darum in der Einfangphase. */
    document.addEventListener(
      'formdata',
      (e) => {
        if (!(e.target instanceof HTMLFormElement) || !e.target.matches(FORM)) return;
        const eintraege = [...e.formData.entries()];
        if (!eintraege.some(([, wert]) => wert === '')) return;
        for (const name of new Set(eintraege.map(([name]) => name))) e.formData.delete(name);
        for (const [name, wert] of eintraege) if (wert !== '') e.formData.append(name, wert);
      },
      true,
    );

    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM)) return;
      if (form.querySelector('[data-filter-anzeigen]')?.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });

    let zeitgeber;
    let abbruch;
    const zahlHolen = async (form, behalten) => {
      const knopf = form.querySelector('[data-filter-anzeigen]');
      abbruch?.abort();
      abbruch = new AbortController();
      const params = new URLSearchParams();
      for (const [name, wert] of new FormData(form)) if (wert !== '') params.append(name, wert);
      params.set('section_id', form.dataset.sectionId);
      knopf?.setAttribute('aria-busy', 'true');
      try {
        const antwort = await fetch(`${form.action}?${params}`, { signal: abbruch.signal });
        if (!antwort.ok) throw new Error(String(antwort.status));
        const html = await antwort.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        gruppenAngleichen(form, doc, behalten);
        const n = Number(doc.querySelector('[data-gesamt]')?.dataset.gesamt);
        if (!knopf || Number.isNaN(n)) return;
        if (n === 0) {
          knopf.textContent = knopf.dataset.textKeine;
          knopf.setAttribute('aria-disabled', 'true');
        } else {
          knopf.textContent =
            n === 1 ? knopf.dataset.textEins : knopf.dataset.textViele.replace('[n]', n.toLocaleString('de-DE'));
          knopf.removeAttribute('aria-disabled');
        }
      } catch (fehler) {
        if (fehler.name !== 'AbortError' && knopf) {
          knopf.textContent = knopf.dataset.textFehler;
          knopf.removeAttribute('aria-disabled');
        }
      } finally {
        knopf?.removeAttribute('aria-busy');
      }
    };

    const geaendert = (e) => {
      const form = e.target.closest?.(FORM);
      if (!form) return;
      if (e.type === 'input' && !(e.target instanceof HTMLInputElement && e.target.type === 'number')) return;
      unisexAbgleichen(form);
      /* Eine Antwort auf den Stand davor darf diese Wahl nicht überschreiben. */
      abbruch?.abort();
      const behalten = e.target.closest?.('[id^="filter-gruppe-"]')?.id;
      clearTimeout(zeitgeber);
      zeitgeber = setTimeout(() => zahlHolen(form, behalten), 350);
    };
    document.addEventListener('change', geaendert);
    document.addEventListener('input', geaendert);

    /* Schnellwahl „Größe ▾" & Co. (Owner 2026-10-15: „leicht intuitiv"):
       Panel öffnet (assets/hervis.js § 3) mit NUR dieser Gruppe, der Titel
       heißt wie sie, „Alle Filter" holt den Rest dazu. Zurücksetzen leert
       dann nur diese Gruppe. Der Knopf „Filter" öffnet immer alles. */
    const fokusSetzen = (form, name) => {
      const titel = form.querySelector('.filter-panel__titel');
      const alle = form.querySelector('[data-filter-alle]');
      const gruppe = name && form.querySelector(`#filter-gruppe-${CSS.escape(name)}`);
      form.querySelectorAll('.ist-fokus').forEach((g) => g.classList.remove('ist-fokus'));
      if (!gruppe) {
        delete form.dataset.fokus;
        if (titel) titel.textContent = titel.dataset.titel;
        if (alle) alle.hidden = true;
        return;
      }
      form.dataset.fokus = name;
      gruppe.classList.add('ist-fokus');
      const ueberschrift = gruppe.querySelector('legend, .filter-panel__gruppen-titel, .filter-panel__schalter > span');
      if (titel) titel.textContent = ueberschrift?.textContent.trim() || titel.dataset.titel;
      if (alle) alle.hidden = false;
    };
    const fokusErneuern = (form) => {
      if (form.dataset.fokus) fokusSetzen(form, form.dataset.fokus);
    };

    document.addEventListener('click', (e) => {
      const alle = e.target.closest?.('[data-filter-alle]');
      if (alle) {
        const form = alle.closest(FORM);
        const gruppe = form?.querySelector('.ist-fokus');
        fokusSetzen(form, null);
        gruppe?.scrollIntoView({ block: 'start' });
        /* Der Knopf verschwindet — der Fokus bleibt in der Gruppe. */
        gruppe?.querySelector('input:not([type="hidden"]):not(:disabled)')?.focus({ preventScroll: true });
        return;
      }
      const knopf = e.target.closest?.('[data-oeffnet="filter-panel"]');
      if (knopf && !knopf.dataset.filterGruppe) {
        const f = document.querySelector(`#filter-panel ${FORM}`);
        if (f) fokusSetzen(f, null);
      }
    });
    document.addEventListener(
      'close',
      (e) => {
        const f = e.target instanceof HTMLDialogElement && e.target.querySelector(FORM);
        if (f) fokusSetzen(f, null);
      },
      true,
    );
    /* Zurücksetzen in der Fokus-Ansicht leert nur die Gruppe und bleibt im
       Panel. In der Einfangphase — sonst lädt das Filtern ohne Neuladen
       (snippets/filter-leiste.liquid) die Rücksetz-Adresse schon. */
    document.addEventListener(
      'click',
      (e) => {
        const zurueck = e.target.closest?.('.filter-panel__fuss a[href]');
        const form = zurueck?.closest(FORM);
        if (!form?.dataset.fokus) return;
        e.preventDefault();
        const gruppe = form.querySelector('.ist-fokus');
        gruppe?.querySelectorAll('input').forEach((feld) => {
          if (feld.type === 'checkbox') feld.checked = false;
          else if (feld.type === 'radio') feld.checked = feld.value === '';
          else if (feld.type === 'number') feld.value = '';
        });
        gruppe?.querySelectorAll('[data-kat-gruppe]').forEach(katAbgleichen);
        gruppe?.querySelector('input')?.dispatchEvent(new Event('change', { bubbles: true }));
      },
      true,
    );

    document.addEventListener('click', (e) => {
      const ausloeser = e.target.closest?.('[data-filter-gruppe]');
      if (!ausloeser) return;
      const form = document.querySelector(`#filter-panel ${FORM}`);
      if (form) fokusSetzen(form, ausloeser.dataset.filterGruppe);
      requestAnimationFrame(() => {
        const gruppe = document.getElementById(`filter-gruppe-${ausloeser.dataset.filterGruppe}`);
        if (!gruppe) return;
        gruppe.scrollIntoView({ block: 'start' });
        const ziel =
          gruppe.querySelector('input:not([type="hidden"]):not(:disabled)') ||
          gruppe.querySelector('a[aria-current]') ||
          gruppe.querySelector('a[href]');
        ziel?.focus({ preventScroll: true });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["konto-benachrichtigungen"] && !Shopify.designMode) return;
  try {
    (() => {
    const wurzel = document.querySelector('[data-benachrichtigungen]');
    if (!wurzel) return;

    let texte = {};
    try {
      texte = JSON.parse(wurzel.querySelector('[data-benachrichtigungen-texte]').textContent);
    } catch {}
    const t = (schluessel, werte = {}) => (texte[schluessel] || '').replace(/%(\w+)%/g, (_, name) => werte[name] ?? '');

    const api = window.hervisApi;
    const inhalt = wurzel.querySelector('[data-benachrichtigungen-inhalt]');
    const meldung = wurzel.querySelector('[data-meldung]');
    const fehlerZeile = wurzel.querySelector('[data-fehler]');

    /* ------------------------------------- Regeln aus der App (rein) */

    const istObjekt = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);

    // lib/consents-wire.ts: Zustand mit oder ohne Versionsfeld, Zeilen unter
    // `consents` oder `rows`. null heißt „diese Form liegt nicht vor".
    const istZustand = (v) => istObjekt(v) && (v.v === 1 || (v.v === undefined && istObjekt(v.channels)));
    const antwortLesen = (daten) => {
      if (!istObjekt(daten)) return { zeilen: null, zustand: null };
      const zeilen = Array.isArray(daten.consents) ? daten.consents : Array.isArray(daten.rows) ? daten.rows : null;
      const roh = istZustand(daten.state) ? daten.state : istZustand(daten.consents) ? daten.consents : null;
      return { zeilen, zustand: roh };
    };

    // lib/consents.ts emptyConsents + stateFrom: fehlende Teile auffüllen.
    const zustandAus = (roh) => ({
      channels: {},
      purposes: {},
      interests: {},
      seeded: false,
      updatedAt: new Date(0).toISOString(),
      ...roh,
      v: 1,
    });

    // updateConsents: jede Änderung ist eine Willenserklärung mit Zeitpunkt.
    const geaendert = (zustand, aenderung) => ({
      ...aenderung(zustand),
      v: 1,
      updatedAt: new Date().toISOString(),
    });

    // lib/profile-api.ts newsletterFrom / readNewsletterState.
    const newsletterAusZeilen = (zeilen) => {
      const zeile = zeilen.find((z) => z && z.topic === 'newsletter' && z.channel === 'email');
      if (!zeile) return null;
      const status = ['pending', 'authorized', 'blocked'].includes(zeile.status) ? zeile.status : null;
      return { an: status === 'authorized' || status === 'pending', offen: status === 'pending' };
    };
    const newsletterAusZustand = (zustand) => {
      const liste = Array.isArray(zustand.pendingConfirmation) ? zustand.pendingConfirmation : [];
      const offen = liste.some((e) =>
        typeof e === 'string' ? e === 'email' : istObjekt(e) && (e.channel === 'email' || e.topic === 'email'),
      );
      return { an: offen || zustand.channels?.email === 'granted', offen };
    };
    const newsletterLesen = ({ zeilen, zustand }) => {
      if (zeilen) return newsletterAusZeilen(zeilen) ?? { an: false, offen: false };
      return zustand ? newsletterAusZustand(zustand) : null;
    };

    /* „Alle Werbe-Einwilligungen widerrufen" (lib/consents.ts denyAll):
       Kanäle, Werbezwecke und Interessen ausdrücklich ablehnen —
       Servicezwecke (Bestellstatus) bleiben. */
    const KANAELE = ['email', 'push', 'sms', 'whatsapp', 'inapp'];
    const WERBEZWECKE = ['offers', 'community', 'cart'];
    const allesAblehnen = (zustand, interessen) =>
      geaendert(zustand, (z) => {
        const channels = { ...z.channels };
        for (const kanal of KANAELE) channels[kanal] = 'denied';
        const purposes = { ...z.purposes };
        for (const zweck of WERBEZWECKE) purposes[zweck] = 'denied';
        const interests = { ...z.interests };
        for (const id of interessen) interests[id] = 'denied';
        return { ...z, channels, purposes, interests, seeded: true };
      });

    // lib/phone.ts formatPhone — nur fürs Lesen der Unterzeile.
    const VORWAHLEN = [
      '423',
      '421',
      '420',
      '386',
      '385',
      '372',
      '371',
      '370',
      '359',
      '358',
      '357',
      '356',
      '354',
      '353',
      '352',
      '351',
      '49',
      '48',
      '47',
      '46',
      '45',
      '43',
      '41',
      '40',
      '39',
      '36',
      '34',
      '33',
      '32',
      '31',
      '30',
    ];
    const telefonAnzeige = (e164) => {
      if (!/^\+\d{4,}$/.test(e164 || '')) return e164 || '';
      const ziffern = e164.slice(1);
      const vorwahl = VORWAHLEN.find((v) => ziffern.startsWith(v));
      if (!vorwahl) return e164;
      const n = ziffern.slice(vorwahl.length);
      let block = 3;
      if (vorwahl === '43' && n.startsWith('1')) block = 1;
      if (vorwahl === '49' && /^(30|40|69|89)/.test(n)) block = 2;
      return n.length <= block ? `+${vorwahl} ${n}` : `+${vorwahl} ${n.slice(0, block)} ${n.slice(block)}`;
    };

    /* --------------------------------------------------- Zustand */

    const NEWSLETTER_TEXTFASSUNG = 'app-newsletter-2026-09-30';
    const email = wurzel.dataset.email || '';
    const interessenIds = [
      ...new Set([...wurzel.querySelectorAll('[data-interesse]')].map((e) => e.dataset.interesse)),
    ];

    let zustand = null; // was angezeigt wird (inkl. ungesendeter Änderungen)
    let bestaetigt = null; // was das Backend zuletzt bestätigt hat
    let newsletter = null;
    let telefon = null;
    let telefonBekannt = false;

    const meldungZeigen = (text) => {
      meldung.textContent = '';
      requestAnimationFrame(() => (meldung.textContent = text || ''));
    };
    const fehlerZeigen = (text) => {
      fehlerZeile.querySelector('[data-text]').textContent = text || '';
      fehlerZeile.hidden = !text;
    };

    const wertSetzen = (feld, text) => {
      const zelle = wurzel.querySelector(`[data-feld="${feld}"] [data-feld-wert]`);
      if (zelle) zelle.textContent = text;
    };

    const anzeigen = () => {
      const nl = wurzel.querySelector('[data-newsletter]');
      nl.checked = newsletter.an;
      wurzel.querySelector('[data-unterzeile="email"]').textContent = newsletter.offen
        ? t('bestaetigen')
        : email
          ? t('an', { ziel: email })
          : t('email_beschreibung');

      for (const kanal of ['sms', 'whatsapp']) {
        const ohneNummer = telefonBekannt && !telefon;
        wurzel.querySelector(`[data-kanal-schalter="${kanal}"]`).hidden = ohneNummer;
        wurzel.querySelector(`[data-kanal-ohne-nummer="${kanal}"]`).hidden = !ohneNummer;
        wurzel.querySelector(`[data-kanal="${kanal}"]`).checked = zustand.channels[kanal] === 'granted';
        wurzel.querySelector(`[data-unterzeile="${kanal}"]`).textContent = telefon
          ? t('an', { ziel: telefonAnzeige(telefon) })
          : t(`${kanal}_beschreibung`);
      }

      for (const eingabe of wurzel.querySelectorAll('[data-interesse]')) {
        eingabe.checked = zustand.interests[eingabe.dataset.interesse] === 'granted';
      }

      // „Ski, Bike +2" bzw. „Noch nichts gewählt" (interestSummary).
      const welten = [...wurzel.querySelectorAll('[data-welt]')]
        .filter((welt) => [...welt.querySelectorAll('[data-interesse]')].some((e) => e.checked))
        .map((welt) => welt.dataset.weltName.split(' & ')[0].split(' ')[0]);
      wertSetzen(
        'sportwelten',
        welten.length === 0
          ? t('noch_nichts')
          : welten.length <= 2
            ? welten.join(', ')
            : `${welten.slice(0, 2).join(', ')} +${welten.length - 2}`,
      );
      const themen = [...wurzel.querySelectorAll('[data-thema]')];
      wertSetzen('themen', t('von', { an: themen.filter((e) => e.checked).length, alle: themen.length }));
    };

    const freigeben = () => {
      inhalt.removeAttribute('aria-busy');
      // SMS/WhatsApp bleiben gesperrt, solange die Nummer unbekannt ist —
      // „erst wissen, dann urteilen" (app/consents/index.tsx).
      for (const eingabe of wurzel.querySelectorAll('[data-newsletter], [data-interesse]')) eingabe.disabled = false;
      for (const eingabe of wurzel.querySelectorAll('[data-kanal]')) eingabe.disabled = !telefonBekannt;
      wurzel.querySelector('[data-widerrufen]').disabled = false;
      for (const feld of ['sportwelten', 'themen']) {
        const zeile = wurzel.querySelector(`[data-feld="${feld}"]`);
        zeile.dataset.oeffnet = `benachrichtigung-${feld}`;
        zeile.removeAttribute('aria-disabled');
      }
    };

    const rueckfall = () => {
      inhalt.hidden = true;
      wurzel.querySelector('[data-benachrichtigungen-rueckfall]').hidden = false;
    };

    /* ------------------------------ Voll-Replace, entprellt wie die App */

    const ENTPRELLEN_MS = 800;
    let zeitgeber = null;
    let laufend = null;

    const senden = async () => {
      clearTimeout(zeitgeber);
      zeitgeber = null;
      if (laufend) await laufend.catch(() => {});
      const gesendet = zustand;
      if (gesendet === bestaetigt) return;
      laufend = api.schreiben('/api/account/consents', { consents: gesendet });
      try {
        const neu = antwortLesen(await laufend).zustand;
        bestaetigt = neu ? { ...zustandAus(neu), seeded: gesendet.seeded } : gesendet;
        // Wer während des Sendens weitergeschaltet hat, behält seinen Stand —
        // er ist der jüngere und geht gleich hinterher.
        if (zustand === gesendet) {
          zustand = bestaetigt;
          anzeigen();
        }
        fehlerZeigen('');
        meldungZeigen(t('gespeichert'));
      } catch (grund) {
        // Kein Spiegel auf der Platte wie in der App: zurück auf das, was das
        // Backend hat, und sagen, dass es nicht geklappt hat. Wurde inzwischen
        // weitergeschaltet, bleibt der neuere Stand — sein Senden steht an.
        if (zustand === gesendet) {
          zustand = bestaetigt;
          anzeigen();
        }
        fehlerZeigen(grund?.status === 0 ? t('fehler_verbindung') : t('fehler_speichern'));
        throw grund;
      } finally {
        laufend = null;
      }
    };
    const planen = () => {
      clearTimeout(zeitgeber);
      zeitgeber = setTimeout(() => senden().catch(() => {}), ENTPRELLEN_MS);
    };

    /* Seite verlassen, während noch etwas aussteht: sofort und mit
       keepalive senden, sonst ginge der letzte Schalter verloren. */
    const nachholen = () => {
      if (!zeitgeber || zustand === bestaetigt) return;
      clearTimeout(zeitgeber);
      zeitgeber = null;
      fetch('/apps/hervis/api/account/consents', {
        method: 'POST',
        headers: { accept: 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify({ consents: zustand }),
        credentials: 'same-origin',
        keepalive: true,
      }).catch(() => {});
    };
    window.addEventListener('pagehide', nachholen);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') nachholen();
    });

    /* --------------------------------------------- Newsletter (DOI) */

    let newsletterLaeuft = false;
    const newsletterSetzen = async (an) => {
      const status = an ? 'pending' : 'blocked';
      const antwort = await api.schreiben('/api/account/consents', {
        consent: { topic: 'newsletter', channel: 'email', status, textVersion: NEWSLETTER_TEXTFASSUNG },
      });
      // Ein 2xx heißt „angenommen" — fehlt die Zeile in der Antwort, gilt der
      // angeforderte Stand (profile-api.ts setNewsletterSubscribed).
      const { zeilen } = antwortLesen(antwort);
      return (zeilen && newsletterAusZeilen(zeilen)) || { an, offen: an };
    };
    /* Der E-Mail-Kanal im Zustand ist nur Anzeige (applyServerChannel) —
       übernehmen ist keine Willenserklärung, also ohne neues updatedAt. */
    const emailUebernehmen = (an) => {
      const wert = an ? 'granted' : 'denied';
      if (zustand.channels.email === wert) return;
      const mit = (z) => ({ ...z, channels: { ...z.channels, email: wert } });
      if (zustand === bestaetigt) {
        zustand = mit(zustand);
        bestaetigt = zustand;
      } else {
        zustand = mit(zustand);
        bestaetigt = mit(bestaetigt);
      }
    };

    wurzel.addEventListener('change', async (e) => {
      const eingabe = e.target;
      if (!(eingabe instanceof HTMLInputElement) || !zustand) return;

      if (eingabe.matches('[data-newsletter]')) {
        if (newsletterLaeuft) {
          eingabe.checked = newsletter.an;
          return;
        }
        newsletterLaeuft = true;
        eingabe.setAttribute('aria-busy', 'true');
        const vorher = newsletter;
        newsletter = { an: eingabe.checked, offen: eingabe.checked && vorher.offen };
        try {
          newsletter = await newsletterSetzen(eingabe.checked);
          emailUebernehmen(newsletter.an);
          fehlerZeigen('');
          meldungZeigen(newsletter.an ? t('email_bestaetigen') : t('email_aus'));
        } catch (grund) {
          newsletter = vorher;
          fehlerZeigen(grund?.code === 'no_email' ? t('fehler_keine_email') : t('fehler_email'));
        } finally {
          newsletterLaeuft = false;
          eingabe.removeAttribute('aria-busy');
          anzeigen();
        }
        return;
      }

      const wert = eingabe.checked ? 'granted' : 'denied';
      if (eingabe.matches('[data-kanal]')) {
        const kanal = eingabe.dataset.kanal;
        zustand = geaendert(zustand, (z) => ({ ...z, channels: { ...z.channels, [kanal]: wert } }));
      } else if (eingabe.matches('[data-interesse]')) {
        const id = eingabe.dataset.interesse;
        zustand = geaendert(zustand, (z) => ({ ...z, interests: { ...z.interests, [id]: wert } }));
      } else {
        return;
      }
      anzeigen();
      planen();
    });

    // Fertig/Schließen: den entprellten Rest sofort schicken.
    wurzel.addEventListener(
      'close',
      () => {
        if (zeitgeber) senden().catch(() => {});
      },
      true,
    );

    /* ------------------------------------------------- Widerruf */

    wurzel.querySelector('[data-widerrufen]').addEventListener('click', async (e) => {
      const knopf = e.currentTarget;
      if (!zustand || knopf.getAttribute('aria-busy') === 'true') return;
      const fehler = wurzel.querySelector('[data-widerruf-fehler]');
      fehler.hidden = true;
      knopf.setAttribute('aria-busy', 'true');
      zustand = allesAblehnen(zustand, interessenIds);
      anzeigen();
      try {
        await senden();
        // Auch das Newsletter-Backend — sonst bliebe E-Mail an (Owner
        // 2026-09-11: „hier widerruft er nicht E-Mail").
        try {
          newsletter = await newsletterSetzen(false);
          emailUebernehmen(false);
        } catch {
          fehler.textContent = t('fehler_abbestellen');
          fehler.hidden = false;
        }
        anzeigen();
        wurzel.querySelector('[data-widerruf]').open = false;
        meldungZeigen(t('widerrufen_erledigt'));
      } catch {
        fehler.textContent = t('fehler_speichern');
        fehler.hidden = false;
      } finally {
        knopf.removeAttribute('aria-busy');
      }
    });

    /* ------------------------------------------------------ Start */

    (async () => {
      if (!api) return rueckfall();
      let daten;
      let profil = null;
      try {
        [daten, profil] = await Promise.all([
          api.lesen('/api/account/consents'),
          api.lesen('/api/account/profile').catch(() => null),
        ]);
      } catch {
        return rueckfall();
      }
      const gelesen = antwortLesen(daten);
      if (!gelesen.zustand) return rueckfall();
      zustand = zustandAus(gelesen.zustand);
      bestaetigt = zustand;
      newsletter = newsletterLesen(gelesen) ?? { an: false, offen: false };
      telefonBekannt = profil !== null;
      telefon = profil && typeof profil.phone === 'string' ? profil.phone.trim() || null : null;
      anzeigen();
      freigeben();
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["konto-bestelldetail"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('[data-bestellung]')) return;
    const wurzel = window.Shopify?.routes?.root || '/';

    // „Alle n Artikel anzeigen" / „Weniger anzeigen": ohne Skript stehen alle
    // Artikel da; mit Skript ab dem vierten eingeklappt.
    document.querySelectorAll('[data-bestellartikel-umschalten]').forEach((knopf) => {
      const liste = document.getElementById(knopf.getAttribute('aria-controls'));
      const text = knopf.querySelector('[data-bestellartikel-text]');
      if (!liste || !text) return;
      const setzen = (offen) => {
        liste.classList.toggle('is-gekuerzt', !offen);
        knopf.setAttribute('aria-expanded', String(offen));
        text.textContent = offen ? knopf.dataset.tWeniger : knopf.dataset.tMehr;
      };
      setzen(false);
      knopf.hidden = false;
      knopf.addEventListener('click', () => setzen(knopf.getAttribute('aria-expanded') !== 'true'));
    });

    // „Retournieren": den Link mit Token erst beim Klick holen
    // (window.hervisApi.retoure, assets/hervis-api.js) und im selben Tab
    // öffnen. Sonst den Grund nennen, bei „nicht verfügbar“ mit dem Weg zum
    // Kundenservice.
    const TEXT = {
      nicht_versendet: 'tNichtVersendet',
      zu_oft: 'tZuOft',
      nicht_verfuegbar: 'tNichtVerfuegbar',
      fehler: 'tFehler',
    };
    document.querySelectorAll('[data-retoure-bestellung]').forEach((knopf) => {
      const ansage = knopf.closest('[data-nachbestellen-box]')?.querySelector('[data-retoure-ansage]');
      const text = ansage?.querySelector('[data-retoure-ansage-text]');
      const kontakt = ansage?.querySelector('[data-retoure-kontakt]');
      const zeigen = (meldung, mitKontakt = false) => {
        if (text) text.textContent = meldung || '';
        if (kontakt) kontakt.hidden = !mitKontakt;
      };
      knopf.addEventListener('click', async () => {
        if (knopf.getAttribute('aria-busy') === 'true') return;
        const api = window.hervisApi;
        if (!api?.retoure) {
          zeigen(knopf.dataset.tNichtVerfuegbar, true);
          return;
        }
        knopf.setAttribute('aria-busy', 'true');
        zeigen(knopf.dataset.tLaeuft);
        const ergebnis = await api.retoure({ orderId: knopf.dataset.retoureBestellung });
        if (ergebnis.typ === 'ok') {
          location.assign(ergebnis.url);
          return;
        }
        knopf.removeAttribute('aria-busy');
        zeigen(knopf.dataset[TEXT[ergebnis.typ] || 'tFehler'], ergebnis.typ === 'nicht_verfuegbar');
      });
    });

    // „Erneut bestellen": alle noch lieferbaren Artikel in den Warenkorb.
    // Ein Sammelaufruf; scheitert er (ein Artikel ist ausverkauft), einzeln.
    // Was wirklich ankam, sagt der Vergleich des Warenkorbs vorher/nachher.
    const mengen = (warenkorb) => {
      const karte = new Map();
      (warenkorb?.items || []).forEach((posten) => {
        karte.set(posten.variant_id, (karte.get(posten.variant_id) || 0) + posten.quantity);
      });
      return karte;
    };
    const holen = async () => {
      const antwort = await fetch(`${wurzel}cart.js`, { headers: { Accept: 'application/json' } });
      if (!antwort.ok) throw new Error(String(antwort.status));
      return antwort.json();
    };
    const legen = (items) =>
      fetch(`${wurzel}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });

    document.addEventListener('submit', async (event) => {
      const formular = event.target.closest('[data-nachbestellen]');
      if (!formular) return;
      event.preventDefault();
      const knopf = formular.querySelector('[type="submit"]');
      if (knopf?.getAttribute('aria-busy') === 'true') return;
      const box = formular.closest('[data-nachbestellen-box]');
      const text = box?.querySelector('[data-nachbestellen-text]');
      const link = box?.querySelector('[data-nachbestellen-link]');
      const zeigen = (meldung, mitLink) => {
        if (text) text.textContent = meldung;
        if (link) link.hidden = !mitLink;
      };

      const gewuenscht = new Map();
      formular.dataset.nachbestellen.split(',').forEach((teil) => {
        const [id, menge] = teil.split(':').map(Number);
        if (id > 0 && menge > 0) gewuenscht.set(id, (gewuenscht.get(id) || 0) + menge);
      });
      const items = [...gewuenscht].map(([id, quantity]) => ({ id, quantity }));
      if (!items.length) return;

      knopf?.setAttribute('aria-busy', 'true');
      zeigen(formular.dataset.tLaeuft, false);
      try {
        const vorher = mengen(await holen());
        const sammel = await legen(items);
        if (!sammel.ok) {
          for (const posten of items) {
            await legen([posten]).catch(() => {});
          }
        }
        const nachher = await holen();
        const danach = mengen(nachher);
        let angekommen = 0;
        let fehlt = Number(formular.dataset.fehlend) || 0;
        gewuenscht.forEach((menge, id) => {
          const dazu = Math.max(0, (danach.get(id) || 0) - (vorher.get(id) || 0));
          angekommen += Math.min(dazu, menge);
          fehlt += Math.max(0, menge - dazu);
        });
        document.dispatchEvent(new CustomEvent('hervis:warenkorb', { detail: { item_count: nachher.item_count } }));
        if (angekommen === 0) throw new Error('nichts angekommen');
        if (fehlt === 0) zeigen(formular.dataset.tGelegt, true);
        else if (fehlt === 1) zeigen(formular.dataset.tEinsFehlt, true);
        else zeigen(formular.dataset.tFehlen.replace('%n', String(fehlt)), true);
      } catch {
        zeigen(formular.dataset.tFehler, false);
      } finally {
        knopf?.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["konto-meine-daten"] && !Shopify.designMode) return;
  try {
    (() => {
    const wurzel = document.querySelector('[data-meine-daten]');
    if (!wurzel) return;

    let texte = {};
    try {
      texte = JSON.parse(wurzel.querySelector('[data-meine-daten-texte]').textContent);
    } catch {}
    const t = (schluessel, werte = {}) => (texte[schluessel] || '').replace(/%(\w+)%/g, (_, name) => werte[name] ?? '');

    const api = window.hervisApi;
    const statusZeile = wurzel.querySelector('[data-meine-daten-status]');
    const ansagen = (text) => {
      statusZeile.textContent = '';
      requestAnimationFrame(() => (statusZeile.textContent = text));
    };

    /* ---------------------------------------------- Regeln aus der App */

    const ANREDEN = ['frau', 'herr', 'divers'];
    const istAnrede = (wert) => ANREDEN.includes(wert);

    // lib/birthday.ts: Mindestalter wie im Onboarding, Monatsnamen wie in AT.
    const MINDESTALTER = 10;
    const MONATE = [
      'Jänner',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ];
    const isoTeile = (iso) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
      return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
    };
    const datumKurz = (iso) => {
      const teile = isoTeile(iso);
      if (!teile) return '';
      const [j, m, d] = teile;
      return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${j}`;
    };
    const datumLang = (iso) => {
      const teile = isoTeile(iso);
      return teile ? `${teile[2]}. ${MONATE[teile[1] - 1]} ${teile[0]}` : '';
    };
    /* Lokale Kalendertage, nie UTC: ein Geburtstag ist ein Tag, kein
       Zeitpunkt. */
    const heuteIso = () => {
      const h = new Date();
      return `${h.getFullYear()}-${String(h.getMonth() + 1).padStart(2, '0')}-${String(h.getDate()).padStart(2, '0')}`;
    };
    const geburtstagProblem = (iso, unvollstaendig) => {
      if (unvollstaendig || !iso) return t('fehler_datum_unvollstaendig');
      const teile = isoTeile(iso);
      if (!teile) return t('fehler_datum_unvollstaendig');
      if (teile[0] < 1900) return t('fehler_datum_jahr');
      const heute = heuteIso();
      if (iso > heute) return t('fehler_datum_zukunft');
      const mitAlter = `${teile[0] + MINDESTALTER}${iso.slice(4)}`;
      if (mitAlter > heute) return t('fehler_datum_alter', { alter: MINDESTALTER });
      return null;
    };

    // lib/phone.ts: Vorwahlen EU + EFTA, gespeichert wird E.164.
    const VORWAHLEN = {
      AT: '43',
      DE: '49',
      BE: '32',
      BG: '359',
      CH: '41',
      CY: '357',
      CZ: '420',
      DK: '45',
      EE: '372',
      ES: '34',
      FI: '358',
      FR: '33',
      GR: '30',
      HR: '385',
      HU: '36',
      IE: '353',
      IS: '354',
      IT: '39',
      LI: '423',
      LT: '370',
      LU: '352',
      LV: '371',
      MT: '356',
      NL: '31',
      NO: '47',
      PL: '48',
      PT: '351',
      RO: '40',
      SE: '46',
      SI: '386',
      SK: '421',
    };
    const BEISPIELE = { AT: '0660 1234567', DE: '0151 23456789' };
    const ERLAUBT = /^[0-9+()/.\-\s]*$/;
    // Längste Vorwahl zuerst — „+423" ist Liechtenstein, nicht „+42".
    const NACH_LAENGE = Object.entries(VORWAHLEN).sort((a, b) => b[1].length - a[1].length);

    const vorwahlLesen = (roh, land) => {
      const getrimmt = roh.trim();
      const rest = getrimmt.startsWith('+') ? getrimmt.slice(1) : getrimmt.startsWith('00') ? getrimmt.slice(2) : null;
      if (rest === null) return { land, national: roh };
      const ziffern = rest.replace(/\D/g, '');
      const treffer = NACH_LAENGE.find(([, vorwahl]) => ziffern.startsWith(vorwahl));
      if (!treffer) return { land, national: roh, unbekannt: true };
      let gesehen = 0;
      let i = 0;
      while (i < rest.length && gesehen < treffer[1].length) {
        if (/\d/.test(rest[i])) gesehen += 1;
        i += 1;
      }
      return { land: treffer[0], national: rest.slice(i).trim() };
    };
    const nationaleZiffern = (national) => national.replace(/\(0\)/g, '').replace(/\D/g, '');
    const zuE164 = (land, national) => {
      const vorwahl = VORWAHLEN[land];
      if (!vorwahl || /^\s*(\+|00)/.test(national)) return null;
      let ziffern = nationaleZiffern(national);
      // Die eine führende Null fällt weg — außer in Italien.
      if (land !== 'IT') ziffern = ziffern.replace(/^0/, '');
      return ziffern ? `+${vorwahl}${ziffern}` : null;
    };
    const telefonProblem = (land, national) => {
      if (!ERLAUBT.test(national)) return t('tel_zeichen');
      if (nationaleZiffern(national).length < 4) return t('tel_kurz');
      const e164 = zuE164(land, national);
      if (!e164) return t('tel_format');
      if (e164.length > 16) return t('tel_lang');
      if (!/^\+[1-9]\d{6,14}$/.test(e164)) return t('tel_format');
      return null;
    };
    const e164Teilen = (e164) => {
      if (!/^\+\d{2,}$/.test(e164 || '')) return null;
      const ziffern = e164.slice(1);
      const treffer = NACH_LAENGE.find(([, vorwahl]) => ziffern.startsWith(vorwahl));
      return treffer ? { land: treffer[0], national: ziffern.slice(treffer[1].length) } : null;
    };
    const telefonAnzeige = (e164) => {
      if (!e164) return '';
      const teile = e164Teilen(e164);
      if (!teile) return e164;
      const { land, national: n } = teile;
      let block = 3;
      if (land === 'AT' && n.startsWith('1')) block = 1;
      if (land === 'DE' && /^(30|40|69|89)/.test(n)) block = 2;
      const vorwahl = VORWAHLEN[land];
      return n.length <= block ? `+${vorwahl} ${n}` : `+${vorwahl} ${n.slice(0, block)} ${n.slice(block)}`;
    };
    // Getippt wird mit der Null, gespeichert ohne sie (außer IT).
    const nationalFuersFeld = (land, national) =>
      land === 'IT' || national.startsWith('0') ? national : `0${national}`;

    /* ------------------------------------------------ Stand und Zeilen */

    const zeilen = new Map([...document.querySelectorAll('[data-feld]')].map((zeile) => [zeile.dataset.feld, zeile]));
    let stand = null;

    const zeigen = (feld, wert, einladung = false) => {
      const zelle = zeilen.get(feld)?.querySelector('[data-feld-wert]');
      if (!zelle) return;
      zelle.textContent = wert;
      zelle.classList.toggle('konto-zeile__wert--aktion', einladung);
    };
    const anzeigen = () => {
      const anrede = istAnrede(stand.salutation) ? t(stand.salutation) : '';
      zeigen('anrede', anrede || t('hinzufuegen'), !anrede);
      const geburtstag = datumKurz(stand.birthday);
      zeigen('geburtstag', geburtstag || t('hinzufuegen'), !geburtstag);
      const telefon = telefonAnzeige(stand.phone);
      zeigen('telefon', telefon || t('hinzufuegen'), !telefon);
    };
    const freigeben = () => {
      for (const [feld, zeile] of zeilen) {
        zeile.dataset.oeffnet = `daten-${feld}`;
        zeile.removeAttribute('aria-disabled');
      }
    };
    /* Kein Backend: dieselbe ehrliche Übergabe an die App wie vorher
       (snippets/app-einladung.liquid hört auf data-app-invite). */
    const zurApp = () => {
      for (const [feld, zeile] of zeilen) {
        zeigen(feld, t('in_der_app'));
        delete zeile.dataset.oeffnet;
        zeile.dataset.appInvite = 'daten';
        zeile.dataset.appPfad = '/account/data';
        zeile.dataset.appTopic = t('thema_daten');
        zeile.dataset.appHinweis = t('hinweis_daten');
        zeile.removeAttribute('aria-disabled');
      }
    };
    const standAus = (profil) => ({
      salutation: istAnrede(profil.salutation) ? profil.salutation : null,
      birthday: typeof profil.birthday === 'string' ? profil.birthday : null,
      phone: typeof profil.phone === 'string' ? profil.phone.trim() || null : null,
    });

    /* ------------------------------------------------------ Dialoge */

    const formular = (feld) => wurzel.querySelector(`[data-daten-form="${feld}"]`);

    const fehlerZeigen = (form, text, ziel) => {
      const zeile = form.querySelector('[data-fehler]');
      zeile.querySelector('[data-text]').textContent = text || '';
      zeile.hidden = !text;
      const eingabe = form.querySelector('[data-eingabe]');
      if (eingabe && text) eingabe.setAttribute('aria-invalid', 'true');
      if (eingabe && !text) eingabe.removeAttribute('aria-invalid');
      if (text) (ziel || eingabe)?.focus();
    };

    const entfernenZuruecksetzen = (form, sichtbar) => {
      const bereich = form.querySelector('[data-entfernen-bereich]');
      if (!bereich) return;
      bereich.hidden = !sichtbar;
      bereich.querySelector('[data-entfernen]').hidden = false;
      bereich.querySelector('[data-entfernen-frage]').hidden = true;
    };

    const telefonVorschau = (form) => {
      const land = form.querySelector('[data-land]').value;
      const national = form.querySelector('[data-eingabe]').value;
      const vorschau = form.querySelector('[data-vorschau]');
      const e164 = zuE164(land, national);
      if (nationaleZiffern(national).length >= 4 && e164) {
        vorschau.textContent = t('gespeichert_wird', { wert: telefonAnzeige(e164) });
      } else if (!national.trim() && stand.phone && !e164Teilen(stand.phone)) {
        vorschau.textContent = t('gespeichert_fremd', { nummer: stand.phone });
      } else {
        vorschau.textContent = '';
      }
      const beispiel = BEISPIELE[land];
      form.querySelector('[data-eingabe]').placeholder = beispiel ? t('beispiel', { nummer: beispiel }) : '';
    };

    // Nur ein Datum, das auch gespeichert würde.
    const geburtstagVorschau = (form) => {
      const eingabe = form.querySelector('[data-eingabe]');
      const gueltig = eingabe.value && !geburtstagProblem(eingabe.value, eingabe.validity.badInput);
      form.querySelector('[data-vorschau]').textContent = gueltig
        ? t('gespeichert_wird', { wert: datumLang(eingabe.value) })
        : '';
    };

    /* Beim Öffnen den gelesenen Stand eintragen — hervis.js öffnet den
       Dialog (data-oeffnet), dieser Klick-Lauscher füllt ihn im selben Takt. */
    const vorbereiten = (feld) => {
      const form = formular(feld);
      if (!form || !stand) return;
      fehlerZeigen(form, '');
      form.removeAttribute('aria-busy');
      let fokus = form.querySelector('[data-eingabe]');
      if (feld === 'anrede') {
        for (const radio of form.querySelectorAll('input[name="salutation"]')) {
          radio.checked = radio.value === stand.salutation;
        }
        fokus = form.querySelector('input:checked') || form.querySelector('input[name="salutation"]');
      }
      if (feld === 'geburtstag') {
        fokus.value = stand.birthday || '';
        fokus.max = heuteIso();
        geburtstagVorschau(form);
        entfernenZuruecksetzen(form, Boolean(stand.birthday));
      }
      if (feld === 'telefon') {
        const teile = stand.phone ? e164Teilen(stand.phone) : null;
        form.querySelector('[data-land]').value = teile ? teile.land : 'AT';
        fokus.value = teile ? nationalFuersFeld(teile.land, teile.national) : '';
        telefonVorschau(form);
        entfernenZuruecksetzen(form, Boolean(stand.phone));
      }
      // Erst wenn der Dialog offen ist (hervis.js öffnet ihn im selben Klick).
      requestAnimationFrame(() => fokus?.focus());
    };

    document.addEventListener('click', (e) => {
      const zeile = e.target.closest('[data-feld]');
      if (zeile && zeile.dataset.oeffnet) vorbereiten(zeile.dataset.feld);
    });

    // Die Vorwahl gehört in die Wahl: „Deutschland +49" (App: Flagge + Vorwahl).
    for (const option of wurzel.querySelectorAll('[data-land] option')) {
      const vorwahl = VORWAHLEN[option.value];
      if (vorwahl) option.textContent = `${option.textContent} +${vorwahl}`;
    }

    wurzel.addEventListener('input', (e) => {
      const form = e.target.closest('[data-daten-form]');
      if (!form) return;
      if (form.dataset.datenForm === 'telefon') {
        const eingabe = form.querySelector('[data-eingabe]');
        const wahl = form.querySelector('[data-land]');
        // Eingefügte oder mitgetippte Vorwahl stellt die Wahl um.
        if (e.target === eingabe && /^\s*(\+|00)/.test(eingabe.value)) {
          const gelesen = vorwahlLesen(eingabe.value, wahl.value);
          if (!gelesen.unbekannt) {
            wahl.value = gelesen.land;
            eingabe.value = gelesen.national;
          }
        }
        telefonVorschau(form);
      }
      if (form.dataset.datenForm === 'geburtstag') geburtstagVorschau(form);
      if (!form.querySelector('[data-fehler]').hidden) fehlerZeigen(form, '');
    });

    /* Fehlertext je Feld und Server-Code (lib/profile-api.ts). Nur 401 heißt
       „nicht angemeldet"; Status 0 ist das Netz. */
    const fehlerText = (feld, fehler, entfernen = false) => {
      if (fehler?.status === 0) return t('fehler_verbindung');
      if (fehler?.status === 401) return t('fehler_sitzung');
      const code = fehler?.code;
      if (feld === 'anrede') return code === 'invalid_salutation' ? t('fehler_anrede_wahl') : t('fehler_anrede');
      if (feld === 'geburtstag') {
        if (entfernen) return t('fehler_geburtstag_entfernen');
        return code === 'invalid_birthday' ? t('fehler_datum_ungueltig') : t('fehler_geburtstag');
      }
      if (entfernen) return t('fehler_telefon_entfernen');
      if (code === 'invalid_phone') return t('tel_ungueltig');
      if (code === 'phone_taken') return t('tel_vergeben');
      return t('fehler_telefon');
    };

    /* Was gespeichert werden soll — oder warum nicht. */
    const pruefen = (feld, form) => {
      if (feld === 'anrede') {
        const wahl = form.querySelector('input[name="salutation"]:checked');
        return wahl ? { wert: wahl.value } : { fehler: t('fehler_anrede_wahl') };
      }
      // Ein leeres Feld ist keine Änderung — Entfernen ist ein eigener Knopf.
      if (feld === 'geburtstag') {
        const eingabe = form.querySelector('[data-eingabe]');
        if (!eingabe.value && !eingabe.validity.badInput) return { wert: stand.birthday };
        const problem = geburtstagProblem(eingabe.value, eingabe.validity.badInput);
        return problem ? { fehler: problem } : { wert: eingabe.value };
      }
      const land = form.querySelector('[data-land]').value;
      const national = form.querySelector('[data-eingabe]').value;
      if (!national.trim()) return { wert: stand.phone };
      const gelesen = vorwahlLesen(national, land);
      if (gelesen.unbekannt) return { fehler: t('tel_vorwahl') };
      const problem = telefonProblem(land, national);
      return problem ? { fehler: problem } : { wert: zuE164(land, national) };
    };

    const SCHLUESSEL = { anrede: 'salutation', geburtstag: 'birthday', telefon: 'phone' };

    /* Die Antwort ist die Wahrheit (lib/profile-api.ts) — bis auf die Nummer:
       echot das Backend sie nicht, kennt es das Feld noch nicht, und die
       gesendete Nummer bleibt mit Hinweis stehen (savePhone, 'unsupported'). */
    const uebernehmen = (feld, antwort, gesendet) => {
      const neu = standAus(antwort || {});
      if (feld === 'telefon') {
        stand.phone = gesendet;
        return neu.phone === gesendet;
      }
      stand[SCHLUESSEL[feld]] = neu[SCHLUESSEL[feld]];
      return true;
    };

    /* Ein Kanal ohne Nummer ist nicht zustellbar: SMS und WhatsApp gehen mit
       der Nummer aus (app/account/phone.tsx). Voll-Replace wie
       lib/consents.ts — der Serverstand mit den zwei Kanälen auf „denied". */
    const einwilligungen = async () => {
      const daten = await api.lesen('/api/account/consents');
      const zustand =
        daten && typeof daten.consents === 'object' && !Array.isArray(daten.consents) ? daten.consents : null;
      return zustand && typeof zustand.channels === 'object' ? zustand : null;
    };
    const kanaeleAus = async (zustand) => {
      const kanaele = { ...zustand.channels };
      for (const kanal of ['sms', 'whatsapp']) if (kanaele[kanal] === 'granted') kanaele[kanal] = 'denied';
      await api.schreiben('/api/account/consents', {
        consents: {
          purposes: {},
          interests: {},
          seeded: false,
          ...zustand,
          channels: kanaele,
          v: 1,
          updatedAt: new Date().toISOString(),
        },
      });
    };
    const telefonKanaeleAn = (zustand) =>
      Boolean(zustand) && ['sms', 'whatsapp'].some((kanal) => zustand.channels[kanal] === 'granted');

    let laeuft = false;
    const speichern = async (form, feld, wert, entfernen = false) => {
      if (laeuft) return;
      laeuft = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const zustand = entfernen && feld === 'telefon' ? await einwilligungen().catch(() => null) : null;
        const antwort = await api.schreiben('/api/account/profile', { [SCHLUESSEL[feld]]: wert });
        const bestaetigt = uebernehmen(feld, antwort, wert);
        if (telefonKanaeleAn(zustand)) await kanaeleAus(zustand).catch(() => {});
        anzeigen();
        form.closest('dialog').close();
        ansagen(entfernen ? t('entfernt') : bestaetigt ? t('gespeichert') : t('telefon_abgleich'));
      } catch (fehler) {
        fehlerZeigen(
          form,
          fehlerText(feld, fehler, entfernen),
          entfernen ? form.querySelector('[data-entfernen-ja]') : null,
        );
      } finally {
        laeuft = false;
        form.removeAttribute('aria-busy');
      }
    };

    wurzel.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-daten-form]');
      if (!form) return;
      e.preventDefault();
      if (!stand) return;
      const feld = form.dataset.datenForm;
      const ergebnis = pruefen(feld, form);
      if (ergebnis.fehler) {
        fehlerZeigen(form, ergebnis.fehler, feld === 'anrede' ? form.querySelector('input[name="salutation"]') : null);
        return;
      }
      // Nichts geändert: nur schließen, kein Schreiben an BSI.
      if (ergebnis.wert === stand[SCHLUESSEL[feld]]) {
        form.closest('dialog').close();
        return;
      }
      speichern(form, feld, ergebnis.wert);
    });

    wurzel.addEventListener('click', async (e) => {
      const form = e.target.closest('[data-daten-form]');
      if (!form) return;
      const bereich = form.querySelector('[data-entfernen-bereich]');
      if (e.target.closest('[data-entfernen]')) {
        bereich.querySelector('[data-entfernen]').hidden = true;
        bereich.querySelector('[data-entfernen-frage]').hidden = false;
        bereich.querySelector('[data-entfernen-nein]').focus();
        // Die Folge nur nennen, wenn es sie gibt: ohne aktive Kanäle wäre der
        // Satz eine Drohung ins Leere.
        const folge = bereich.querySelector('[data-entfernen-folge]');
        if (folge) folge.hidden = !telefonKanaeleAn(await einwilligungen().catch(() => null));
      }
      if (e.target.closest('[data-entfernen-nein]')) {
        entfernenZuruecksetzen(form, true);
        bereich.querySelector('[data-entfernen]').focus();
      }
      if (e.target.closest('[data-entfernen-ja]')) speichern(form, form.dataset.datenForm, null, true);
    });

    /* ------------------------------------- Auskunft und Löschantrag */

    /* Mit Backend gehen beide Anträge dorthin wie in der App
       (POST /api/account/data-request, /api/account/delete — das Backend
       legt keinen zweiten Antrag an). Ohne Backend bleibt es beim
       Kontaktformular. Das Häkchen beim Löschen prüft der Browser vor dem
       submit-Ereignis (required). */
    const ANTRAEGE = { auskunft: '/api/account/data-request', loeschen: '/api/account/delete' };
    const antraegeVerbinden = () => {
      document.addEventListener('submit', async (e) => {
        const form = e.target.closest('form[data-antrag]');
        if (!form || !ANTRAEGE[form.dataset.antrag]) return;
        e.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        const fehler = form.querySelector('[data-antrag-fehler]');
        fehler.hidden = true;
        form.setAttribute('aria-busy', 'true');
        try {
          await api.schreiben(ANTRAEGE[form.dataset.antrag]);
          const vorlage = wurzel.querySelector('[data-antrag-erfolg]').content.firstElementChild.cloneNode(true);
          vorlage.querySelector('[data-text]').textContent = t(`antrag_${form.dataset.antrag}_danke`);
          form.querySelector('details').replaceWith(vorlage);
          vorlage.focus({ preventScroll: true });
        } catch (grund) {
          fehler.textContent = grund?.status === 0 ? t('fehler_verbindung') : t('antrag_fehler');
          fehler.hidden = false;
        } finally {
          form.removeAttribute('aria-busy');
        }
      });
    };

    /* ------------------------------------------------------ Start */

    (async () => {
      if (!api) return zurApp();
      try {
        stand = standAus(await api.lesen('/api/account/profile'));
      } catch {
        return zurApp();
      }
      anzeigen();
      freigeben();
      antraegeVerbinden();
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["konto-sendung"] && !Shopify.designMode) return;
  try {
    (() => {
    // Sendungsnummer kopieren — und höflich ansagen. Ohne Zwischenablage
    // (alter Browser, unsicherer Kontext) wird die Nummer markiert.
    if (!document.querySelector('[data-sendung-kopieren]')) return;
    const HAKEN_DAUER = 2000;
    document.addEventListener('click', async (event) => {
      const knopf = event.target.closest('[data-sendung-kopieren]');
      if (!knopf) return;
      const block = knopf.closest('.sendung__nummer');
      const feld = block?.querySelector('[data-sendungsnummer]');
      const ansage = block?.querySelector('[data-sendung-ansage]');
      if (!feld) return;
      const sagen = (text) => {
        if (!ansage) return;
        ansage.textContent = '';
        window.setTimeout(() => {
          ansage.textContent = text;
        }, 50);
      };
      try {
        await navigator.clipboard.writeText(feld.textContent.trim());
        sagen(knopf.dataset.kopiert || '');
        knopf.dataset.ok = '';
        window.clearTimeout(knopf.hakenZeit);
        knopf.hakenZeit = window.setTimeout(() => delete knopf.dataset.ok, HAKEN_DAUER);
      } catch {
        const bereich = document.createRange();
        bereich.selectNodeContents(feld);
        const auswahl = window.getSelection();
        auswahl?.removeAllRanges();
        auswahl?.addRange(bereich);
        sagen(knopf.dataset.fehler || '');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kopf-profil"] && !Shopify.designMode) return;
  try {
    (() => {
    const MENUE = '[data-profil-menue]';

    if (document.querySelector(MENUE)) {
      const schliessen = (menue) => {
        menue.open = false;
      };
      const modalOffen = () => !!document.querySelector('dialog[open]:modal');

      // Klick daneben schließt — außer der Klick gilt einem offenen Dialog.
      document.addEventListener('click', (event) => {
        if (event.target.closest(MENUE) || event.target.closest('dialog')) return;
        document.querySelectorAll(`${MENUE}[open]`).forEach(schliessen);
      });

      // Esc schließt und gibt den Fokus an den Knopf zurück. Ist ein modaler
      // Dialog offen, schließt Esc nur diesen (nativ).
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || modalOffen()) return;
        document.querySelectorAll(`${MENUE}[open]`).forEach((menue) => {
          schliessen(menue);
          menue.querySelector('summary')?.focus();
        });
      });

      document.querySelectorAll(MENUE).forEach((menue) => {
        // Tab aus dem Panel heraus schließt es.
        menue.addEventListener('focusout', (event) => {
          const ziel = event.relatedTarget;
          if (!ziel || menue.contains(ziel) || ziel.closest('dialog')) return;
          schliessen(menue);
        });
      });

      // Öffnet ein Mega-Menü, geht das Flyout zu (nie zwei Panels übereinander).
      document.addEventListener(
        'toggle',
        (event) => {
          if (!event.target.matches?.('.desktop-mega') || !event.target.open) return;
          document.querySelectorAll(`${MENUE}[open]`).forEach(schliessen);
        },
        true,
      );
    }

    // „n gemerkt" — so viele Einträge, wie der Merkliste-Dialog zeigt: Handles
    // aus „hervis-shop-merkliste", die Inhalte in „…-inhalte" haben.
    if (!document.querySelector('[data-merkliste-gemerkt]')) return;
    const SCHLUESSEL = 'hervis-shop-merkliste';
    const INHALTE = 'hervis-shop-merkliste-inhalte';
    const zaehlen = () => {
      let anzahl = 0;
      try {
        const liste = JSON.parse(localStorage.getItem(SCHLUESSEL) || '[]');
        const inhalte = JSON.parse(localStorage.getItem(INHALTE) || '{}') || {};
        anzahl = Array.isArray(liste) ? liste.filter((handle) => inhalte[handle]).length : 0;
      } catch {
        anzahl = 0;
      }
      document.querySelectorAll('[data-merkliste-gemerkt]').forEach((wert) => {
        wert.textContent = anzahl > 0 ? (wert.dataset.vorlage || '%n').replace('%n', anzahl) : '';
        wert.hidden = anzahl === 0;
      });
    };
    document.addEventListener('hervis:merkliste', zaehlen);
    window.addEventListener('storage', (event) => {
      if (event.key === SCHLUESSEL || event.key === INHALTE) zaehlen();
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) zaehlen();
    });
    zaehlen();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kopf-suche"] && !Shopify.designMode) return;
  try {
    (() => {
    const verlaufKey = 'hervis-shop-suchverlauf';
    const gesehenKey = 'hervis-shop-zuletzt';
    if (!document.querySelector('[data-kopfsuche]') && !window.Shopify?.designMode) return;

    // Handy-Unterseiten: [Zurück] [Logo] [Pille] [Warenkorb] lassen der Pille
    // wenig Platz — dort „Suchen" statt eines abgeschnittenen „Wonach such…"
    // (Codex-Durchsicht 2026-10-12). Besucher von außen haben keinen Zurück-Kreis.
    const feldKurz = document.querySelector('#kopf-suche[data-platzhalter-kurz]');
    if (feldKurz) {
      const lang = feldKurz.placeholder;
      const handy = window.matchMedia('(max-width: 48rem)');
      const eng = () =>
        handy.matches && feldKurz.closest('.desktop-kopf--unter') && !('einstieg' in document.documentElement.dataset);
      const setze = () => {
        feldKurz.placeholder = eng() ? feldKurz.dataset.platzhalterKurz : lang;
      };
      setze();
      handy.addEventListener('change', setze);
    }

    function lesen(key) {
      try {
        const wert = JSON.parse(localStorage.getItem(key));
        return Array.isArray(wert) ? wert : [];
      } catch {
        return [];
      }
    }
    function schreiben(key, wert) {
      try {
        localStorage.setItem(key, JSON.stringify(wert));
      } catch {}
    }
    function merken(begriff) {
      const q = typeof begriff === 'string' ? begriff.trim() : '';
      if (q) schreiben(verlaufKey, [q, ...lesen(verlaufKey).filter((s) => s !== q)].slice(0, 6));
    }
    const text = (wert) => (typeof wert === 'string' ? wert.trim() : '');
    // Nur Pfade dieses Shops, nie fremde Ziele aus dem Speicher.
    const pfad = (url) => (typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') ? url : '');
    // Wie snippets/zuletzt-angesehen.liquid: Handle, bei alten Einträgen aus der URL.
    function handle(eintrag) {
      if (text(eintrag.handle)) return text(eintrag.handle);
      const treffer = /\/products\/([^/?#]+)/.exec(pfad(eintrag.url));
      return treffer ? decodeURIComponent(treffer[1]) : '';
    }

    // Marken (WP21): Groß/klein und Akzente egal, wie die App („loffler" → Löffler).
    const falten = (wert) =>
      text(wert)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]/gi, '')
        .toLowerCase();
    // Die Zeilen von Marken A–Z (nur Marken mit Ware, Ziel aus marke-url),
    // einmal pro Sitzung geholt und im sessionStorage gehalten.
    const markenKey = 'hervis-shop-marken';
    let markenDaten = null;
    let markenAnfrage = null;
    function markenLaden(quelle) {
      if (markenDaten) return Promise.resolve(markenDaten);
      if (markenAnfrage) return markenAnfrage;
      try {
        const gemerkt = JSON.parse(sessionStorage.getItem(markenKey));
        if (Array.isArray(gemerkt) && gemerkt.length) {
          markenDaten = gemerkt;
          return Promise.resolve(markenDaten);
        }
      } catch {}
      if (!pfad(quelle)) return Promise.resolve([]);
      markenAnfrage = fetch(quelle)
        .then((antwort) => {
          if (!antwort.ok) throw new Error('marken ' + antwort.status);
          return antwort.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          markenDaten = [...doc.querySelectorAll('a[data-marke]')]
            .map((a) => ({
              name: text(a.dataset.marke),
              url: pfad(a.getAttribute('href')),
              zahl: Number(a.dataset.zahl) || 0,
            }))
            .filter((m) => m.name && m.url);
          try {
            sessionStorage.setItem(markenKey, JSON.stringify(markenDaten));
          } catch {}
          return markenDaten;
        })
        .catch(() => {
          markenAnfrage = null;
          return [];
        });
      return markenAnfrage;
    }
    // Pause nach dem letzten Tastendruck, bevor die Vorschläge geholt werden.
    const PAUSE = 150; // ms
    // Shopify-CDN skaliert über ?width= — nie das 2048-px-Original laden.
    function bild(src, breite) {
      if (!text(src)) return '';
      try {
        const url = new URL(src, location.href);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
        url.searchParams.set('width', breite);
        return url.href;
      } catch {
        return '';
      }
    }
    const waehrung = window.Shopify?.currency?.active || 'EUR';
    let format;
    try {
      format = new Intl.NumberFormat('de-AT', { style: 'currency', currency: waehrung });
    } catch {
      format = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });
    }
    // „74.99" aus der Predictive Search → „€ 74,99" wie snippets/preis.liquid.
    const preis = (wert) => {
      const zahl = Number.parseFloat(wert);
      return Number.isFinite(zahl) ? format.format(zahl) : '';
    };

    function element(tag, klasse, inhalt) {
      const el = document.createElement(tag);
      if (klasse) el.className = klasse;
      if (inhalt) el.textContent = inhalt;
      return el;
    }
    function platte(src, breite) {
      const div = element('div', 'produkt-platte');
      const url = bild(src, breite);
      if (url) {
        const img = element('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = breite;
        img.height = breite;
        div.append(img);
      }
      return div;
    }

    const steuerung = new Map();
    function init(bereich) {
      bereich.querySelectorAll('[data-kopfsuche]').forEach((form) => {
        if (steuerung.has(form)) return;
        const abbruch = new AbortController();
        const hoeren = (ziel, ereignis, rueckruf) =>
          ziel.addEventListener(ereignis, rueckruf, { signal: abbruch.signal });
        const kopf = form.closest('[data-header]');
        const input = form.querySelector('[name=q]');
        const panel = form.querySelector('.kopfsuche__panel');
        const start = form.querySelector('[data-search-start]');
        const ergebnisse = form.querySelector('[data-search-results]');
        const status = form.querySelector('[data-search-status]');
        const treffer = form.querySelector('[data-search-products]');
        // Zwei Schließen-Knöpfe: × in der Pille (Desktop), Zurück-Kreis (Handy).
        const schliessen = [...form.querySelectorAll('[data-search-close]')];
        if (!input || !panel || !start || !ergebnisse || !status || !treffer || !schliessen.length) return;
        const leeren = form.querySelector('[data-search-leeren]');
        const handy = matchMedia('(max-width: 48rem)');
        // Was am Handy hinter der offenen Ebene liegt und solange inert ist.
        let gesperrt = [];
        const markenBlock = form.querySelector('[data-marken-block]');
        const markenTreffer = form.querySelector('[data-search-brands]');
        const markenIcon = form.querySelector('[data-marke-icon]');
        let anfrage = null;
        let warte = 0;
        // Suchbegriff, dessen Treffer gerade im Panel stehen.
        let gezeigt = '';
        let fokusZurueck = false;
        const sortiment = () => kopf?.querySelector('.desktop-kopf__nav');
        const feldFokus = () => {
          fokusZurueck = true;
          input.focus({ preventScroll: true });
          fokusZurueck = false;
        };
        function abbrechen() {
          clearTimeout(warte);
          anfrage?.abort();
          anfrage = null;
        }

        const suchUrl = (q) => {
          const url = new URL(form.action, location.href);
          url.searchParams.set('q', q);
          url.searchParams.set('type', 'product');
          return url.pathname + url.search;
        };

        function einstieg() {
          const verlauf = form.querySelector('[data-recent-searches]');
          verlauf.replaceChildren(
            ...lesen(verlaufKey)
              .filter((q) => text(q))
              .slice(0, 6)
              .map((q) => {
                const li = element('li');
                const a = element('a', 'chip', text(q));
                a.href = suchUrl(text(q));
                a.dataset.searchTerm = text(q);
                li.append(a);
                return li;
              }),
          );
          form.querySelector('[data-recent-block]').hidden = !verlauf.children.length;

          const gesehen = form.querySelector('[data-viewed-products]');
          // Auf der Produktseite nicht das Produkt zeigen, das gerade offen ist.
          const offen = text(document.querySelector('[data-zuletzt-aufzeichnen]')?.dataset.handle);
          const handles = new Set();
          const karten = [];
          for (const e of lesen(gesehenKey)) {
            if (karten.length >= 12) break;
            if (!e || typeof e !== 'object' || !pfad(e.url) || !text(e.title)) continue;
            const schluessel = handle(e) || pfad(e.url).split('?')[0];
            if (handles.has(schluessel) || schluessel === offen) continue;
            handles.add(schluessel);
            const li = element('li');
            const a = element('a', 'kopfsuche__karte');
            a.href = pfad(e.url);
            a.append(platte(e.image, 240));
            const marke = text(e.vendor || e.brand);
            if (marke) a.append(element('span', 'kopfsuche__marke', marke));
            a.append(element('span', 'kopfsuche__name', text(e.title)));
            if (text(e.preis)) a.append(element('span', 'kopfsuche__preis', text(e.preis)));
            li.append(a);
            karten.push(li);
          }
          gesehen.replaceChildren(...karten);
          form.querySelector('[data-viewed-block]').hidden = !karten.length;

          // Marken-Zeile erst beim ersten Öffnen einsetzen (Logos laden dann).
          if (markenBlock?.hidden) {
            const vorlage = markenBlock.querySelector('[data-marken-vorlage]');
            const liste = markenBlock.querySelector('[data-marken-liste]');
            if (vorlage && liste) {
              liste.append(vorlage.content.cloneNode(true));
              markenBlock.hidden = false;
            }
          }
          // Markenvorschläge schon holen, während man noch nicht tippt.
          if (markenTreffer) markenLaden(markenTreffer.dataset.quelle);
        }

        function markeZeile(m, q) {
          const li = element('li');
          const a = element('a');
          a.href = m.url;
          a.dataset.searchTerm = m.name;
          const etikett = element('span', 'kopfsuche__etikett');
          if (markenIcon) etikett.append(markenIcon.content.cloneNode(true));
          const txt = element('span', 'kopfsuche__treffer-text');
          txt.append(element('span', 'kopfsuche__name', m.name));
          txt.append(element('span', 'kopfsuche__unterzeile', markenTreffer.dataset.marke));
          a.append(etikett, txt);
          li.append(a);
          return li;
        }
        // Höchstens 3 Marken, deren Name (oder ein Wort darin) mit dem Begriff
        // beginnt; ganzer Name vor Wortanfang, dann die größere Marke zuerst.
        function markenZeigen(q) {
          if (!markenTreffer) return;
          const fq = falten(q);
          if (fq.length < 2 || !markenDaten) {
            markenTreffer.replaceChildren();
            return;
          }
          const passend = markenDaten
            .map((m) => {
              const woerter = m.name.split(/[\s\-\/&]+/).map(falten);
              let rang = -1;
              if (falten(m.name).startsWith(fq)) rang = 0;
              else if (woerter.some((w) => w.startsWith(fq))) rang = 1;
              return { m, rang };
            })
            .filter((x) => x.rang >= 0)
            .sort((x, y) => x.rang - y.rang || y.m.zahl - x.m.zahl)
            .slice(0, 3);
          markenTreffer.replaceChildren(...passend.map(({ m }) => markeZeile(m, q)));
        }

        // Handy: die Ebene beginnt an der Unterkante der Kopfzeile (oben am
        // Seitenanfang liegen App-Leiste und Laufband darüber).
        function ebeneMessen() {
          if (!kopf || !handy.matches || form.dataset.open !== 'true') return;
          const oben = Math.max(0, Math.round(kopf.getBoundingClientRect().bottom));
          panel.style.setProperty('--suche-oben', `${oben}px`);
        }
        // Handy: die Suche belegt den unteren Platz (Tab-Leiste weicht), alles
        // außerhalb des Kopfs ist inert, solange die Ebene offen ist.
        function sperren() {
          if (!handy.matches) return;
          form.dataset.slotBelegt = '';
          ebeneMessen();
          const block = form.closest('.shopify-section') || form;
          gesperrt = [...document.body.children].filter(
            (el) =>
              !el.contains(block) &&
              !el.inert &&
              !/^(SCRIPT|STYLE|TEMPLATE|LINK|DIALOG)$/.test(el.tagName) &&
              !el.id.startsWith('shopify-pc'),
          );
          gesperrt.forEach((el) => (el.inert = true));
        }
        function entsperren() {
          delete form.dataset.slotBelegt;
          gesperrt.forEach((el) => (el.inert = false));
          gesperrt = [];
        }
        const leerenZeigen = () => {
          if (leeren) leeren.hidden = !input.value;
        };

        function oeffnen(mitSuche = true) {
          if (fokusZurueck || form.dataset.open === 'true') return;
          form.dataset.open = 'true';
          if (kopf) kopf.dataset.searchOpen = 'true';
          panel.inert = false;
          schliessen.forEach((knopf) => (knopf.tabIndex = 0));
          sperren();
          leerenZeigen();
          // Solange die Suche offen ist, reagiert die Kategorienzeile nicht
          // (kein Mega-Panel per Hover unter dem Suchpanel); offene Panels zu.
          const nav = sortiment();
          if (nav && !nav.contains(form)) nav.inert = true;
          kopf?.querySelectorAll('details[open]').forEach((d) => {
            if (!d.contains(form)) d.open = false;
          });
          einstieg();
          // Stehen die Treffer zum Feld schon da, nicht neu holen: die Antwort
          // ersetzte sonst die Zeile, auf der die Tastatur gerade steht.
          if (mitSuche && input.value.trim() !== gezeigt) suchen();
        }
        function zumachen(fokus = false) {
          abbrechen();
          if (form.dataset.open !== 'true') return;
          form.dataset.open = 'false';
          if (kopf) kopf.dataset.searchOpen = 'false';
          panel.inert = true;
          schliessen.forEach((knopf) => (knopf.tabIndex = -1));
          entsperren();
          ergebnisse.setAttribute('aria-busy', 'false');
          const nav = sortiment();
          if (nav) nav.inert = false;
          if (!fokus) return;
          // Auf der Startseite verschwindet die Pille wieder hinter der Lupe:
          // dann kehrt der Fokus dorthin zurück.
          if (input.getClientRects().length) feldFokus();
          else kopf?.querySelector('[data-kopf-lupe]')?.focus({ preventScroll: true });
        }

        // Ersetzt die Trefferliste. Stand der Fokus auf einem Treffer, rückt er
        // an dieselbe Stelle der neuen Liste (oder ins Feld) — sonst fiele er
        // mit dem entfernten Link auf <body>, und das Panel ginge zu.
        function zeigen(zeilen) {
          const stelle = [...treffer.querySelectorAll('a')].indexOf(document.activeElement);
          treffer.replaceChildren(...zeilen);
          if (stelle === -1) return;
          const neu = treffer.querySelectorAll('a');
          if (neu.length) neu[Math.min(stelle, neu.length - 1)].focus();
          else feldFokus();
        }

        function zeile(p, q) {
          const li = element('li');
          const a = element('a');
          a.href = pfad(p.url) || suchUrl(q);
          a.dataset.searchTerm = q;
          a.append(platte(p.featured_image?.url || p.image, 128));
          const txt = element('span', 'kopfsuche__treffer-text');
          if (text(p.vendor)) txt.append(element('span', 'kopfsuche__marke', text(p.vendor)));
          txt.append(element('span', 'kopfsuche__name', text(p.title)));
          a.append(txt);
          a.append(
            element('span', 'kopfsuche__preis', p.available === false ? status.dataset.ausverkauft : preis(p.price)),
          );
          li.append(a);
          return li;
        }

        function suchen() {
          abbrechen();
          // Erst wieder gesetzt, wenn die Treffer zu q vollständig dastehen.
          gezeigt = '';
          const q = input.value.trim();
          start.hidden = !!q;
          ergebnisse.hidden = !q;
          markenZeigen(q);
          if (q && !markenDaten && markenTreffer) {
            markenLaden(markenTreffer.dataset.quelle).then(() => {
              if (input.value.trim() === q) markenZeigen(q);
            });
          }
          if (!q) {
            zeigen([]);
            ergebnisse.setAttribute('aria-busy', 'false');
            einstieg();
            return;
          }
          status.textContent = status.dataset.loading;
          ergebnisse.setAttribute('aria-busy', 'true');
          warte = setTimeout(() => holen(q), PAUSE);
        }

        async function holen(q) {
          const aktiv = new AbortController();
          anfrage = aktiv;
          try {
            const basis = window.Shopify?.routes?.root || '/';
            const params = new URLSearchParams({
              q,
              'resources[type]': 'product',
              'resources[limit]': '6',
              'resources[options][unavailable_products]': 'last',
            });
            const antwort = await fetch(basis + 'search/suggest.json?' + params, { signal: aktiv.signal });
            if (!antwort.ok) throw new Error('suggest ' + antwort.status);
            const daten = await antwort.json();
            if (aktiv.signal.aborted || input.value.trim() !== q) return;
            // Lieferbares zuerst, sonst Shopifys Reihenfolge (stabile Sortierung).
            const produkte = [...(daten?.resources?.results?.products || [])].sort(
              (a, b) => (b.available !== false) - (a.available !== false),
            );
            zeigen(produkte.map((p) => zeile(p, q)));
            gezeigt = q;
            status.textContent = produkte.length ? status.dataset.products : status.dataset.empty;
          } catch (fehler) {
            if (fehler.name === 'AbortError') return;
            zeigen([]);
            status.textContent = status.dataset.error;
          } finally {
            if (anfrage === aktiv) ergebnisse.setAttribute('aria-busy', 'false');
          }
        }

        // Am Handy öffnet ein Tab ins Feld die Vollbild-Ebene nicht: sie sperrt
        // die Seite und blendet den Warenkorb aus, der in der Tab-Reihenfolge
        // danach kommt (zurück → Suche → Warenkorb). Tippen, Pfeil runter oder
        // ein Klick öffnen sie.
        let perTab = false;
        document.addEventListener('keydown', (e) => (perTab = e.key === 'Tab'), {
          capture: true,
          signal: abbruch.signal,
        });
        document.addEventListener('pointerdown', () => (perTab = false), { capture: true, signal: abbruch.signal });
        hoeren(input, 'focus', () => {
          if (perTab && handy.matches) return;
          oeffnen();
        });
        hoeren(input, 'click', () => oeffnen());
        hoeren(input, 'input', () => {
          oeffnen(false);
          leerenZeigen();
          suchen();
        });
        hoeren(form, 'submit', () => merken(input.value));
        // Am Handy per Finger: zu, ohne den Cursor zurück ins Feld zu setzen
        // (die Tastatur ginge sonst sofort wieder auf). Per Tastatur und am
        // Desktop: zurück ins Feld.
        schliessen.forEach((knopf) =>
          hoeren(knopf, 'click', (e) => {
            const zurueckInsFeld = e.detail === 0 || !handy.matches;
            zumachen(zurueckInsFeld);
            if (!zurueckInsFeld && form.contains(document.activeElement)) document.activeElement.blur();
          }),
        );
        if (leeren) {
          hoeren(leeren, 'click', () => {
            input.value = '';
            leerenZeigen();
            input.focus({ preventScroll: true });
            suchen();
          });
        }
        hoeren(window, 'resize', ebeneMessen);
        // Kam der Kopf gerade erst zurück (rollt herein), nach dem Einrollen nachmessen.
        const kopfBlock = form.closest('.shopify-section');
        if (kopfBlock) hoeren(kopfBlock, 'transitionend', (e) => e.target === kopfBlock && ebeneMessen());
        hoeren(handy, 'change', () => zumachen());
        // Zurück aus dem bfcache: nie mit offener Ebene und inerter Seite.
        hoeren(window, 'pageshow', (e) => {
          if (e.persisted) zumachen();
          leerenZeigen();
        });
        leerenZeigen();
        hoeren(form, 'click', (e) => {
          const begriff = e.target.closest('[data-search-term]');
          if (begriff) merken(begriff.dataset.searchTerm);
          if (e.target.closest('[data-search-clear]')) {
            schreiben(verlaufKey, []);
            // Andere Chip-Zeilen der Seite (snippets/such-chips.liquid) räumen mit.
            document.dispatchEvent(new CustomEvent('hervis:suchverlauf', { detail: { verlauf: [] } }));
            einstieg();
            input.focus({ preventScroll: true });
          }
        });
        hoeren(document, 'pointerdown', (e) => {
          if (!form.contains(e.target)) zumachen();
        });
        // Fokus verlässt die Suche → zu. Ohne relatedTarget (Fokus ins Leere,
        // Fenster verloren) erst nach dem Fokuswechsel nachsehen.
        hoeren(form, 'focusout', (e) => {
          if (e.relatedTarget) {
            if (!form.contains(e.relatedTarget)) zumachen();
            return;
          }
          setTimeout(() => {
            if (document.hasFocus() && !form.contains(document.activeElement)) zumachen();
          });
        });
        // Ein Klick auf die Pille neben dem Eingabefeld setzt den Cursor hinein.
        const feld = form.querySelector('.kopfsuche__feld');
        hoeren(feld, 'mousedown', (e) => {
          if (e.target !== feld) return;
          e.preventDefault();
          input.focus();
        });
        hoeren(form, 'keydown', (e) => {
          if (e.key === 'Escape' && form.dataset.open === 'true') {
            e.preventDefault();
            zumachen(true);
            return;
          }
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          oeffnen();
          const ziele = [...panel.querySelectorAll('a[href], button')].filter(
            (el) => el.getClientRects().length && !el.closest('[hidden]'),
          );
          const i = ziele.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') (ziele[i + 1] || input).focus();
          else (i === -1 ? ziele.at(-1) || input : ziele[i - 1] || input).focus();
        });
        steuerung.set(form, () => {
          abbrechen();
          entsperren();
          abbruch.abort();
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      steuerung.forEach((aufraeumen, form) => {
        if (e.target.contains(form)) {
          aufraeumen();
          steuerung.delete(form);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["landing-kopf"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('.landing-kopf')) return;
    const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Reiter: Pfeile und Ausblenden nur, wo die Spur wirklich weitergeht. */
    const messen = (reiter) => {
      const spur = reiter.querySelector('[data-reiter-spur]');
      if (!spur) return;
      const ende = spur.scrollWidth - spur.clientWidth;
      reiter.toggleAttribute('data-links', spur.scrollLeft > 1);
      reiter.toggleAttribute('data-rechts', spur.scrollLeft < ende - 1);
    };
    /* Der gewählte Reiter steht im Bild — auch wenn er weit rechts liegt. */
    const zeigen = (reiter) => {
      const spur = reiter.querySelector('[data-reiter-spur]');
      const aktiv = spur?.querySelector('[aria-current]');
      if (!spur || !aktiv) return;
      const s = spur.getBoundingClientRect();
      const a = aktiv.getBoundingClientRect();
      if (a.left < s.left || a.right > s.right) {
        spur.scrollLeft += a.left - s.left - (s.width - a.width) / 2;
      }
    };
    const alle = () =>
      document.querySelectorAll('[data-reiter]').forEach((reiter) => {
        zeigen(reiter);
        messen(reiter);
      });

    document.addEventListener(
      'scroll',
      (e) => {
        const reiter = e.target instanceof Element && e.target.closest('[data-reiter]');
        if (reiter) messen(reiter);
      },
      true,
    );
    window.addEventListener('resize', alle);
    /* Nach dem Filtern (snippets/filter-leiste.liquid) kommt der Kopf neu. */
    document.addEventListener('hervis:inhalt', alle);
    alle();

    document.addEventListener('click', (e) => {
      const pfeil = e.target.closest?.('[data-reiter-pfeil]');
      if (pfeil) {
        const spur = pfeil.closest('[data-reiter]')?.querySelector('[data-reiter-spur]');
        spur?.scrollBy({
          left: Number(pfeil.dataset.reiterPfeil) * spur.clientWidth * 0.7,
          behavior: ruhig() ? 'auto' : 'smooth',
        });
        return;
      }
      /* Sofort zeigen, was gewählt ist — die Liste lädt dahinter (Section
         Rendering) und bestätigt den Stand mit dem neuen Kopf. */
      const link = e.target.closest?.('[data-kopf-wahl] a');
      if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      link
        .closest('[data-kopf-wahl]')
        .querySelectorAll('[aria-current]')
        .forEach((alt) => alt.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'page');
    });

    /* Per Tab fokussierte Reiter ganz ins Bild holen (Chrome holt sie nur halb). */
    document.addEventListener('focusin', (e) => {
      const link = e.target.closest?.('.landing-kopf__reiter-link, .landing-kopf__unter-link');
      if (!link) return;
      link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: ruhig() ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marke-discover"] && !Shopify.designMode) return;
  try {
    (() => {
    const baender = document.querySelectorAll('[data-marke-discover]');
    if (!baender.length || !window.customElements) return;
    customElements.whenDefined('entdecken-feed').then(() => {
      baender.forEach((band) => {
        band.hidden = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('[data-menge]')) return;

    const zahl = (wert, ersatz) => {
      const n = Number.parseInt(wert, 10);
      return Number.isFinite(n) ? n : ersatz;
    };
    const grenzen = (feld) => ({
      min: zahl(feld.min, 0),
      max: feld.max === '' ? Infinity : zahl(feld.max, Infinity),
    });

    /* −/+ am Minimum bzw. Maximum ausgrauen (aria-disabled, Fokus bleibt). */
    const zustand = (feld) => {
      const box = feld.closest('[data-menge]');
      if (!box) return;
      const { min, max } = grenzen(feld);
      const wert = zahl(feld.value, min);
      box.querySelector('[data-menge-schritt="-1"]')?.setAttribute('aria-disabled', String(wert <= min));
      box.querySelector('[data-menge-schritt="1"]')?.setAttribute('aria-disabled', String(wert >= max));
    };

    document.addEventListener('click', (e) => {
      const knopf = e.target.closest('[data-menge-schritt]');
      if (!knopf) return;
      const feld = knopf.closest('[data-menge]')?.querySelector('input');
      if (!feld || knopf.getAttribute('aria-disabled') === 'true') return;
      const { min, max } = grenzen(feld);
      const alt = zahl(feld.value, min);
      const neu = Math.min(max, Math.max(min, alt + Number(knopf.dataset.mengeSchritt)));
      if (neu === alt) return;
      feld.value = String(neu);
      zustand(feld);
      feld.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('input', (e) => {
      if (e.target instanceof HTMLInputElement && e.target.closest('[data-menge]')) zustand(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["merkliste-abgleich"] && !Shopify.designMode) return;
  try {
    (() => {
    const marke = document.querySelector('[data-merkliste-abgleich]');
    if (!marke) return;
    let kunde = '';
    try {
      kunde = String(JSON.parse(marke.textContent).kunde || '');
    } catch {}

    const SCHLUESSEL = 'hervis-shop-merkliste';
    const INHALTE = 'hervis-shop-merkliste-inhalte';
    const BASIS = 'hervis-shop-merkliste-basis';
    const LISTEN = 'hervis-shop-listen';
    const AENDERUNGEN = 'hervis-shop-listen-aenderungen';
    const lesen = (schluessel, ersatz) => {
      try {
        return JSON.parse(localStorage.getItem(schluessel)) ?? ersatz;
      } catch {
        return ersatz;
      }
    };
    const schreiben = (schluessel, wert) => {
      try {
        if (wert === null) localStorage.removeItem(schluessel);
        else localStorage.setItem(schluessel, JSON.stringify(wert));
      } catch {}
    };
    const handles = () => {
      const liste = lesen(SCHLUESSEL, []);
      return Array.isArray(liste) ? liste.filter((h) => typeof h === 'string') : [];
    };
    const inhalte = () => {
      const wert = lesen(INHALTE, {});
      return wert && typeof wert === 'object' && !Array.isArray(wert) ? wert : {};
    };
    const aenderungen = () => {
      const wert = lesen(AENDERUNGEN, []);
      return Array.isArray(wert)
        ? wert.filter((a) => a && typeof a.liste === 'string' && typeof a.handle === 'string')
        : [];
    };

    /* Eigene Meldungen nicht als Änderung des Kunden lesen. */
    let eigen = false;
    const melden = () => {
      eigen = true;
      try {
        document.dispatchEvent(new CustomEvent('hervis:merkliste'));
      } finally {
        eigen = false;
      }
    };

    /* Abgemeldet: Liste, Listen und Basis eines Kontos bleiben nicht im Browser. */
    if (!kunde) {
      if (lesen(BASIS, null)) {
        for (const schluessel of [SCHLUESSEL, INHALTE, BASIS, LISTEN, AENDERUNGEN]) schreiben(schluessel, null);
        melden();
      }
      return;
    }

    const api = window.hervisApi;
    if (!api) return;

    /* ------------------------------------------------ Regeln der App */

    const istReserviert = (liste) => liste && (liste.reserved === true || liste.id === 'saved-for-later');
    const zielListe = (listen) =>
      listen.find((l) => l.pinned) ?? listen.find((l) => l.isDefault || l.name === 'Favoriten') ?? listen[0] ?? null;
    const preis = (cent) =>
      new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' }).format(Number(cent) / 100);
    const wurzel = window.Shopify?.routes?.root || '/';

    /* Web → App: die App braucht die Produkt-gid — die liefert
       /products/<handle>.js. Scheitert das, bleibt der Artikel diesmal
       draußen (er steht nicht in der Basis und kommt beim nächsten
       Abgleich wieder dran). */
    const appEintrag = async (handle, jetzt) => {
      try {
        const antwort = await fetch(`${wurzel}products/${encodeURIComponent(handle)}.js`, {
          headers: { accept: 'application/json' },
        });
        if (!antwort.ok) return null;
        const p = await antwort.json();
        if (!p || !p.id) return null;
        const bild = p.featured_image
          ? p.featured_image.startsWith('//')
            ? `https:${p.featured_image}`
            : p.featured_image
          : null;
        return {
          handle,
          id: `gid://shopify/Product/${p.id}`,
          name: p.title || handle,
          price: preis(p.price),
          compareAtPrice: p.compare_at_price > p.price ? preis(p.compare_at_price) : null,
          image: bild,
          addedAt: jetzt,
        };
      } catch {
        return null;
      }
    };

    /* App → Web: was die Merkliste zum Zeigen braucht. Vorhandene Einträge
       (mit Marke) gewinnen — die App-Liste kennt keine Marke. */
    const webInhalt = (eintrag, vorher) => ({
      title: (vorher && vorher.title) || eintrag.name || '',
      image: (vorher && vorher.image) || eintrag.image || '',
      url: (vorher && vorher.url) || `${wurzel}products/${eintrag.handle}`,
      vendor: (vorher && vorher.vendor) || '',
      preis: (vorher && vorher.preis) || eintrag.price || '',
    });

    /* Alle Artikel aller Listen, je Handle der zuletzt gemerkte. */
    const vereinigung = (listen) => {
      const alle = new Map();
      for (const liste of listen) {
        for (const eintrag of liste.items) {
          const vorher = alle.get(eintrag.handle);
          if (!vorher || (eintrag.addedAt || 0) > (vorher.addedAt || 0)) alle.set(eintrag.handle, eintrag);
        }
      }
      return alle;
    };

    /* --------------------------------------------------- Abgleich */

    const hinweisSetzen = (name) => {
      document.querySelectorAll('[data-merkliste-hinweis]').forEach((hinweis) => {
        const vorlage = hinweis.dataset.abgeglichen;
        if (vorlage) hinweis.textContent = vorlage.replace('%liste%', name || 'Favoriten');
      });
    };

    let laeuft = false;
    let nochmal = false;

    const abgleichen = async () => {
      if (laeuft) {
        nochmal = true;
        return;
      }
      laeuft = true;
      try {
        const daten = await api.lesen('/api/account/wishlist');
        if (!Array.isArray(daten?.wishlists)) return;
        const jetzt = Date.now();
        let listen = daten.wishlists
          .filter((l) => l && !istReserviert(l) && typeof l.id === 'string' && Array.isArray(l.items))
          .map((l) => ({ ...l, items: l.items.filter((i) => i && typeof i.handle === 'string') }));
        const lokal = handles();
        const offen = aenderungen();
        const basisRoh = lesen(BASIS, null);
        const basis = basisRoh && basisRoh.kunde === kunde && Array.isArray(basisRoh.handles) ? basisRoh.handles : null;

        let ziel = zielListe(listen);
        // Noch keine Liste im Konto und nichts zu bringen: nichts anlegen.
        if (!ziel && !lokal.length) {
          schreiben(BASIS, { kunde, handles: [] });
          schreiben(LISTEN, []);
          schreiben(AENDERUNGEN, null);
          hinweisSetzen('Favoriten');
          return;
        }
        let geaendert = false;
        if (!ziel) {
          ziel = {
            id: `wl_web_${jetzt.toString(36)}${Math.random().toString(36).slice(2, 6)}`,
            name: 'Favoriten',
            isDefault: true,
            createdAt: jetzt,
            updatedAt: jetzt,
            items: [],
          };
          listen = [...listen, ziel];
          geaendert = true;
        }
        const zielId = ziel.id;
        const listeAendern = (id, neu) => {
          listen = listen.map((l) => (l.id === id ? { ...l, items: neu(l.items), updatedAt: jetzt } : l));
          geaendert = true;
        };

        // 1) Entfernt in einer Liste (Blatt): nur dort.
        for (const { liste, handle } of offen) {
          const treffer = listen.find((l) => l.id === liste);
          if (treffer && treffer.items.some((i) => i.handle === handle)) {
            listeAendern(liste, (items) => items.filter((i) => i.handle !== handle));
          }
        }

        // 2) Herz an/aus seit der Basis. Ohne Basis: Vereinigung.
        const fern = vereinigung(listen);
        const hinzu = lokal.filter((h) => !fern.has(h) && !(basis && basis.includes(h)));
        const weg = basis ? basis.filter((h) => !lokal.includes(h) && fern.has(h)) : [];

        // Neueste zuerst wie in der App; das Web zählt neueste zuletzt.
        const neu = (await Promise.all([...hinzu].reverse().map((h, i) => appEintrag(h, jetzt - i)))).filter(Boolean);
        if (neu.length) {
          const neueHandles = new Set(neu.map((e) => e.handle));
          listeAendern(zielId, (items) => [...neu, ...items.filter((i) => !neueHandles.has(i.handle))]);
        }
        for (const liste of listen) {
          if (liste.items.some((i) => weg.includes(i.handle))) {
            listeAendern(liste.id, (items) => items.filter((i) => !weg.includes(i.handle)));
          }
        }

        if (geaendert) await api.schreiben('/api/account/wishlist', { wishlists: listen });
        // Geschrieben (oder nichts zu tun): die abgearbeiteten Einträge raus,
        // später dazugekommene bleiben stehen.
        schreiben(AENDERUNGEN, aenderungen().slice(offen.length));

        // Das Web übernimmt die Listen der App — plus, was diesmal nicht hinüberging.
        const alle = vereinigung(listen);
        const sortiert = [...alle.values()].sort((a, b) => (a.addedAt || 0) - (b.addedAt || 0)).map((i) => i.handle);
        const nichtGesendet = hinzu.filter((h) => !neu.some((e) => e.handle === h));
        let ergebnis = [...sortiert, ...nichtGesendet];

        // Hat der Kunde WÄHREND des Abgleichs gemerkt oder entfernt, gilt seine
        // Änderung obendrauf — und ein zweiter Lauf bringt sie in die App.
        const aktuell = handles();
        const dazu = aktuell.filter((h) => !lokal.includes(h));
        const raus = lokal.filter((h) => !aktuell.includes(h));
        ergebnis = ergebnis.filter((h) => !raus.includes(h));
        for (const h of dazu) if (!ergebnis.includes(h)) ergebnis.push(h);
        if (dazu.length || raus.length || aenderungen().length) nochmal = true;

        const vorher = inhalte();
        const nachher = {};
        for (const h of sortiert) nachher[h] = webInhalt(alle.get(h), vorher[h]);
        for (const h of [...nichtGesendet, ...dazu]) if (vorher[h]) nachher[h] = vorher[h];
        for (const h of raus) delete nachher[h];

        const listenVorher = JSON.stringify(lesen(LISTEN, []));
        const listenNachher = listen.map((l) => ({
          id: l.id,
          name: typeof l.name === 'string' ? l.name : '',
          emoji: typeof l.emoji === 'string' ? l.emoji : '',
          ziel: l.id === zielId,
          handles: l.items.map((i) => i.handle).filter((h) => !raus.includes(h)),
        }));

        const anders =
          JSON.stringify(ergebnis) !== JSON.stringify(aktuell) ||
          JSON.stringify(nachher) !== JSON.stringify(vorher) ||
          JSON.stringify(listenNachher) !== listenVorher;
        schreiben(SCHLUESSEL, ergebnis);
        schreiben(INHALTE, nachher);
        schreiben(LISTEN, listenNachher);
        schreiben(BASIS, { kunde, handles: sortiert });
        hinweisSetzen(listen.find((l) => l.id === zielId)?.name);
        if (anders) melden();
      } catch {
        // Backend weg oder Störung: die Merkliste bleibt lokal, der nächste
        // Abgleich holt nach (Basis und offene Änderungen sind unverändert).
      } finally {
        laeuft = false;
        if (nochmal) {
          nochmal = false;
          planen();
        }
      }
    };

    let timer = null;
    const planen = () => {
      clearTimeout(timer);
      timer = setTimeout(abgleichen, 800);
    };

    document.addEventListener('hervis:merkliste', () => {
      if (!eigen) planen();
    });
    // Zurück auf einen Tab: die App kann inzwischen etwas geändert haben.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') planen();
    });
    abgleichen();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["merkliste-reihe"] && !Shopify.designMode) return;
  try {
    (() => {
    const SCHLUESSEL = 'hervis-shop-merkliste';
    const INHALTE = 'hervis-shop-merkliste-inhalte';
    const HOECHSTENS = 12;

    function lesen(schluessel, ersatz) {
      try {
        const wert = JSON.parse(localStorage.getItem(schluessel));
        return wert ?? ersatz;
      } catch {
        return ersatz;
      }
    }
    const text = (wert) => (typeof wert === 'string' ? wert.trim() : '');
    // Nur Pfade dieses Shops, nie fremde Ziele aus dem Speicher.
    const pfad = (url) => (typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') ? url : '');
    // Shopify-CDN skaliert über ?width= — daraus wird das srcset.
    function bild(src, breite) {
      try {
        const url = new URL(src, location.href);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
        url.searchParams.set('width', breite);
        return url.href;
      } catch {
        return '';
      }
    }

    function eintraege() {
      const handles = lesen(SCHLUESSEL, []);
      const inhalte = lesen(INHALTE, {});
      if (!Array.isArray(handles) || typeof inhalte !== 'object' || !inhalte) return [];
      const liste = [];
      for (const handle of [...handles].reverse()) {
        if (liste.length >= HOECHSTENS) break;
        const eintrag = inhalte[handle];
        if (typeof handle !== 'string' || !eintrag || typeof eintrag !== 'object') continue;
        if (!pfad(eintrag.url) || !text(eintrag.title)) continue;
        liste.push({ handle, ...eintrag });
      }
      return liste;
    }

    function karte(eintrag, root, herz) {
      const marke = text(eintrag.vendor || eintrag.brand);
      const name = [marke, text(eintrag.title)].filter(Boolean).join(' ');
      const li = document.createElement('li');
      const article = document.createElement('article');
      article.className = 'sortiment-karte';
      const link = document.createElement('a');
      link.className = 'sortiment-karte__link';
      link.href = pfad(eintrag.url);
      const platte = document.createElement('div');
      platte.className = 'produkt-platte';
      if (text(eintrag.image) && bild(eintrag.image, 400)) {
        const img = document.createElement('img');
        img.src = bild(eintrag.image, 400);
        img.srcset = [200, 300, 400, 600].map((b) => `${bild(eintrag.image, b)} ${b}w`).join(', ');
        img.sizes = root.dataset.sizes;
        img.alt = name;
        img.loading = 'lazy';
        img.width = 600;
        img.height = 600;
        platte.append(img);
      }
      link.append(platte);
      if (marke) {
        const p = document.createElement('p');
        p.className = 'sortiment-karte__marke';
        p.textContent = marke;
        link.append(p);
      }
      const titel = document.createElement('h3');
      titel.className = 'sortiment-karte__name';
      titel.textContent = text(eintrag.title);
      link.append(titel);
      if (text(eintrag.preis)) {
        const preis = document.createElement('p');
        preis.className = 'sortiment-karte__preis zahl';
        preis.textContent = text(eintrag.preis);
        link.append(preis);
      }
      article.append(link);

      const knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'produkt-platte__herz';
      knopf.dataset.merken = eintrag.handle;
      knopf.dataset.title = text(eintrag.title);
      knopf.dataset.url = pfad(eintrag.url);
      if (text(eintrag.image)) knopf.dataset.image = text(eintrag.image);
      knopf.dataset.vendor = marke;
      knopf.dataset.preis = text(eintrag.preis);
      knopf.setAttribute('aria-pressed', 'true');
      knopf.setAttribute('aria-label', root.dataset.merkenLabel.replace('[titel]', name));
      if (herz) knopf.append(herz.content.cloneNode(true));
      article.append(knopf);
      li.append(article);
      return li;
    }

    function fuellen(root) {
      const spur = root.querySelector('[data-merkliste-spur]');
      if (!spur) return;
      const herz = root.querySelector('template[data-merkliste-herz]');
      const liste = eintraege();
      spur.replaceChildren(...liste.map((e) => karte(e, root, herz)));
      root.dataset.handles = liste.map((e) => e.handle).join(' ');
      root.hidden = liste.length === 0;
      const alle = root.querySelector('.merkliste-reihe__alle');
      if (alle) alle.hidden = !document.getElementById('merkliste');
      if (liste.length) document.dispatchEvent(new CustomEvent('hervis:inhalt'));
    }

    // Neu aufbauen nur, wenn etwas dazukam — Entferntes bleibt stehen.
    function aktualisieren(root) {
      const gezeigt = new Set((root.dataset.handles || '').split(' ').filter(Boolean));
      if (eintraege().some((e) => !gezeigt.has(e.handle))) fuellen(root);
    }

    function init(bereich) {
      bereich.querySelectorAll('[data-merkliste-reihe]').forEach(fuellen);
    }
    if (window.Shopify?.designMode) document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (!document.querySelector('[data-merkliste-reihe]')) return;
    init(document);
    const nachziehen = () => document.querySelectorAll('[data-merkliste-reihe]').forEach(aktualisieren);
    document.addEventListener('hervis:merkliste', nachziehen);
    window.addEventListener('storage', (e) => {
      if (e.key === SCHLUESSEL || e.key === INHALTE) nachziehen();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mitgliedskarte"] && !Shopify.designMode) return;
  try {
    (() => {
    // „Karte drucken": nur dieser eine Druck zeigt allein die Karte
    // (CSS @media print oben); Strg+P druckt weiter die ganze Seite.
    if (!document.querySelector('[data-karte-drucken]')) return;
    const wurzel = document.documentElement;
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-karte-drucken]')) return;
      wurzel.dataset.druck = 'karte';
      window.print();
    });
    window.addEventListener('afterprint', () => {
      delete wurzel.dataset.druck;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["produkt-galerie"] && !Shopify.designMode) return;
  try {
    (() => {
    const galerien = document.querySelectorAll('[data-galerie]');
    if (!galerien.length) return;

    galerien.forEach((galerie) => {
      const spur = galerie.querySelector('[data-galerie-spur]');
      if (!spur) return;
      const bilder = [...spur.children];
      const knoepfe = [...galerie.querySelectorAll('[data-galerie-ziel]')];
      const vorlage = galerie.dataset.bildN || '';
      const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const sichtbar = () => bilder.filter((bild) => !bild.hidden);

      // Welches Bild steht gerade in der Spur? Das sichtbare, dessen linke
      // Kante der Scrollposition am nächsten liegt.
      const aktuell = () => {
        const liste = sichtbar();
        const links = spur.scrollLeft;
        let beste = 0;
        let abstand = Infinity;
        liste.forEach((bild, i) => {
          const d = Math.abs(bild.offsetLeft - links);
          if (d < abstand) {
            abstand = d;
            beste = i;
          }
        });
        return liste[beste];
      };

      const markieren = () => {
        const bild = aktuell();
        const index = bilder.indexOf(bild);
        knoepfe.forEach((knopf) => {
          knopf.setAttribute('aria-current', String(Number(knopf.dataset.galerieZiel) === index));
        });
      };

      const zeigen = (index, sanft = true) => {
        const bild = bilder[index];
        if (!bild || bild.hidden) return;
        spur.scrollTo({ left: bild.offsetLeft, behavior: sanft && !ruhig() ? 'smooth' : 'auto' });
      };

      galerie.addEventListener('click', (event) => {
        const knopf = event.target.closest('[data-galerie-ziel]');
        if (!knopf) return;
        zeigen(Number(knopf.dataset.galerieZiel));
      });

      let bildchen;
      spur.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(bildchen);
          bildchen = requestAnimationFrame(markieren);
        },
        { passive: true },
      );

      // Farbwechsel: nur Bilder dieser Farbe, sonst alle; zurück auf Bild 1.
      galerie.addEventListener('galerie:farbe', (event) => {
        const farbe = String(event.detail?.farbe || '')
          .trim()
          .toLowerCase();
        const passend = farbe ? bilder.filter((bild) => bild.dataset.farbe === farbe) : [];
        const zeigeAlle = passend.length === 0;
        bilder.forEach((bild) => {
          bild.hidden = !zeigeAlle && !passend.includes(bild);
        });
        const liste = sichtbar();
        knoepfe.forEach((knopf) => {
          const bild = bilder[Number(knopf.dataset.galerieZiel)];
          knopf.hidden = !bild || bild.hidden;
          const n = liste.indexOf(bild) + 1;
          if (n > 0) {
            knopf.setAttribute(
              'aria-label',
              vorlage.replace('[n]', String(n)).replace('[gesamt]', String(liste.length)),
            );
          }
        });
        galerie
          .querySelectorAll('[data-galerie-punkte], [data-galerie-vorschau]')
          .forEach((leiste) => (leiste.hidden = liste.length < 2));
        // Das erste sichtbare Bild darf nicht faul laden — es steht sofort da.
        liste[0]?.querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
        spur.scrollTo({ left: 0, behavior: 'auto' });
        markieren();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["produkt-optionen"] && !Shopify.designMode) return;
  try {
    (() => {
    const wurzeln = document.querySelectorAll('[data-optionen]');
    if (!wurzeln.length) return;

    wurzeln.forEach((wurzel) => {
      let varianten = [];
      try {
        varianten = JSON.parse(wurzel.querySelector('[data-varianten]')?.textContent || '[]');
      } catch {
        return;
      }
      if (!varianten.length) return;
      const anzahl = varianten[0].options.length;
      const farbPosition = Number(wurzel.dataset.farbPosition) || 0;

      const feld = (position) =>
        wurzel.querySelector(
          `input[type="radio"][data-option="${position}"]:checked, input[type="hidden"][data-option="${position}"]`,
        );
      const auswahl = () => Array.from({ length: anzahl }, (_, i) => feld(i + 1)?.value ?? null);
      const finde = (werte) => varianten.find((v) => v.options.every((o, i) => o === werte[i])) || null;

      // Ausverkauft-Marken für jede Chip-Gruppe — gemessen an der Wahl der
      // übrigen Optionen (z. B. Größe in der gewählten Farbe).
      const markieren = (werte) => {
        wurzel.querySelectorAll('.groessen').forEach((gruppe) => {
          const position = Number(gruppe.dataset.optionGruppe);
          gruppe.querySelectorAll('input[data-option]').forEach((input) => {
            const probe = werte.slice();
            probe[position - 1] = input.value;
            const variante = finde(probe);
            const leer = !variante || !variante.available;
            const chip = input.closest('.groesse');
            chip.classList.toggle('groesse--leer', leer);
            const text = chip.querySelector('[data-leer-text]');
            if (text) text.hidden = !leer;
          });
        });
      };

      let letzteFarbe = farbPosition ? auswahl()[farbPosition - 1] : '';

      wurzel.addEventListener('change', (event) => {
        const input = event.target.closest('input[data-option]');
        if (!input) return;
        const position = Number(input.dataset.option);
        let werte = auswahl();
        let variante = finde(werte);

        // Neue Farbe ohne die gewählte Größe: die erste verfügbare Größe dieser
        // Farbe nehmen (App: Standard = erste Größe auf Lager). Eine Größe, die
        // man selbst anklickt, bleibt dagegen gewählt — auch wenn sie leer ist.
        if (position === farbPosition && (!variante || !variante.available)) {
          const treffer = (v) =>
            v.options.reduce((summe, o, i) => summe + (i !== position - 1 && o === werte[i] ? 1 : 0), 0);
          const beste = varianten
            .filter((v) => v.available && v.options[position - 1] === input.value)
            .sort((a, b) => treffer(b) - treffer(a))[0];
          if (beste) {
            beste.options.forEach((wert, i) => {
              const radio = [...wurzel.querySelectorAll(`input[type="radio"][data-option="${i + 1}"]`)].find(
                (r) => r.value === wert,
              );
              if (radio) radio.checked = true;
            });
            werte = auswahl();
            variante = finde(werte);
          }
        }

        const farbe = farbPosition ? werte[farbPosition - 1] : '';
        if (farbPosition) {
          const anzeige = wurzel.querySelector('[data-farbwert]');
          if (anzeige) anzeige.textContent = farbe;
        }
        markieren(werte);
        wurzel.dispatchEvent(
          new CustomEvent('produkt:variante', {
            bubbles: true,
            detail: { variante, farbe, farbe_neu: farbe !== letzteFarbe },
          }),
        );
        letzteFarbe = farbe;
      });

      markieren(auswahl());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["produkt-reihe"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('produkt-reihe')) return;

    // Blätterpfeile einer Produktreihe: ein Klick schiebt um 90 % der
    // sichtbaren Breite; am Anfang und Ende ist der Pfeil ausgegraut
    // (aria-disabled statt disabled, damit der Fokus auf dem Knopf bleibt).
    class ProduktReihe extends HTMLElement {
      connectedCallback() {
        this.spur = this.querySelector('.produkt-reihe__spur');
        this.knoepfe = [...this.querySelectorAll('[data-reihe-richtung]')];
        if (!this.spur || this.beobachter) return;

        this.onKlick = (event) => {
          const knopf = event.target.closest('[data-reihe-richtung]');
          if (!knopf || knopf.getAttribute('aria-disabled') === 'true') return;
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.spur.scrollBy({
            left: Number(knopf.dataset.reiheRichtung) * this.spur.clientWidth * 0.9,
            behavior: ruhig ? 'auto' : 'smooth',
          });
        };
        this.onScroll = () => {
          cancelAnimationFrame(this.bild);
          this.bild = requestAnimationFrame(() => this.aktualisieren());
        };

        this.addEventListener('click', this.onKlick);
        this.spur.addEventListener('scroll', this.onScroll, { passive: true });
        this.beobachter = new ResizeObserver(() => this.aktualisieren());
        this.beobachter.observe(this.spur);
        this.aktualisieren();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onKlick);
        this.spur?.removeEventListener('scroll', this.onScroll);
        this.beobachter?.disconnect();
        this.beobachter = null;
        cancelAnimationFrame(this.bild);
      }

      aktualisieren() {
        const { scrollLeft, scrollWidth, clientWidth } = this.spur;
        const ende = scrollWidth - clientWidth;
        this.toggleAttribute('data-ueberlauf', ende > 1);
        this.knoepfe.forEach((knopf) => {
          const zurueck = Number(knopf.dataset.reiheRichtung) < 0;
          const amEnde = zurueck ? scrollLeft <= 1 : scrollLeft >= ende - 1;
          knopf.setAttribute('aria-disabled', String(amEnde));
        });
      }
    }

    customElements.define('produkt-reihe', ProduktReihe);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-einstieg"] && !Shopify.designMode) return;
  try {
    (() => {
    // Merkt sich den gewählten Reiter in diesem Browser (wie die App ihre
    // Anrede). Ohne JS oder Speicher bleibt „Alle" bzw. die Vorgabe.
    const SCHLUESSEL = 'hervis-shop-zielgruppe';
    const WERTE = ['alle', 'damen', 'herren', 'kinder'];

    function lesen() {
      try {
        return localStorage.getItem(SCHLUESSEL);
      } catch {
        return null;
      }
    }

    function init(bereich) {
      bereich.querySelectorAll('[data-shop-einstieg]:not([data-bereit])').forEach((wurzel) => {
        wurzel.setAttribute('data-bereit', '');
        const wert = lesen();
        if (!wurzel.hasAttribute('data-vorgabe') && WERTE.includes(wert)) {
          const feld = wurzel.querySelector(`.shop-einstieg__reiter input[value="${wert}"]`);
          if (feld) feld.checked = true;
        }
        wurzel.addEventListener('change', (event) => {
          const feld = event.target.closest('.shop-einstieg__reiter input');
          if (!feld) return;
          try {
            localStorage.setItem(SCHLUESSEL, feld.value);
          } catch {}
        });
      });
    }

    if (window.Shopify?.designMode) document.addEventListener('shopify:section:load', (e) => init(e.target));
    init(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["such-chips"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'hervis-shop-suchverlauf';
    const PLATZ = '__BEGRIFF__';
    const MAX = 6;

    const sauber = (liste) =>
      liste
        .filter((s) => typeof s === 'string' && s.trim())
        .map((s) => s.trim())
        .filter((s, i, alle) => alle.indexOf(s) === i)
        .slice(0, MAX);
    function lesen() {
      try {
        const wert = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(wert) ? sauber(wert) : [];
      } catch {
        return [];
      }
    }
    function schreiben(liste) {
      try {
        localStorage.setItem(KEY, JSON.stringify(liste));
      } catch {}
    }
    const fuellen = (vorlage, begriff) => (vorlage || '').split(PLATZ).join(begriff);

    // Zeichnet die letzten Suchen vor die beliebten. Idempotent: alte
    // Verlaufs-Chips fliegen erst raus.
    function zeichnen(box, verlauf) {
      const liste = box.querySelector('[data-such-chips-liste]');
      const vorlage = box.querySelector('[data-such-chips-vorlage]');
      if (!liste || !vorlage?.content.firstElementChild) return;
      // Stand die Zeile am Anfang, bleibt sie dort: sonst rastet der Scroller
      // wieder auf die alte erste Chip ein, und die neuen stünden links außen.
      const amAnfang = Math.abs(liste.scrollLeft) <= 1;
      liste.querySelectorAll('[data-such-chips-verlauf]').forEach((li) => li.remove());
      const basis = box.dataset.suchUrl || '/search';
      const stueck = document.createDocumentFragment();
      for (const begriff of verlauf) {
        const li = vorlage.content.firstElementChild.cloneNode(true);
        const a = li.querySelector('a');
        const weg = li.querySelector('[data-such-chips-weg]');
        const textEl = li.querySelector('[data-such-chips-text]');
        if (!a || !weg || !textEl) continue;
        a.href = basis + '?q=' + encodeURIComponent(begriff) + '&type=product';
        a.dataset.searchTerm = begriff;
        a.setAttribute('aria-label', fuellen(box.dataset.verlaufLink, begriff));
        textEl.textContent = begriff;
        weg.dataset.begriff = begriff;
        weg.setAttribute('aria-label', fuellen(box.dataset.verlaufEntfernen, begriff));
        stueck.append(li);
      }
      liste.prepend(stueck);
      if (amAnfang) liste.scrollLeft = 0;
    }
    function alle() {
      const verlauf = lesen();
      document.querySelectorAll('[data-such-chips]').forEach((box) => zeichnen(box, verlauf));
    }

    document.addEventListener('click', (e) => {
      const weg = e.target.closest?.('[data-such-chips] [data-such-chips-weg]');
      if (weg) {
        e.preventDefault();
        const box = weg.closest('[data-such-chips]');
        const liste = box.querySelector('[data-such-chips-liste]');
        const stelle = [...liste.children].indexOf(weg.closest('li'));
        const verlauf = lesen().filter((s) => s !== weg.dataset.begriff);
        schreiben(verlauf);
        document.dispatchEvent(new CustomEvent('hervis:suchverlauf', { detail: { verlauf } }));
        // Fokus: auf die Chip, die nachrückt, sonst die davor, sonst die erste.
        const eintraege = liste.children;
        const ziel = eintraege[stelle] || eintraege[stelle - 1] || eintraege[0];
        ziel?.querySelector('a')?.focus();
        return;
      }
      // Ein Tipp auf eine Chip ist eine Suche: sie rückt im Verlauf nach vorn.
      const chip = e.target.closest?.('[data-such-chips] a[data-search-term]');
      if (chip) {
        const q = chip.dataset.searchTerm.trim();
        if (q) schreiben([q, ...lesen().filter((s) => s !== q)].slice(0, MAX));
      }
    });
    document.addEventListener('hervis:suchverlauf', alle);
    document.addEventListener('hervis:inhalt', alle);
    document.addEventListener('shopify:section:load', alle);
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) alle();
    });
    window.addEventListener('storage', (e) => {
      if (e.key === KEY || e.key === null) alle();
    });
    alle();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zuletzt-angesehen"] && !Shopify.designMode) return;
  try {
    (() => {
    const schluessel = 'hervis-shop-zuletzt';

    function lesen() {
      try {
        const wert = JSON.parse(localStorage.getItem(schluessel));
        return Array.isArray(wert) ? wert : [];
      } catch {
        return [];
      }
    }
    const text = (wert) => (typeof wert === 'string' ? wert.trim() : '');
    // Nur Pfade dieses Shops, nie fremde Ziele aus dem Speicher.
    const pfad = (url) => (typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') ? url : '');
    function handle(eintrag) {
      if (text(eintrag.handle)) return text(eintrag.handle);
      const treffer = /\/products\/([^/?#]+)/.exec(pfad(eintrag.url));
      return treffer ? decodeURIComponent(treffer[1]) : '';
    }
    // Shopify-CDN skaliert über ?width= — daraus wird das srcset.
    function bild(src, breite) {
      try {
        const url = new URL(src, location.href);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
        url.searchParams.set('width', breite);
        return url.href;
      } catch {
        return '';
      }
    }

    function karte(eintrag, root, herz) {
      const name = [text(eintrag.vendor || eintrag.brand), text(eintrag.title)].filter(Boolean).join(' ');
      const li = document.createElement('li');
      const article = document.createElement('article');
      article.className = 'sortiment-karte';
      const link = document.createElement('a');
      link.className = 'sortiment-karte__link';
      link.href = pfad(eintrag.url);
      const platte = document.createElement('div');
      platte.className = 'produkt-platte';
      if (text(eintrag.image) && bild(eintrag.image, 400)) {
        const img = document.createElement('img');
        img.src = bild(eintrag.image, 400);
        img.srcset = [200, 300, 400, 600].map((b) => `${bild(eintrag.image, b)} ${b}w`).join(', ');
        img.sizes = root.dataset.sizes;
        img.alt = name;
        img.loading = 'lazy';
        img.width = 600;
        img.height = 600;
        platte.append(img);
      }
      link.append(platte);
      if (text(eintrag.vendor || eintrag.brand)) {
        const marke = document.createElement('p');
        marke.className = 'sortiment-karte__marke';
        marke.textContent = text(eintrag.vendor || eintrag.brand);
        link.append(marke);
      }
      const titel = document.createElement('h3');
      titel.className = 'sortiment-karte__name';
      titel.textContent = text(eintrag.title);
      link.append(titel);
      if (text(eintrag.preis)) {
        const preis = document.createElement('p');
        preis.className = 'sortiment-karte__preis zahl';
        preis.textContent = text(eintrag.preis);
        link.append(preis);
      }
      article.append(link);

      const knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'produkt-platte__herz';
      knopf.dataset.merken = handle(eintrag);
      knopf.dataset.title = text(eintrag.title);
      knopf.dataset.url = pfad(eintrag.url);
      if (text(eintrag.image)) knopf.dataset.image = bild(eintrag.image, 400);
      knopf.dataset.vendor = text(eintrag.vendor || eintrag.brand);
      knopf.dataset.preis = text(eintrag.preis);
      knopf.setAttribute('aria-pressed', 'false');
      knopf.setAttribute('aria-label', root.dataset.merkenLabel.replace('[titel]', name));
      if (herz) knopf.append(herz.content.cloneNode(true));
      article.append(knopf);
      li.append(article);
      return li;
    }

    function fuellen(root) {
      const spur = root.querySelector('[data-zuletzt-spur]');
      if (!spur) return;
      const herz = root.querySelector('template[data-zuletzt-herz]');
      const ausschluss = root.dataset.ausschluss;
      const anzahl = Number(root.dataset.anzahl) || 12;
      const gesehen = new Set();
      const karten = [];
      for (const eintrag of lesen()) {
        if (karten.length >= anzahl) break;
        if (!eintrag || typeof eintrag !== 'object') continue;
        const h = handle(eintrag);
        if (!h || !pfad(eintrag.url) || !text(eintrag.title) || gesehen.has(h) || h === ausschluss) continue;
        gesehen.add(h);
        karten.push(karte(eintrag, root, herz));
      }
      spur.replaceChildren(...karten);
      root.hidden = karten.length === 0;
      if (karten.length) document.dispatchEvent(new CustomEvent('hervis:inhalt'));
    }

    // Produktseite: das offene Produkt vorne einreihen (ohne Doppel, max. 12).
    function aufzeichnen(quelle) {
      const d = quelle.dataset;
      const eintrag = {
        handle: text(d.handle),
        id: text(d.id),
        url: pfad(d.url),
        title: text(d.title),
        vendor: text(d.vendor),
        image: text(d.image),
        preis: text(d.preis),
      };
      if (!eintrag.handle || !eintrag.url || !eintrag.title) return;
      const rest = lesen().filter((e) => e && typeof e === 'object' && handle(e) !== eintrag.handle);
      try {
        localStorage.setItem(schluessel, JSON.stringify([eintrag, ...rest].slice(0, 12)));
      } catch {}
    }

    function init(bereich) {
      bereich.querySelectorAll('[data-zuletzt]').forEach(fuellen);
    }
    if (window.Shopify?.designMode) document.addEventListener('shopify:section:load', (e) => init(e.target));
    const quelle = document.querySelector('[data-zuletzt-aufzeichnen]');
    if (!quelle && !document.querySelector('[data-zuletzt]')) return;
    const auffrischen = () => {
      if (quelle) aufzeichnen(quelle);
      init(document);
    };
    auffrischen();
    // Zurück aus dem bfcache: die Seite kommt eingefroren wieder, ohne dass
    // dieses Skript neu läuft — sonst fehlte das eben angesehene Produkt.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) auffrischen();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
